var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
(function () {
    angular.module('QMC.Fachleistung', ['QMC.Klient', 'QMC.Home']).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProviderr, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('case', {
            url: '/fls/case',
            templateUrl: qmcBase + '/fls/Case',
            controller: 'FlsCaseController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Case List');
                    }]
            }
        })
            .state('companion', {
            url: '/fls/companion',
            templateUrl: qmcBase + '/fls/Companion',
            controller: 'FlsCompanionController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Companion');
                    }]
            }
        })
            .state('documentation', {
            url: '/fls/documentation',
            templateUrl: qmcBase + '/fls/DocumentationList',
            controller: 'FlsDocumentationListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Documentation List');
                    }]
            }
        })
            .state('documentationdetail', {
            url: '/fls/documentation/:id',
            templateUrl: qmcBase + '/fls/Documentation',
            controller: 'FlsDocumentationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Documentation Detail');
                    }]
            }
        })
            .state('documentationnew', {
            url: '/fls/documentation/new/:flsCaseIds?:plannedDocumentationId',
            templateUrl: qmcBase + '/fls/Documentation',
            controller: 'FlsDocumentationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Documentation New');
                    }]
            }
        })
            .state('planedDocumenation', {
            url: '/fls/case/PlanedDocumentation',
            templateUrl: qmcBase + '/fls/PlanedDocumentation',
            controller: 'FlsPlanedRawListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Planed Documentation');
                    }]
            }
        })
            .state('rawDocumentation', {
            url: '/fls/case/RawDocumentation',
            templateUrl: qmcBase + '/fls/RawDocumentation',
            controller: 'FlsPlanedRawListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Raw Documentation');
                    }]
            }
        })
            .state('documentationEndingConfirmation', {
            url: '/fls/documentationEndingConfirmation',
            templateUrl: qmcBase + '/fls/documentationEndingConfirmation',
            controller: 'FlsDocumentationEndingConfirmationController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Confirm Documentation Ending');
                    }]
            }
        })
            .state('signature', {
            url: '/fls/signature?:page',
            templateUrl: qmcBase + '/fls/SignatureList',
            controller: 'FlsSignatureListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Signature List');
                    }]
            }
        })
            .state('signaturedetail', {
            url: '/fls/signature/:id',
            templateUrl: qmcBase + '/fls/SignatureList',
            controller: 'FlsSignatureListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Signature List for id');
                    }]
            }
        })
            .state('weekplanner', {
            url: '/fls/weekplanner?:startDay?view',
            templateUrl: qmcBase + '/fls/WeekplannerList',
            controller: 'FlsWeekplannerListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Weekplanner List');
                    }]
            },
            params: {
                startDay: {
                    dynamic: true
                },
                view: {
                    dynamic: true
                }
            }
        })
            .state('summary', {
            url: '/fls/summary',
            templateUrl: qmcBase + '/fls/Summary',
            controller: 'FlsSummaryController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: FLS Summary');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        Fachleistung.HttpProvider = HttpProvider;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Fachleistung')
        .config(['$httpProvider', QMC.Fachleistung.HttpProvider.configureHttpProvider]);
})();
// namespace FullCalendar {
//     // ReSharper disable once InconsistentNaming
//     export interface EventObject {
//         type: string;
//     }
// }
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsService = /** @class */ (function (_super) {
            __extends(FlsService, _super);
            function FlsService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Fachleistung';
                return _this;
            }
            /***** Case *****/
            FlsService.prototype.getCarerList = function () {
                return _super.prototype.get.call(this, '/Person/Carer', {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getCarerListForCase = function (caseId, addTheLoggedUser) {
                if (caseId === void 0) { caseId = QMC.Common.Constants.GUID_EMPTY; }
                if (addTheLoggedUser === void 0) { addTheLoggedUser = false; }
                return _super.prototype.get.call(this, this.modulePath + '/Case/Carer/' + caseId, { addTheLoggedUser: addTheLoggedUser }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getCasesListByViewPermission = function (currentOnly, onlyActive) {
                if (currentOnly === void 0) { currentOnly = false; }
                if (onlyActive === void 0) { onlyActive = true; }
                return _super.prototype.get.call(this, this.modulePath + '/Case/Viewable', { currentOnly: currentOnly, onlyActive: onlyActive }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getCasesList = function (carerTypeFilterId, currentOnly, carerId, onlyForDisplay) {
                if (currentOnly === void 0) { currentOnly = false; }
                if (carerId === void 0) { carerId = undefined; }
                if (onlyForDisplay === void 0) { onlyForDisplay = false; }
                var additionalParams = "?currentOnly=" + currentOnly;
                if (carerTypeFilterId !== undefined && carerTypeFilterId !== null && carerTypeFilterId !== "")
                    additionalParams += "&carerTypeFilterId=" + carerTypeFilterId;
                additionalParams += "&onlyForDisplay=" + onlyForDisplay;
                return _super.prototype.get.call(this, this.modulePath + '/Case' + additionalParams, { page: -1, pageSize: -1, carerId: carerId }, function (data) {
                    return data.items;
                });
            };
            FlsService.prototype.getCasesListPaginated = function (carerTypeFilterId, page, pageSize, currentOnly, listSearch, carerId, searchProperties) {
                if (page === void 0) { page = -1; }
                if (pageSize === void 0) { pageSize = -1; }
                if (currentOnly === void 0) { currentOnly = false; }
                if (listSearch === void 0) { listSearch = ""; }
                if (carerId === void 0) { carerId = null; }
                if (searchProperties === void 0) { searchProperties = []; }
                var additionalParams = "?currentOnly=" + currentOnly;
                if (carerTypeFilterId !== undefined && carerTypeFilterId !== null && carerTypeFilterId !== "")
                    additionalParams += "&carerTypeFilterId=" + carerTypeFilterId;
                return _super.prototype.getItem.call(this, this.modulePath + '/Case' + additionalParams, { page: page, pageSize: pageSize, listSearch: listSearch, carerId: carerId, searchProperties: searchProperties }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getFlsCase = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Case/' + id, {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getFlsCases = function (ids) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Case/Multiple', { ids: ids }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getFlsCaseWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Case/WvModel', {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getFlsCasePaused = function (caseIds) {
                return _super.prototype.get.call(this, this.modulePath + '/Case/Paused', { caseIds: caseIds }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getPlannedDocumentations = function (days, daysFuture) {
                return _super.prototype.get.call(this, this.modulePath + '/Documentation/PlanedDocumentations', { days: days, daysFuture: daysFuture }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getRawDocumentations = function (days) {
                return _super.prototype.get.call(this, this.modulePath + '/Documentation/RawDocumentations', { days: days }, function (data) {
                    return data;
                });
            };
            /***** Contingent *****/
            FlsService.prototype.getContingent = function (flsCaseId, targetDate) {
                return _super.prototype.get.call(this, this.modulePath + '/Contingent/' + flsCaseId, { targetDate: targetDate }, function (data) {
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var conti = data_1[_i];
                        for (var _a = 0, _b = conti.contingentItems; _a < _b.length; _a++) {
                            var item = _b[_a];
                            if (item.highlightColor && item.highlightColor.length > 0) {
                                var color = item.highlightColor.substring(1, 7);
                                item.highlightText = (((parseInt(color.substring(0, 2), 16) * 0.299)
                                    + (parseInt(color.substring(2, 4), 16) * 0.587) + (parseInt(color.substring(4, 6), 16) * 0.114)) > 186) ?
                                    "#000000" : "#FFFFFF";
                            }
                        }
                    }
                    return data;
                });
            };
            /***** Config *****/
            FlsService.prototype.getUserConfig = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Documentation/UserConfig', {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getCatalogSettings = function (caseIds, docuId, date, carerId) {
                if (carerId === void 0) { carerId = null; }
                return _super.prototype.getItem.call(this, this.modulePath + '/Documentation/EditorSettings', { flsCaseIds: caseIds, flsDocumentationId: docuId, carerId: carerId, date: date }, function (data) {
                    return data;
                });
            };
            /***** Report Template *****/
            FlsService.prototype.getReportTemplates = function () {
                return _super.prototype.get.call(this, this.modulePath + '/ReportTemplate', {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getReportTemplateItems = function (id) {
                return _super.prototype.get.call(this, this.modulePath + '/ReportTemplate/' + id, {}, function (data) {
                    return data;
                });
            };
            /***** SupportPlanTarget Template *****/
            FlsService.prototype.getSupportPlanTargetTemplates = function (clientId) {
                return _super.prototype.get.call(this, '/SupportPlan/Template/' + clientId, {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getSupportPlanTargetTemplateItems = function (id) {
                return _super.prototype.get.call(this, '/SupportPlan/Template/item/' + id, {}, function (data) {
                    return data;
                });
            };
            /***** SupportPlanPhase *****/
            FlsService.prototype.getSupportPlanActivePhase = function (supportPlanId) {
                return _super.prototype.getItem.call(this, '/SupportPlan/' + supportPlanId + '/ActivePhase/', {}, function (data) {
                    return data;
                });
            };
            /***** Signature *****/
            FlsService.prototype.getSignature = function (id) {
                return _super.prototype.get.call(this, this.modulePath + '/Signature/' + id, {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getSignatureWv = function () {
                return _super.prototype.cachedGet.call(this, this.modulePath + '/Signature/WvModel', {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.postSignature = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Signature', data).then(function (data) { return data; });
            };
            /***** Week Planning *****/
            FlsService.prototype.getWeekPlanningList = function (personId, dateFrom, dateTo) {
                return _super.prototype.get.call(this, this.modulePath + '/WeekPlanning', { personId: personId, dateFrom: dateFrom, dateTo: dateTo }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.postWeekPlanningPlannedDoc = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/WeekPlanning', data).then(function (e) {
                    return e;
                });
            };
            FlsService.prototype.putWeekPlanningPlannedDoc = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/WeekPlanning/' + id, data).then(function (data) {
                    return data;
                });
            };
            FlsService.prototype.deleteWeekPlanningPlannedDoc = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + '/WeekPlanning/' + id).then(function (data) { return data; });
            };
            FlsService.prototype.getAllPossibleCarer = function () {
                return _super.prototype.get.call(this, this.modulePath + '/WeekPlanning/Carer', {}, function (data) { return data; });
            };
            /***** Fls Documentation *****/
            FlsService.prototype.getFlsDocumentationList = function (page, pageSize, dateFrom, dateTo, flsCaseId, showOnlyOwnCreated, onlyCurrentCases, onlyOwnCases, listSearch, searchProperties) {
                if (onlyCurrentCases === void 0) { onlyCurrentCases = false; }
                if (onlyOwnCases === void 0) { onlyOwnCases = false; }
                if (listSearch === void 0) { listSearch = ''; }
                if (searchProperties === void 0) { searchProperties = []; }
                return _super.prototype.get.call(this, this.modulePath + '/Documentation', { dateFrom: dateFrom, dateTo: dateTo, flsCaseId: flsCaseId, showOnlyOwnCreated: showOnlyOwnCreated, page: page, pageSize: pageSize, onlyCurrentCases: onlyCurrentCases, onlyOwnCases: onlyOwnCases, listSearch: listSearch, searchProperties: searchProperties }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getUnsignedFlsDocumentationList = function (page, pageSize, dateFrom, dateTo, onlyOwn, listSearch, onlyCurrentCases) {
                if (onlyOwn === void 0) { onlyOwn = false; }
                if (listSearch === void 0) { listSearch = ''; }
                if (onlyCurrentCases === void 0) { onlyCurrentCases = false; }
                return _super.prototype.get.call(this, this.modulePath + '/Documentation/Unsigned', { page: page, pageSize: pageSize, dateFrom: dateFrom, dateTo: dateTo, onlyOwn: onlyOwn, listSearch: listSearch, onlyCurrentCases: onlyCurrentCases }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getFlsDocumentation = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Documentation/' + id, {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getFlsDocumentationWvModel = function (flsCaseIds, flsDocumentationId, carersIds, date) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Documentation/WvModel', { flsCaseIds: flsCaseIds, flsDocumentationId: flsDocumentationId, carersIds: carersIds, date: date }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.checkForWarningsAndErrors = function (data, isPlanned) {
                if (isPlanned === void 0) { isPlanned = false; }
                return _super.prototype.post.call(this, this.modulePath + '/Documentation/WarningsAndErrors' + '?isPlanned=' + isPlanned, data).then(function (data) {
                    return data;
                });
            };
            FlsService.prototype.postFlsDocumentation = function (data, distributeHours, carerId, multiple) {
                if (distributeHours === void 0) { distributeHours = false; }
                if (carerId === void 0) { carerId = null; }
                if (multiple === void 0) { multiple = false; }
                var postString = this.modulePath + '/Documentation?distributeHours=' + distributeHours + '&carerId=' + carerId + '&multiple=' + multiple;
                return _super.prototype.post.call(this, postString, data).then(function (data) {
                    return data;
                });
            };
            FlsService.prototype.putFlsDocumentation = function (id, data, carerId, onlyModifyDescription) {
                if (carerId === void 0) { carerId = null; }
                if (onlyModifyDescription === void 0) { onlyModifyDescription = false; }
                return _super.prototype.put.call(this, this.modulePath + '/Documentation/' + id + '?carerId=' + carerId + '&onlyModifyDescription=' + onlyModifyDescription, data).then(function (data) {
                    return data;
                });
            };
            FlsService.prototype.deleteFlsDocumentation = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Documentation/Delete/' + id, data).then(function (data) {
                    return data;
                });
            };
            /***** Fls Documentation Summary *****/
            FlsService.prototype.getFlsDocumentationSummary = function (filter) {
                return _super.prototype.post.call(this, this.modulePath + "/Documentation/Summary/" + filter.id + "?page=" + filter.pagination.page + "&pageSize=" + filter.pagination.pageSize, filter).then(function (data) {
                    return data;
                });
            };
            /***** Fls Group *****/
            FlsService.prototype.getFlsGroupList = function (page, pageSize) {
                return _super.prototype.get.call(this, this.modulePath + '/Group', { page: page, pageSize: pageSize }, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getFlsGroupDetail = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Group/' + id, {}, function (data) {
                    return data;
                });
            };
            /***** Required Fields *****/
            FlsService.prototype.getFlsRequiredFields = function () {
                return _super.prototype.get.call(this, this.modulePath + "/Documentation/RequiredFields", {}, function (data) {
                    return data;
                });
            };
            /***** Confirm Documentation Ending *****/
            FlsService.prototype.getDocEndingConfirmList = function () {
                return _super.prototype.get.call(this, this.modulePath + "/FlsConfirmDocumentationEnding", {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.getDocEndingConfirmForFlsCase = function (flsCaseId) {
                return _super.prototype.getItem.call(this, this.modulePath + "/FlsConfirmDocumentationEnding/ForFlsCase/" + flsCaseId, {}, function (data) {
                    return data;
                });
            };
            FlsService.prototype.postDocEndingConfirm = function (data) {
                return _super.prototype.post.call(this, this.modulePath + "/FlsConfirmDocumentationEnding", data).then(function (data) {
                    return data;
                });
            };
            FlsService.prototype.putDocEndingConfirm = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + "/FlsConfirmDocumentationEnding/" + id, data).then(function (data) {
                    return data;
                });
            };
            /***** other *****/
            FlsService.prototype.getMileage = function (id) {
                return _super.prototype.getItem.call(this, '/Resource/Vehicle/Mileage/' + id, {}, function (data) {
                    return data;
                });
            };
            FlsService = __decorate([
                QMC.Service('QMC.Fachleistung', 'FachleistungService'),
                QMC.Inject('$http', '$q')
            ], FlsService);
            return FlsService;
        }(QMC.Common.BaseService));
        Fachleistung.FlsService = FlsService;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsCaseListController = /** @class */ (function () {
            function FlsCaseListController($location, $qui) {
                this.$location = $location;
                this.$qui = $qui;
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
            }
            FlsCaseListController = __decorate([
                QMC.Controller('QMC.Fachleistung', 'FlsCaseController'),
                QMC.Inject('$location', '$qui')
            ], FlsCaseListController);
            return FlsCaseListController;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var CaseListDirective = /** @class */ (function () {
            function CaseListDirective(flsService, $qui, $state, userService, permissionService, lng) {
                var _this = this;
                this.flsService = flsService;
                this.$qui = $qui;
                this.$state = $state;
                this.userService = userService;
                this.permissionService = permissionService;
                this.lng = lng;
                this.restrict = 'E';
                this.templateUrl = './fls/CaseList/';
                this.replace = true;
                this.scope = {};
                this.permissionCersovsky = false;
                this.allowTableExport = false;
                this.ui = new QMC.Fachleistung.UserInterface();
                this.filter = '';
                this.page = 0;
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.isFirstLoad = true;
                this.daysToHighlightCases = 0;
                this.caseFilter = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.loading = false;
                this.checkedCases = [];
                this.checkedCasesCount = 0;
                this.carerTypesMap = [];
                this.tableData = { cards: [], items: [] };
                this.link = function (scope) {
                    _this.checkedCases = [];
                    _this.checkedCasesCount = 0;
                    _this.isFirstLoad = true;
                    scope.vm = _this;
                    localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                        state: _this.$state.$current.name,
                        params: {}
                    }));
                    _this.permissionService.getPermissionsByObjectTypes([230000, 230017]).then(function (data) {
                        _this.allowTableExport = data[0].print;
                        _this.userService.getUserSettings(["FACHLSDOKU.ERFASSUNGENDE.AKTIV"], false).then(function (dataSetting) {
                            _this.permissionCersovsky = dataSetting[0].value.toLowerCase() === "true" && data[1].moduleAccess;
                            _this.$qui.scopeApply(scope);
                        });
                    });
                    _this.userService.getUserSettings([QMC.Common.UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA_KEY, "FLS.CASE.DAYSTOHIGHLIGHT", QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY]).then(function (data) {
                        _this.shouldLoadTableData = data[0].value === "" ? _this.shouldLoadTableData : data[0].value.toLowerCase() === 'true';
                        _this.daysToHighlightCases = data[1].value === "" ? _this.daysToHighlightCases : parseInt(data[1].value);
                        _this.caseFilter = data[2].value === '' ? _this.caseFilter : JSON.parse(data[2].value);
                        if (_this.shouldLoadTableData) {
                            _this.getCases();
                            scope.$watch('vm.caseFilter', function (newValue, oldValue) {
                                if (newValue === oldValue || !newValue)
                                    return;
                                _this.page = 0;
                                _this.getCases();
                            }, true);
                        }
                    });
                    _this.getWv();
                    scope.$watch('vm.filter', function (newValue, oldValue) {
                        if (newValue != oldValue) {
                            if (_this.isFirstLoad) {
                                setTimeout(function () {
                                    _this.isFirstLoad = false;
                                }, 5);
                            }
                            else if (_this.shouldLoadTableData) {
                                var lastValue_1 = _this.filter;
                                setTimeout(function () {
                                    if (_this.filter == lastValue_1 && (newValue.length < oldValue.length || _this.filter.length >= 3)) {
                                        _this.page = 0;
                                        _this.getCases();
                                    }
                                }, 1500);
                            }
                        }
                    });
                    scope.$watch('vm.page', function (newValue, oldValue) {
                        if (newValue != oldValue)
                            if (_this.isFirstLoad) {
                                setTimeout(function () {
                                    _this.isFirstLoad = false;
                                });
                            }
                            else {
                                _this.getCases();
                            }
                    });
                    $("#docEndConBtn").show();
                };
            }
            /////////////// UI FUNCTIONS ///////////////
            CaseListDirective.prototype.getData = function () {
                this.getCases();
            };
            CaseListDirective.prototype.currentfilter = function (entry) {
                var filterActive = $('#filterActive').val();
                if (filterActive === 'true') {
                    return entry.isCurrent;
                }
                else
                    return true;
            };
            CaseListDirective.prototype.persistCaseFilter = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: JSON.stringify(this.caseFilter) }] })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            CaseListDirective.prototype.toggleContingentModal = function (data) {
                var _this = this;
                this.currentCase = data;
                setTimeout(function () {
                    _this.openContingent();
                });
            };
            CaseListDirective.prototype.toggleCommentModal = function (data) {
                this.currentCase = data;
                $('#caseComment').modal('toggle');
            };
            CaseListDirective.prototype.countCheckedCases = function () {
                this.checkedCasesCount = this.checkedCases.length;
            };
            CaseListDirective.prototype.toggleChecked = function (isChecked, caseObj) {
                var _this = this;
                // check if case is allowed to be selected (fix accountability and report templates)
                if (isChecked) {
                    var selectedCases = this.cases.filter(function (x) { return _this.checkedCases.some(function (y) { return y === x.objectId; }); });
                    var fixAccRule = selectedCases.filter(function (x) { return x.isAccountableRuleFix; })[0];
                    var fixRepTemp = selectedCases.filter(function (x) { return x.isReportTemplateFix; })[0];
                    var getEmphString_1 = function (str) { return "<em>" + str + "</em>"; };
                    var createErrorString = function (conflict, oldV, newV, displayTitle) {
                        return "<strong style=\"font-size: 2rem\">" + conflict + ".</strong><br />\n\t\t\t\t\t(" + _this.$qui.formatString(_this.lng.translate(20016237, 'Bereits gewählt: {0}, aktuell: {1}'), getEmphString_1(oldV), getEmphString_1(newV)) + ") <br />\n\t\t\t\t\t(" + _this.lng.translate(20016238, 'Ursprung') + ": " + getEmphString_1(displayTitle) + ")";
                    };
                    var errors = [];
                    if (fixAccRule && caseObj.isAccountableRuleFix && (caseObj.defaultAccountableRuleId !== fixAccRule.defaultAccountableRuleId))
                        errors.push(createErrorString(this.lng.translate(20016235, 'Ein bereits gewählter Fall hat eine abweichende fixe Abrechenbarkeitsregel'), fixAccRule.accountableRule, caseObj.accountableRule, fixAccRule.displayTitle));
                    if (fixRepTemp && caseObj.isReportTemplateFix && (caseObj.reportTemplateId !== fixRepTemp.reportTemplateId))
                        errors.push(createErrorString(this.lng.translate(20016236, 'Ein bereits gewählter Fall hat eine abweichende fixe Berichtsvorlage'), fixRepTemp.reportTemplate, caseObj.reportTemplate, fixRepTemp.displayTitle));
                    if (errors.length) {
                        isChecked = false;
                        errors.forEach(function (err) {
                            return _this.$qui.notify({
                                message: err,
                                title: _this.lng.translate(20000331, 'Auswahl nicht möglich') + ": " + getEmphString_1(caseObj.displayTitle),
                                icon: "qm-icon-error",
                                status: "warning",
                                timer: 8000
                            });
                        });
                    }
                }
                for (var _i = 0, _a = this.cases; _i < _a.length; _i++) {
                    var curCase = _a[_i];
                    if (curCase.objectId === caseObj.objectId) {
                        curCase.isChecked = isChecked;
                    }
                }
                if (isChecked)
                    this.checkedCases.push(caseObj.objectId);
                else
                    this.checkedCases = this.checkedCases.filter(function (item) { return item !== caseObj.objectId; });
                this.countCheckedCases();
                this.tableData.items.forEach(function (item) {
                    item.Avatar.selected = _this.checkedCases.some(function (x) { return x === item.objectId.value; });
                });
                this.tableData.cards.forEach(function (item) {
                    item.avatar.selected = _this.checkedCases.some(function (x) { return x === item.id; });
                });
            };
            CaseListDirective.prototype.openMultipleDocumentation = function () {
                var caseIds = "";
                for (var _i = 0, _a = this.checkedCases; _i < _a.length; _i++) {
                    var caseId = _a[_i];
                    caseIds += caseId + ",";
                }
                caseIds = caseIds.substring(0, caseIds.length - 1);
                $(".modal-backdrop").hide();
                $("body").removeClass("modal-open");
                this.$state.go('documentationnew', { "flsCaseIds": caseIds });
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            CaseListDirective.prototype.getWv = function () {
                var _this = this;
                this.flsService.getFlsCaseWv().then(function (data) {
                    _this.flsCaseWv = data;
                    _this.carerTypesMap = _this.flsCaseWv.carerTypeWv.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    // Set carer type filter from local storage, or if not present, from the first wv item
                    if (!_this.flsCaseWv.carerTypeWv.some(function (x) { return x.objectId === _this.caseFilter.carerTypeFilterId; }) || !_this.caseFilter.carerTypeFilterId || _this.caseFilter.carerTypeFilterId === QMC.Common.Constants.GUID_EMPTY)
                        _this.caseFilter.carerTypeFilterId = _this.flsCaseWv.carerTypeWv[0].id;
                });
            };
            CaseListDirective.prototype.getCases = function () {
                var _this = this;
                var _a, _b, _c;
                this.persistCaseFilter();
                if (!this.flsCaseWv) {
                    setTimeout(function () { _this.getCases(); }, 100);
                    return;
                }
                this.loading = true;
                var days = this.daysToHighlightCases;
                var searchProperties = this.ui.getDisplayedPropertiesFromSchema(this.ui.caseTable);
                if (!((_c = (_b = (_a = this.ui) === null || _a === void 0 ? void 0 : _a.caseTable) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.some(function (y) { return y.isReportTemplateFix; })))
                    searchProperties = searchProperties.filter(function (x) { return x !== 'reportTemplate' && x !== 'isReportTemplateFix'; });
                this.flsService.getCasesListPaginated(this.caseFilter.carerTypeFilterId, this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, this.caseFilter.onlyCurrentCases, this.filter, null, __spreadArrays(searchProperties, ['personNr', 'personShortCaption'])).then(function (data) {
                    var _a;
                    _this.paginationInfo = data.paginationInfo;
                    for (var _i = 0, _b = _this.checkedCases; _i < _b.length; _i++) {
                        var caseId = _b[_i];
                        for (var _c = 0, _d = data.items; _c < _d.length; _c++) {
                            var item = _d[_c];
                            if (item.objectId == caseId)
                                item.isChecked = true;
                        }
                    }
                    _this.cases = data.items;
                    data.items = data.items.map(function (obj) {
                        if (obj.dateTo && Math.abs(moment().startOf('day').diff(moment(obj.dateTo).startOf('day'), 'days')) <= days)
                            obj.highlightDate = { 'background-color': 'orange', 'color': 'white' };
                        if (!obj.isCurrent)
                            obj.highlightDate = { 'background-color': 'orangered', 'color': 'white' };
                        if (obj.dateTo !== null && obj.dateTo !== undefined) {
                            obj.date = moment(obj.dateFrom).format('DD.MM.YYYY') + " - " + moment(obj.dateTo).format('DD.MM.YYYY');
                        }
                        else if (obj.dateFrom !== null && obj.dateFrom !== undefined) {
                            obj.date = moment(obj.dateFrom).format('DD.MM.YYYY');
                        }
                        else {
                            obj.date = "";
                        }
                        return obj;
                    });
                    data.items = data.items.map(function (item) {
                        item.fullName = _this.$qui.createPersonDisplay(item.name, item.forename, item.personShortCaption, item.personNr);
                        return item;
                    });
                    _this.loading = false;
                    _this.isFirstLoad = false;
                    _this.ui.caseTable.data = (_a = data.items) !== null && _a !== void 0 ? _a : [];
                    _this.$qui.functionWaiter("ui.createTable", _this);
                });
            };
            CaseListDirective = __decorate([
                QMC.Directive('QMC.Fachleistung', 'qmCaseList', ['FachleistungService', '$qui', '$state', 'UserService', 'QmcPermissionService', 'QmcLanguageService'])
            ], CaseListDirective);
            return CaseListDirective;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsCompanionController = /** @class */ (function () {
            function FlsCompanionController($location, flsService, $qui, $scope, $stateParams, $state, userService, permissionService, terminService, lng) {
                var _this = this;
                this.$location = $location;
                this.flsService = flsService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.userService = userService;
                this.permissionService = permissionService;
                this.terminService = terminService;
                this.lng = lng;
                this.loading = {
                    permission: true,
                    carer: false,
                    cases: false,
                    report: false,
                    plannings: false,
                    settings: false,
                    wv: false,
                    editorSettings: false,
                    requiredFields: false,
                    save: false,
                    allLoaded: function () { return !(_this.loading.permission || _this.loading.carer || _this.loading.cases || _this.loading.report || _this.loading.plannings || _this.loading.settings || _this.loading.wv || _this.loading.editorSettings || _this.loading.requiredFields || _this.loading.save); }
                };
                this.title = '';
                this.formWatcherList = [];
                this.editLockType = 'errors';
                this.wvsByDate = {};
                this.defaultAccountability = '4d35825c-8c2a-4ea2-920d-1f87db35cfcc';
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                this.title = this.lng.translate(20016003, "Dokumentation vom") + " " + moment().format('DD.MM.YYYY') + " (WebClient)";
                permissionService.getPermissionsByObjectTypes([230000, 230021]).then(function (data) {
                    _this.new = data[0].new && data[0].moduleAccess;
                    _this.editLockType = data[1].openFile ? 'warnings' : 'errors';
                    _this.init();
                    _this.loading.requiredFields = true;
                    _this.flsService.getFlsRequiredFields().then(function (rdata) {
                        _this.loading.settings = true;
                        _this.userService.getUserSettings(["FLS.DEFAULTCARETYPE", "FLS.DEFAULTCONTACTTYPE", "FLS.DEFAULTACTIVITYTYPE", "FLS.DOKU.BERICHTTITELVORGABE", "FLS.DOKU.BERICHTTITEL", "FLS.ZEITPLANUNG.ALLOW_MANUELLEZEITENDEUHRZEIT", "FLS.DEFAULTVALUE_MANUAL", "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER"], false).then(function (data) {
                            _this.settings.flsDefaultCareType = $.grep(data, function (e) { return e.key === "FLS.DEFAULTCARETYPE"; })[0].value;
                            _this.settings.flsDefaultContactType = $.grep(data, function (e) { return e.key === "FLS.DEFAULTCONTACTTYPE"; })[0].value;
                            _this.settings.flsDefaultActivityType = $.grep(data, function (e) { return e.key === "FLS.DEFAULTACTIVITYTYPE"; })[0].value;
                            if (data[3].value === "1")
                                _this.title = "";
                            if (data[3].value === "2")
                                _this.title = data[4].value;
                            if (data[7].value.length > 0)
                                _this.settings.isManuelTimeVisible = data[7].value.toLowerCase() === "true";
                            if (data[5].value.length > 0)
                                _this.settings.allowManual = data[5].value.toLowerCase() === "true" && _this.settings.isManuelTimeVisible;
                            if (data[6].value.length > 0 && _this.settings.allowManual && _this.settings.isManuelTimeVisible)
                                _this.settings.manualDefault = data[6].value.toLowerCase() === "true";
                            _this.flsService.getUserConfig().then(function (dataUserConfig) {
                                _this.settings.allowEmptyReports = dataUserConfig.allowEmptyReports;
                                _this.showTime = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : dataUserConfig.allowEmptyReports;
                                _this.settings.requiredFields = rdata;
                                _this.planForm.workingHours.isMiscontactEnabled = rdata.workingHours.miscontactWvId;
                                _this.loading.requiredFields = false;
                                _this.loading.settings = false;
                                _this.loading.permission = false;
                                _this.events();
                                _this.getCarer();
                                _this.getCases();
                                _this.getReportTemplates();
                            });
                        });
                    });
                });
            }
            FlsCompanionController.prototype.init = function () {
                var _a, _b;
                this.planForm = {
                    caseId: null,
                    carerId: $('#session').data().personId,
                    dateFrom: new Date(),
                    dateTo: new Date(),
                    freedays: {
                        holiday: false, vacation: false
                    },
                    report: {
                        templateId: QMC.Common.Constants.GUID_EMPTY, itemId: QMC.Common.Constants.GUID_EMPTY, isTemplateFix: false
                    },
                    timeFrom: new Date(),
                    timeTo: new Date(),
                    weekdays: {
                        mo: true, tu: true, we: true, th: true, fr: true, sa: false, su: false
                    },
                    workingHours: {
                        abrechenbarkeitId: QMC.Common.Constants.GUID_EMPTY,
                        activityWvId: QMC.Common.Constants.GUID_EMPTY,
                        careTypeWvId: QMC.Common.Constants.GUID_EMPTY,
                        contactTypeWvId: QMC.Common.Constants.GUID_EMPTY,
                        durationInHours: 0,
                        isManualDuration: false,
                        carerObjectId: $("#session").data().personId,
                        miscontactWvId: QMC.Common.Constants.FLS_NO_MISCONTACT,
                        isMiscontactEnabled: (_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.requiredFields) === null || _b === void 0 ? void 0 : _b.workingHours.miscontactWvId
                    }
                };
                if (localStorage.getItem(this.cacheName) && localStorage.getItem(this.cacheName).length > 0) {
                    this.planForm.caseId = localStorage.getItem(this.cacheName);
                }
                this.planForm.dateFrom.setDate(1);
                this.planForm.dateTo = moment().endOf('month').toDate();
                this.planForm.timeFrom.setHours(8, 0, 0, 0);
                this.planForm.timeTo.setHours(12, 0, 0, 0);
                this.createForm = {
                    caseId: null,
                    documentations: null,
                    reportTemplateId: null,
                    reportTemplateItemId: null
                };
                this.settings = {
                    isAccountableRuleFix: false,
                    flsDefaultActivityType: null,
                    flsDefaultCareType: null,
                    flsDefaultContactType: null,
                    editor: null,
                    requiredFields: null,
                    allowEmptyReports: false,
                    manualDefault: false,
                    allowManual: true,
                    isManuelTimeVisible: true
                };
                this.selectLists = {
                    accountability: [],
                    activity: [],
                    careType: [],
                    carer: [],
                    cases: [],
                    contactType: [],
                    miscontact: []
                };
            };
            FlsCompanionController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.planForm.report.templateId', function (newVal, oldVal) { if (newVal !== oldVal)
                    _this.getReportTemplateItems(); });
                this.$scope.$watch('vm.planForm.carerId', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        _this.getCases();
                    }
                });
                this.$scope.$watch('vm.planForm.caseId', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal && newVal !== QMC.Common.Constants.GUID_EMPTY) {
                        _this.createForm.documentations = [];
                        _this.getWvForCase();
                        _this.getEditorSetting();
                        localStorage.setItem(_this.cacheName, _this.planForm.caseId);
                        _this.setFixedTemplate(newVal);
                        _this.checkCasePaused();
                    }
                });
                this.$scope.$watch('vm.planForm.dateTo', function (newVal, oldVal) {
                    if (newVal === oldVal || !_this.planForm.caseId || _this.planForm.caseId === QMC.Common.Constants.GUID_EMPTY)
                        return;
                    _this.getWvForCase();
                    _this.getEditorSetting();
                });
                this.$scope.$watch('vm.planForm.report', function (newVal, oldVal) {
                    if (newVal !== oldVal && _this.createForm) {
                        _this.createForm.reportTemplateItemId = _this.planForm.report.itemId;
                        _this.createForm.reportTemplateId = _this.planForm.report.templateId;
                    }
                }, true);
                this.$scope.$watch('vm.planForm.workingHours', function (newVal, oldVal) {
                    // if activity, caretype, ... are changed revalidate all items
                    if (newVal !== oldVal && _this.createForm.documentations)
                        _this.validatePlannings();
                }, true);
            };
            /////////////// DISPLAY LOGIC ///////////////
            FlsCompanionController.prototype.setFixedTemplate = function (caseId) {
                this.planForm.report.isTemplateFix = false;
                var cCase = this.cases.filter(function (x) { return x.objectId === caseId; })[0];
                if (cCase.reportTemplateId && cCase.reportTemplateId != QMC.Common.Constants.GUID_EMPTY) {
                    this.planForm.report.templateId = cCase.reportTemplateId;
                    this.planForm.report.isTemplateFix = cCase.isReportTemplateFix;
                }
            };
            FlsCompanionController.prototype.checkCasePaused = function () {
                var _this = this;
                // Check if any case is paused
                this.pausedCases = [];
                if (!this.planForm.caseId || this.planForm.caseId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                this.flsService.getFlsCasePaused([this.planForm.caseId]).then(function (pauseData) {
                    for (var _i = 0, _a = _this.cases; _i < _a.length; _i++) {
                        var curCase = _a[_i];
                        if (pauseData[curCase.objectId]) {
                            _this.pausedCases.push(curCase);
                        }
                    }
                    if (_this.pausedCases.length > 0) {
                        $('#casePausedModal').modal('show');
                    }
                });
            };
            FlsCompanionController.prototype.createPlanning = function () {
                var _this = this;
                this.loading.plannings = true;
                this.createForm = null;
                // destroy all current validation watchers
                for (var _i = 0, _a = this.formWatcherList; _i < _a.length; _i++) {
                    var watcher = _a[_i];
                    watcher();
                }
                this.formWatcherList = [];
                var dates = this.getDatesInTimeFrame(this.planForm.dateFrom, this.planForm.dateTo);
                // load editor config for each day
                this.wvsByDate = {};
                dates.forEach(function (date) {
                    _this.wvsByDate[date.toISOString()] = 'LOADING';
                    _this.flsService.getFlsDocumentationWvModel([_this.planForm.caseId], QMC.Common.Constants.GUID_EMPTY, [_this.planForm.carerId], date)
                        .then(function (data) { return _this.wvsByDate[date.toISOString()] = data[0]; })
                        .catch(function () { return _this.wvsByDate[date.toISOString()] = 'ERROR'; });
                });
                this.terminService.getHolidaysSpecific(this.planForm.dateFrom.getFullYear(), !this.planForm.freedays.holiday, !this.planForm.freedays.vacation).then(function (holidays) {
                    _this.createForm = {
                        caseId: _this.planForm.caseId,
                        documentations: [],
                        reportTemplateId: _this.planForm.report.templateId,
                        reportTemplateItemId: _this.planForm.report.itemId,
                    };
                    var _loop_1 = function (i) {
                        var item = {
                            documentationId: _this.$qui.generateGuid(),
                            active: _this.checkIfShouldActivate(dates[i], holidays, _this.planForm.weekdays),
                            date: dates[i],
                            timeFrom: _this.planForm.timeFrom,
                            timeTo: _this.planForm.timeTo,
                            comment: '',
                            validation: { errors: [], warnings: [] },
                            isHoliday: _this.checkIfDateIsInHoliday(dates[i], holidays),
                            style: _this.checkIfDateIsInHoliday(dates[i], holidays) ? "{'color':'indianred'}" : "{'color': 'inherit'}",
                            isManual: _this.settings.manualDefault,
                            duration: 0,
                            durationM: 0,
                            durationH: 0
                        };
                        if (item.isManual) {
                            item.duration = Math.abs(item.timeTo.getTime() - item.timeFrom.getTime()) / 3600000;
                            var conv = _this.$qui.convertDec(item.duration);
                            item.durationH = conv[0];
                            item.durationM = conv[1];
                        }
                        //initializie validation for item
                        _this.formWatcherList.push(_this.$scope.$watch('vm.createForm.documentations[' + _this.createForm.documentations.length + '].timeFrom', function (newVal, oldVal) {
                            if (newVal === oldVal)
                                return;
                            _this.validatePlannings();
                        }, true));
                        _this.formWatcherList.push(_this.$scope.$watch('vm.createForm.documentations[' + _this.createForm.documentations.length + '].timeTo', function (newVal, oldVal) {
                            if (newVal === oldVal)
                                return;
                            _this.validatePlannings();
                        }, true));
                        _this.formWatcherList.push(_this.$scope.$watch('vm.createForm.documentations[' + _this.createForm.documentations.length + '].active', function (newVal, oldVal) {
                            if (newVal === oldVal)
                                return;
                            _this.validatePlannings();
                        }, true));
                        _this.formWatcherList.push(_this.$scope.$watch('vm.createForm.documentations[' + _this.createForm.documentations.length + '].isManual', function () {
                            var conv = _this.$qui.convertDec(item.duration);
                            item.durationH = conv[0];
                            item.durationM = conv[1];
                            _this.validatePlannings();
                        }, true));
                        _this.formWatcherList.push(_this.$scope.$watch('vm.createForm.documentations[' + _this.createForm.documentations.length + '].duration', function (newVal, oldVal) {
                            if (newVal === oldVal)
                                return;
                            _this.validatePlannings();
                        }, true));
                        _this.formWatcherList.push(_this.$scope.$watch('vm.createForm.documentations[' + _this.createForm.documentations.length + '].durationH', function (newVal, oldVal) {
                            if (newVal === oldVal)
                                return;
                            _this.validatePlannings();
                        }, true));
                        _this.formWatcherList.push(_this.$scope.$watch('vm.createForm.documentations[' + _this.createForm.documentations.length + '].durationM', function (newVal, oldVal) {
                            if (newVal === oldVal)
                                return;
                            if (item.durationM && item.durationM > 59) {
                                item.durationH++;
                                item.durationM = item.durationM - 60;
                            }
                            _this.validatePlannings();
                        }, true));
                        if (!_this.settings.allowEmptyReports) {
                            _this.formWatcherList.push(_this.$scope.$watch('vm.createForm.documentations[' + _this.createForm.documentations.length + '].comment', function (newVal, oldVal) {
                                setTimeout(function () {
                                    if (newVal === oldVal || !item.validation)
                                        return;
                                    _this.addOrRemoveError(_this.lng.translate(20016207, "Der Bericht enthält noch keinen Text."), !_this.settings.allowEmptyReports && _this.createForm.documentations[i].comment.length === 0, _this.createForm.documentations[i].validation);
                                }, 1500);
                            }, true));
                        }
                        _this.createForm.documentations.push(item);
                    };
                    for (var i = 0; i < dates.length; i++) {
                        _loop_1(i);
                    }
                    _this.loading.plannings = false;
                    _this.validatePlannings();
                });
            };
            FlsCompanionController.prototype.checkIfShouldActivate = function (date, holidays, weekdays) {
                // iterate through holidays to see if the current date is one
                for (var _i = 0, holidays_1 = holidays; _i < holidays_1.length; _i++) {
                    var holiday = holidays_1[_i];
                    var dateFrom = this.$qui.createDateFromString(holiday.dateFrom);
                    var dateTo = holiday.dateTo ? this.$qui.createDateFromString(holiday.dateTo) : null;
                    if ((!dateTo && dateFrom >= date && dateFrom <= date) || (dateTo && dateTo >= date && dateFrom <= date))
                        return false;
                }
                var currentDay = date.getDay();
                // first check weekdays
                if ((currentDay === 0 && weekdays.su) || (currentDay === 1 && weekdays.mo) || (currentDay === 2 && weekdays.tu) || (currentDay === 3 && weekdays.we) ||
                    (currentDay === 4 && weekdays.th) || (currentDay === 5 && weekdays.fr) || (currentDay === 6 && weekdays.sa))
                    return true;
                return false;
            };
            FlsCompanionController.prototype.checkIfDateIsInHoliday = function (dateToCheck, holidays) {
                for (var _i = 0, holidays_2 = holidays; _i < holidays_2.length; _i++) {
                    var holiday = holidays_2[_i];
                    var dateFrom = this.$qui.createDateFromString(holiday.dateFrom);
                    var dateTo = holiday.dateTo ? this.$qui.createDateFromString(holiday.dateTo) : null;
                    if ((!dateTo && dateFrom >= dateToCheck && dateFrom <= dateToCheck) || (dateTo && dateTo >= dateToCheck && dateFrom <= dateToCheck))
                        return true;
                }
                return false;
            };
            FlsCompanionController.prototype.getDatesInTimeFrame = function (startDate, endDate) {
                var dates = [];
                var currentDate = startDate;
                var addDays = function (days) {
                    var date = new Date(this.valueOf());
                    date.setDate(date.getDate() + days);
                    return date;
                };
                while (currentDate <= endDate) {
                    dates.push(currentDate);
                    currentDate = addDays.call(currentDate, 1);
                }
                for (var _i = 0, dates_1 = dates; _i < dates_1.length; _i++) {
                    var date = dates_1[_i];
                    date.setHours(0, 0, 0, 0);
                }
                return dates;
            };
            ;
            FlsCompanionController.prototype.getWeekdayName = function (date) {
                switch (date.getDay()) {
                    case 0: return this.lng.translate(20000188, "Sonntag");
                    case 1: return this.lng.translate(20000182, "Montag");
                    case 2: return this.lng.translate(20000183, "Dienstag");
                    case 3: return this.lng.translate(20000184, "Mittwoch");
                    case 4: return this.lng.translate(20000185, "Donnerstag");
                    case 5: return this.lng.translate(20000186, "Freitag");
                    case 6: return this.lng.translate(20000187, "Samstag");
                }
                return "";
            };
            FlsCompanionController.prototype.getValidationButtonState = function (item) {
                if (!(item === null || item === void 0 ? void 0 : item.validation))
                    return 2;
                if (item.validation.errors.length > 0)
                    return 2;
                if (item.validation.warnings.length > 0)
                    return 1;
                return 0;
            };
            FlsCompanionController.prototype.showValidation = function (item) {
                this.currentItem = item;
                $('#validationModal').modal('show');
            };
            FlsCompanionController.prototype.savingEnabled = function () {
                if (!this.loading.allLoaded() || !this.new || !this.createForm || !this.createForm.documentations || this.createForm.documentations.length === 0 || !this.title || this.title.length === 0)
                    return false;
                var oneIsActive = false;
                for (var _i = 0, _a = this.createForm.documentations; _i < _a.length; _i++) {
                    var docu = _a[_i];
                    if (docu.active)
                        oneIsActive = true;
                    // dont allow saving if at least one activated item is unvalidated or validated with errors
                    if (docu.active && (!docu.validation || docu.validation.errors.length > 0))
                        return false;
                }
                return oneIsActive;
            };
            FlsCompanionController.prototype.saveFls = function () {
                $('#validationModal').modal('hide');
                var templateItem = this.getTemplateItem(this.completeTemplateItems);
                var flsList = [];
                for (var _i = 0, _a = this.createForm.documentations; _i < _a.length; _i++) {
                    var docu = _a[_i];
                    if (!this.isRowEnabled(docu))
                        continue;
                    if (!docu.validation || docu.validation.errors.length > 0)
                        return;
                    var item = {
                        title: this.title,
                        additionalCost: null,
                        dateFrom: this.$qui.addTimeToDate(docu.date, docu.timeFrom),
                        dateTo: this.$qui.addTimeToDate(docu.date, docu.timeTo),
                        documentationId: null,
                        drivingCost: [],
                        durationInHours: docu.isManual && docu.duration ? docu.duration : 0,
                        flsCaseId: this.createForm.caseId,
                        isManualDuration: docu.isManual,
                        isSupportPlanDocu: false,
                        participantCount: 0,
                        participants: [],
                        plannedDocumentationId: null,
                        reports: [{
                                caption: templateItem.caption,
                                comment: docu.comment,
                                wvChildId: templateItem.reportItemId,
                                templateReferenceId: templateItem.objectId,
                                children: []
                            }],
                        workingHours: this.planForm.workingHours,
                        additionalFls: false,
                        additionalFlsText: '',
                        referencedPersonId: this.getCase(this.planForm.caseId).clientObjectId,
                        warning: false,
                        warningReasons: {},
                        reportTemplateId: this.planForm.report.templateId,
                        isReportTemplateFix: this.planForm.report.isTemplateFix
                    };
                    if (!item.workingHours.isMiscontactEnabled)
                        item.workingHours.miscontactWvId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                    delete item.workingHours.isMiscontactEnabled;
                    flsList.push(item);
                }
                console.log(flsList);
                this.postFls(flsList);
            };
            FlsCompanionController.prototype.getTemplateItem = function (items) {
                if (items === void 0) { items = this.completeTemplateItems; }
                var result;
                for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                    var item = items_1[_i];
                    if (item.objectId === this.createForm.reportTemplateItemId) {
                        result = item;
                        break;
                    }
                    if (item.children && item.children.length > 0) {
                        var temp = this.getTemplateItem(item.children);
                        if (temp) {
                            result = temp;
                            break;
                        }
                    }
                }
                ;
                return result;
            };
            FlsCompanionController.prototype.getCase = function (caseId) {
                for (var _i = 0, _a = this.cases; _i < _a.length; _i++) {
                    var element = _a[_i];
                    if (element.objectId === caseId)
                        return element;
                }
            };
            FlsCompanionController.prototype.setDefaultValues = function () {
                this.planForm.workingHours.activityWvId = this.settings.flsDefaultActivityType;
                this.planForm.workingHours.careTypeWvId = this.settings.flsDefaultCareType;
                this.planForm.workingHours.contactTypeWvId = this.settings.flsDefaultContactType;
                var cuCase = this.getCase(this.planForm.caseId);
                this.planForm.workingHours.abrechenbarkeitId = cuCase.defaultAccountableRuleId;
                this.settings.isAccountableRuleFix = cuCase.isAccountableRuleFix;
                // if no accountability is supplied use default
                if ((!this.planForm.workingHours.abrechenbarkeitId || this.planForm.workingHours.abrechenbarkeitId === QMC.Common.Constants.GUID_EMPTY))
                    this.planForm.workingHours.abrechenbarkeitId = this.defaultAccountability;
            };
            FlsCompanionController.prototype.createDisabled = function () {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
                return !((_a = this.planForm) === null || _a === void 0 ? void 0 : _a.caseId) || this.planForm.caseId == '00000000-0000-0000-0000-000000000000' || !this.title || this.title.length == 0
                    || (((_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.requiredFields) === null || _c === void 0 ? void 0 : _c.workingHours.activityWvId) && (!((_e = (_d = this.planForm) === null || _d === void 0 ? void 0 : _d.workingHours) === null || _e === void 0 ? void 0 : _e.activityWvId) || this.planForm.workingHours.activityWvId === QMC.Common.Constants.GUID_EMPTY))
                    || ((((_g = (_f = this.settings) === null || _f === void 0 ? void 0 : _f.requiredFields) === null || _g === void 0 ? void 0 : _g.workingHours.contactTypeWvId) || ((_j = (_h = this.settings) === null || _h === void 0 ? void 0 : _h.editor) === null || _j === void 0 ? void 0 : _j.isContactTypeRequiered)) && (!this.planForm.workingHours.contactTypeWvId || this.planForm.workingHours.contactTypeWvId === QMC.Common.Constants.GUID_EMPTY))
                    || ((((_l = (_k = this.settings) === null || _k === void 0 ? void 0 : _k.requiredFields) === null || _l === void 0 ? void 0 : _l.workingHours.careTypeWvId) || ((_o = (_m = this.settings) === null || _m === void 0 ? void 0 : _m.editor) === null || _o === void 0 ? void 0 : _o.isCareTypeRequiered)) && (!this.planForm.workingHours.careTypeWvId || this.planForm.workingHours.careTypeWvId === QMC.Common.Constants.GUID_EMPTY))
                    || (((_q = (_p = this.planForm) === null || _p === void 0 ? void 0 : _p.workingHours) === null || _q === void 0 ? void 0 : _q.isMiscontactEnabled) && (!((_s = (_r = this.planForm) === null || _r === void 0 ? void 0 : _r.workingHours) === null || _s === void 0 ? void 0 : _s.miscontactWvId) || this.planForm.workingHours.miscontactWvId === QMC.Common.Constants.GUID_EMPTY || this.planForm.workingHours.miscontactWvId === QMC.Common.Constants.FLS_NO_MISCONTACT));
            };
            FlsCompanionController.prototype.getConfigErrors = function (docu) {
                var _this = this;
                var wv = this.wvsByDate[docu.date.toISOString()];
                if (wv === 'ERROR')
                    return [this.lng.translate(20016239, 'Die Konfiguration zu diesem Datum konnte nicht überprüft werden')];
                if (wv === 'LOADING')
                    return [this.lng.translate(20016240, 'Die Konfiguration zu diesem Datum wird noch geprüft')];
                var errors = [];
                var checkIfIdIsPresentInWv = function (id, wv) { return (!id || id === QMC.Common.Constants.GUID_EMPTY || id === _this.defaultAccountability || wv.some(function (x) { return x.objectId === id; })); };
                var createErrorString = function (id, wv, area) {
                    var _a;
                    var entry = (_a = wv.filter(function (x) { return x.objectId === id; })[0]) !== null && _a !== void 0 ? _a : { caption: '' };
                    var caption = 'name' in entry ? entry.name : entry.caption;
                    return _this.$qui.formatString(_this.lng.translate(20016241, 'Die {0} {1} ist an dem Dokumentationsdatum ungültig'), area, caption);
                };
                if (!checkIfIdIsPresentInWv(this.planForm.workingHours.abrechenbarkeitId, wv.documentationCarerWvModel.abrechenbarkeitWv))
                    errors.push(createErrorString(this.planForm.workingHours.abrechenbarkeitId, this.wv.abrechenbarkeitWv, this.lng.translate(20016036, 'An-/Abrechenbarkeitsregel')));
                if (!checkIfIdIsPresentInWv(this.planForm.workingHours.activityWvId, wv.documentationCarerWvModel.activityWv))
                    errors.push(createErrorString(this.planForm.workingHours.activityWvId, this.wv.activityWv, this.lng.translate(20016046, 'Tätigkeit')));
                if (!checkIfIdIsPresentInWv(this.planForm.workingHours.contactTypeWvId, wv.documentationCarerWvModel.contactTypeWv))
                    errors.push(createErrorString(this.planForm.workingHours.contactTypeWvId, this.wv.contactTypeWv, this.lng.translate(20016049, 'Kontaktart')));
                if (!checkIfIdIsPresentInWv(this.planForm.workingHours.careTypeWvId, wv.documentationCarerWvModel.careTypeWv))
                    errors.push(createErrorString(this.planForm.workingHours.careTypeWvId, this.wv.careTypeWv, this.lng.translate(20016051, 'Betreuungsart')));
                return errors;
            };
            FlsCompanionController.prototype.isRowEnabled = function (docu) {
                return docu.active && this.getConfigErrors(docu).length === 0;
            };
            FlsCompanionController.prototype.showForbiddenNotification = function (docu) {
                this.$qui.notify({
                    message: this.getConfigErrors(docu).join('<br />'),
                    title: this.lng.translate(20000331, 'Auswahl nicht möglich') + ": " + docu.date.toLocaleDateString(),
                    icon: "qm-icon-information",
                    status: "info",
                    timer: 8000
                });
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            FlsCompanionController.prototype.getCarer = function () {
                var _this = this;
                this.loading.carer = true;
                this.flsService.getCarerList().then(function (data) {
                    _this.loading.carer = false;
                    _this.selectLists.carer = _this.$qui.select(data, {
                        value: 'objectId',
                        text: 'displayTitle'
                    });
                });
            };
            FlsCompanionController.prototype.getCases = function () {
                var _this = this;
                this.loading.cases = true;
                this.flsService.getCasesList(undefined, true, this.planForm.carerId).then(function (data) {
                    _this.cases = data;
                    _this.loading.cases = false;
                    _this.selectLists.cases = _this.cases.map(function (x) { return _this.$qui.createCaseDisplayObject(x); });
                    if (!_this.selectLists.cases.some(function (x) { return x.value === _this.planForm.caseId; }))
                        _this.planForm.caseId = QMC.Common.Constants.GUID_EMPTY;
                    if (_this.planForm.caseId && _this.planForm.caseId !== QMC.Common.Constants.GUID_EMPTY) {
                        _this.getWvForCase();
                        _this.getEditorSetting();
                        _this.setFixedTemplate(_this.planForm.caseId);
                    }
                    _this.checkCasePaused();
                });
            };
            FlsCompanionController.prototype.getEditorSetting = function () {
                var _this = this;
                this.loading.editorSettings = true;
                this.flsService.getCatalogSettings([this.planForm.caseId], QMC.Common.Constants.GUID_EMPTY, this.planForm.dateTo, this.planForm.carerId).then(function (data) {
                    _this.loading.editorSettings = false;
                    _this.settings.editor = data;
                    _this.setDefaultValues();
                });
            };
            FlsCompanionController.prototype.getWvForCase = function () {
                var _this = this;
                this.loading.wv = true;
                this.flsService.getFlsDocumentationWvModel([this.planForm.caseId], QMC.Common.Constants.GUID_EMPTY, [this.planForm.carerId], this.planForm.dateTo).then(function (data) {
                    _this.loading.wv = false;
                    _this.wv = data[0].documentationCarerWvModel;
                    _this.selectLists.accountability = _this.$qui.select(_this.wv.abrechenbarkeitWv, {
                        value: 'objectId',
                        text: 'caption'
                    });
                    _this.selectLists.activity = _this.$qui.select(_this.wv.activityWv, {
                        value: 'objectId',
                        text: 'name'
                    });
                    _this.selectLists.careType = _this.$qui.select(_this.wv.careTypeWv, {
                        value: 'objectId',
                        text: 'name'
                    });
                    _this.selectLists.contactType = _this.$qui.select(_this.wv.contactTypeWv, {
                        value: 'objectId',
                        text: 'name'
                    });
                    _this.selectLists.miscontact = _this.$qui.select(_this.wv.miscontactWv, {
                        value: 'objectId',
                        text: 'name'
                    });
                    _this.setDefaultValues();
                });
            };
            FlsCompanionController.prototype.getReportTemplates = function () {
                var _this = this;
                this.loading.report = true;
                this.flsService.getReportTemplates().then(function (data) {
                    if (data.length === 0) {
                        _this.planForm.report.templateId = QMC.Common.Constants.GUID_EMPTY;
                        return;
                    }
                    for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
                        var element = data_2[_i];
                        if (element.isDefault)
                            _this.planForm.report.templateId = element.objectId;
                    }
                    _this.reportTemplates = _this.$qui.select(data, {
                        value: 'objectId',
                        text: 'caption'
                    });
                    _this.loading.report = false;
                });
            };
            FlsCompanionController.prototype.getReportTemplateItems = function () {
                var _this = this;
                this.flsService.getReportTemplateItems(this.planForm.report.templateId).then(function (data) {
                    _this.reportTemplateItems = [];
                    if (data.length === 0) {
                        _this.planForm.report.itemId = QMC.Common.Constants.GUID_EMPTY;
                        return;
                    }
                    _this.planForm.report.itemId = data[0].objectId;
                    _this.reportTemplateItems = _this.createTemplateList(data);
                    _this.completeTemplateItems = data;
                });
            };
            FlsCompanionController.prototype.createTemplateList = function (list, level) {
                if (level === void 0) { level = 0; }
                var result = [];
                for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                    var element = list_1[_i];
                    var text = element.caption;
                    if (level > 0) {
                        text = ' ' + text;
                        for (var j = 0; j < level; j++) {
                            text = '-' + text;
                        }
                    }
                    result.push({ text: text, value: element.objectId });
                    if (element.children && element.children.length > 0)
                        result = result.concat(this.createTemplateList(element.children, level + 1));
                }
                return result;
            };
            FlsCompanionController.prototype.validatePlannings = function () {
                var _this = this;
                var validationObjects = [];
                var curCase = this.getCase(this.planForm.caseId);
                this.createForm.documentations.forEach(function (item) {
                    if (_this.isRowEnabled(item)) {
                        if (!item.isManual) {
                            item.duration = Math.abs(item.timeTo.getTime() - item.timeFrom.getTime()) / 3600000;
                            var conv = _this.$qui.convertDec(item.duration);
                            item.durationH = conv[0];
                            item.durationM = conv[1];
                        }
                        else if (_this.showTime) {
                            var hours = item.durationH ? item.durationH : 0;
                            var minutes = item.durationM ? item.durationM : 0;
                            item.duration = +hours + +(minutes / 60);
                        }
                        validationObjects.push({
                            carer: [{
                                    activityTypeId: _this.planForm.workingHours.activityWvId,
                                    carerId: _this.planForm.carerId,
                                    careTypeId: _this.planForm.workingHours.careTypeWvId,
                                    contactTypeId: _this.planForm.workingHours.contactTypeWvId,
                                    miscontactId: _this.planForm.workingHours.isMiscontactEnabled ? _this.planForm.workingHours.miscontactWvId : QMC.Common.Constants.FLS_NO_MISCONTACT
                                }],
                            dateFrom: _this.$qui.addTimeToDate(item.date, item.timeFrom),
                            dateTo: _this.$qui.addTimeToDate(item.date, item.timeTo),
                            hasManualDuration: item.isManual,
                            ignoreConfigRoundInterval: false,
                            manualDuration: item.isManual && item.duration ? item.duration : 0,
                            references: [{
                                    referenceId: curCase.clientObjectId,
                                    caseId: curCase.objectId,
                                    accountabilityId: _this.planForm.workingHours.abrechenbarkeitId
                                }],
                            documentationId: QMC.Common.Constants.GUID_EMPTY,
                            requestId: item.documentationId
                        });
                    }
                });
                if (this.lastValidation === JSON.stringify(validationObjects))
                    return;
                // clear validations to indicate loading
                this.createForm.documentations.forEach(function (plan) {
                    if (_this.isRowEnabled(plan)) {
                        plan.validation = null;
                    }
                });
                this.lastValidation = JSON.stringify(validationObjects);
                this.flsService.checkForWarningsAndErrors(validationObjects, false).then(function (data) {
                    if (_this.lastValidation !== JSON.stringify(validationObjects))
                        return; // we only care for the last validation
                    data.forEach(function (result) {
                        var docu = _this.createForm.documentations.filter(function (x) { return x.documentationId === result.requestId; })[0];
                        if (!docu)
                            return;
                        docu.validation = result.validation[_this.planForm.carerId];
                        _this.addOrRemoveError(_this.lng.translate(20016207, "Der Bericht enthält noch keinen Text."), !_this.settings.allowEmptyReports && docu.comment.length === 0, docu.validation);
                    });
                }).catch(function () {
                    _this.createForm.documentations.forEach(function (plan) {
                        if (_this.isRowEnabled(plan)) {
                            plan.validation = { warnings: [], errors: [_this.lng.translate(21003033, 'Die Leistung konnte nicht validiert werden.')] };
                        }
                    });
                });
            };
            FlsCompanionController.prototype.formatTimeString = function (duration) {
                if (duration === void 0) { duration = 0; }
                var timeString = "";
                if (this.showTime) {
                    var conv = this.$qui.convertDec(duration);
                    var minutes = conv[1].toString();
                    if (conv[1] < 10)
                        minutes = "0" + minutes;
                    timeString = conv[0] + ":" + minutes;
                }
                else {
                    timeString = parseFloat(duration + "").toFixed(2).toString().replace('.', ',');
                }
                return timeString;
            };
            FlsCompanionController.prototype.GuidIsNullOrEmptyOrGuidEmpty = function (guid) {
                return guid === null || guid === undefined || guid === "" || guid === QMC.Common.Constants.GUID_EMPTY;
            };
            FlsCompanionController.prototype.postFls = function (list) {
                var _this = this;
                window.scrollTo(null, 0);
                this.loading.save = true;
                this.flsService.postFlsDocumentation(list, false, this.planForm.carerId).then(function () {
                    localStorage.setItem('flsDocuListCache', _this.planForm.caseId);
                    _this.$state.go('documentation');
                });
            };
            FlsCompanionController.prototype.addOrRemoveError = function (error, add, validation) {
                if (!validation)
                    return;
                if (add)
                    this.addValidationError(error, validation);
                else
                    this.removeValidationError(error, validation);
                this.$qui.scopeApply(this.$scope);
                return add;
            };
            FlsCompanionController.prototype.addValidationError = function (error, validation) {
                for (var _i = 0, _a = validation.errors; _i < _a.length; _i++) {
                    var presentError = _a[_i];
                    if (presentError === error)
                        return;
                }
                validation.errors.push(error);
            };
            FlsCompanionController.prototype.removeValidationError = function (error, validation) {
                for (var i = 0; i < validation.errors.length; i++) {
                    if (validation.errors[i] === error) {
                        validation.errors.splice(i, 1);
                        return;
                    }
                }
            };
            FlsCompanionController = __decorate([
                QMC.Controller('QMC.Fachleistung', 'FlsCompanionController'),
                QMC.Inject('$location', 'FachleistungService', '$qui', '$scope', '$stateParams', '$state', 'UserService', 'QmcPermissionService', 'TerminService', 'QmcLanguageService')
            ], FlsCompanionController);
            return FlsCompanionController;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsDocumentationListController = /** @class */ (function () {
            /**
             * Creates an instance of FlsDocumentationListController.
             * @param {FlsService} flsService
             * @param {Klient.KlientService} clientService
             * @param {any} $scope
             * @param {any} $qui
             * @param {any} $stateParams
             * @param {any} $timeout
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf FlsDocumentationListController
             */
            function FlsDocumentationListController($location, flsService, $scope, $qui, $state, $stateParams, $timeout, userService, permissionService, lng) {
                var _this = this;
                var _a, _b, _c;
                this.$location = $location;
                this.flsService = flsService;
                this.$scope = $scope;
                this.$qui = $qui;
                this.$state = $state;
                this.$timeout = $timeout;
                this.userService = userService;
                this.permissionService = permissionService;
                this.lng = lng;
                this.ui = new QMC.Fachleistung.UserInterface();
                this.page = 0;
                this.isFirstLoad = true;
                this.allowTableExport = false;
                this.pagination = [];
                this.loadingCases = true;
                this.showOnlyOwnCreated = false;
                this.showOnlyOwnCases = false;
                this.deleteReasons = [];
                this.casesMap = [];
                this.caseFilter = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.isLoadingDeleteModal = false;
                this.isDeleteAllowed = false;
                this.showTime = false;
                this.localStorageCacheName = "flsDocuListCache";
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                this.filter = {
                    dateFrom: moment().startOf('month').toDate(),
                    dateTo: moment().endOf('month').toDate(),
                };
                var previousStateCache = localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE);
                if (previousStateCache !== null) {
                    var cachedParams = JSON.parse(previousStateCache);
                    var isBackFromDocumentation = (_a = cachedParams.isBackFromDocumentationDetail) !== null && _a !== void 0 ? _a : false;
                    localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                        state: this.$state.$current.name,
                        params: cachedParams.params
                    }));
                    if (isBackFromDocumentation) {
                        this.filter = {
                            dateFrom: moment((_b = cachedParams.params.dateFrom) !== null && _b !== void 0 ? _b : this.filter.dateFrom).toDate(),
                            dateTo: moment((_c = cachedParams.params.dateTo) !== null && _c !== void 0 ? _c : this.filter.dateTo).toDate(),
                        };
                    }
                }
                else {
                    localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                        state: this.$state.$current.name,
                        params: {}
                    }));
                }
                /* Signature Permissions */
                this.permissionLoading = true;
                permissionService.getPermissionsByObjectTypes([230009, 230003, 230000]).then(function (data) {
                    _this.signaturePermission = {
                        moduleAccess: data[0].moduleAccess,
                        view: data[0].view
                    };
                    _this.delete = data[1].delete;
                    _this.new = data[1].new;
                    _this.modify = data[1].modify;
                    _this.allowTableExport = data[2].print;
                    _this.init();
                    _this.getCases();
                    _this.permissionLoading = false;
                });
                this.userService.getUserSettings(["FLS.SHOWMONTHFILTER", "SHOWTIMEINSTEADOFDECIMAL"]).then(function (data) {
                    _this.ui.showMonthFilter = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS : data[0].value.toLowerCase() === "true";
                    _this.showTime = data[1].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : data[1].value.toLowerCase() === "true";
                });
                this.ui.documentationTable.filter.model = this.tableFilter;
                this.page = 0;
                $scope.$watch('vm.tableFilter', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (_this.isFirstLoad) {
                            setTimeout(function () {
                                _this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            var lastValue_2 = _this.tableFilter;
                            setTimeout(function () {
                                if (_this.tableFilter == lastValue_2) {
                                    _this.page = 0;
                                    _this.getData();
                                }
                            }, 500);
                        }
                    }
                });
                $scope.$watch('vm.page', function (newValue, oldValue) {
                    if (newValue != oldValue)
                        if (_this.isFirstLoad) {
                            setTimeout(function () {
                                _this.isFirstLoad = false;
                            });
                        }
                        else {
                            _this.getData();
                        }
                });
                this.deleteId = QMC.Common.Constants.DELETE_REASON_ID;
                if (QMC.Common.Constants.IS_MOBILE)
                    this.cards = true;
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.events();
            }
            FlsDocumentationListController.prototype.openNewDocu = function () {
                if (this.loadingCases)
                    return;
                if (this.casesMap.length > 0 && this.filter.selectedCaseId && this.filter.selectedCaseId != '' && this.filter.selectedCaseId != QMC.Common.Constants.GUID_EMPTY)
                    this.$state.go("documentationnew", { flsCaseIds: [this.filter.selectedCaseId] });
                else
                    this.$state.go("case");
            };
            /**
             * init the Filter an the signature permissions
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            FlsDocumentationListController.prototype.init = function () {
                //set filter to last parameters
                if (localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_HIDE_SIGNATURE) !== null && this.signaturePermission.view) {
                    this.hideSignature = localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_HIDE_SIGNATURE) === 'true';
                }
                else {
                    this.hideSignature = true;
                }
                if (localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CREATED) !== null)
                    this.showOnlyOwnCreated = localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CREATED) === "true";
                else
                    this.showOnlyOwnCreated = false;
                if (localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CASES) !== null)
                    this.showOnlyOwnCases = localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CASES) === "true";
                else
                    this.showOnlyOwnCases = false;
            };
            /**
             * Register view events
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            FlsDocumentationListController.prototype.events = function () {
                var _this = this;
                if (this.loading || this.loadingCases) {
                    setTimeout(function () { _this.events(); }, 250);
                    return;
                }
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                        state: _this.$state.$current.name,
                        params: _this.filter
                    }));
                    _this.getData();
                });
                this.filterWatcher = this.$scope.$watch('vm.filter.selectedCaseId ', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    localStorage.setItem(_this.localStorageCacheName, _this.filter.selectedCaseId);
                });
            };
            /**
             * Set the filter values to localStorage and get documentations
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            FlsDocumentationListController.prototype.getData = function () {
                this.getDocumenations();
            };
            FlsDocumentationListController.prototype.getDocumenations = function () {
                var _this = this;
                var currentRequest = { dateFrom: this.filter.dateFrom, dateTo: this.filter.dateTo, caseId: this.filter.selectedCaseId, onlySelf: this.showOnlyOwnCreated, onlyCurrent: this.caseFilter.onlyCurrentCases, onlyOwnCases: this.showOnlyOwnCases, tableFilter: this.tableFilter, page: this.page };
                currentRequest.dateFrom = moment(this.filter.dateFrom).startOf('day').toDate();
                currentRequest.dateTo = moment(this.filter.dateTo).endOf('day').toDate();
                if (!this.cases || this.cases.length <= 0 || (JSON.stringify(this.lastRequest) === JSON.stringify(currentRequest))) {
                    return;
                }
                this.lastRequest = currentRequest;
                this.loading = true;
                this.flsService.getFlsDocumentationList(this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, currentRequest.dateFrom, currentRequest.dateTo, currentRequest.caseId, currentRequest.onlySelf, currentRequest.onlyCurrent, currentRequest.onlyOwnCases, currentRequest.tableFilter, this.ui.getDisplayedPropertiesFromSchema(this.ui.documentationTable)).then(function (data) {
                    _this.paginationInfo = data.paginationInfo;
                    _this.ui.documentationTable.totalSums.data = data.additionalData;
                    data.items = data.items.map(function (obj) {
                        if (obj.warning)
                            obj.style = { 'background-color': '#f0ad4e', 'color': 'white' };
                        return obj;
                    }.bind(_this));
                    _this.docs = data;
                    _this.filteredList = angular.copy(data.items);
                    _this.ui.documentationTable.table.Signiert.invisible = _this.hideSignature;
                    _this.ui.documentationTable.data = _this.filteredList;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.isFirstLoad = false;
                    _this.loading = false;
                });
            };
            /**
             * Toggle the visibility of the signature col
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            FlsDocumentationListController.prototype.toggleShowSignature = function () {
                localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_HIDE_SIGNATURE, this.hideSignature.toString());
                this.ui.documentationTable.table.Signiert.invisible = this.hideSignature;
                this.$qui.functionWaiter("ui.createTable", this);
            };
            /**
             * Toggle the visibility of the own created col
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            FlsDocumentationListController.prototype.toggleShowOnlyOwnCreated = function () {
                localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CREATED, this.showOnlyOwnCreated.toString());
                this.getDocumenations();
            };
            /**
             * Toggle the visibility of my own cases col
             *
             * @private
             *
             * @memberOf FlsDocumentationListController
             */
            FlsDocumentationListController.prototype.toggleShowOnlyOwnCases = function () {
                localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_DOCU_LIST_SHOW_ONLY_OWN_CASES, this.showOnlyOwnCases.toString());
                this.getDocumenations();
            };
            /**
             * Show only the current cases
             *
             * @memberOf FlsDocumentationListController
             */
            FlsDocumentationListController.prototype.toggleShowOnlyCurrentCases = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.getCases();
                                this.getDocumenations();
                                return [4 /*yield*/, this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: JSON.stringify(this.caseFilter) }] })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            FlsDocumentationListController.prototype.getCases = function () {
                var _this = this;
                var lastCaseIDFound = false;
                var lastCaseId = localStorage.getItem(this.localStorageCacheName);
                this.loadingCases = true;
                this.flsService.getCasesList('', this.caseFilter.onlyCurrentCases).then(function (data) {
                    if (data.length > 0) {
                        if (lastCaseId == undefined) {
                            _this.filter.selectedCaseId = data[0].objectId;
                        }
                        else if (lastCaseId == '') {
                            _this.filter.selectedCaseId = '';
                        }
                        else if (lastCaseId != (null || undefined) && _this.$qui.isGuid(lastCaseId)) {
                            for (var i = 0; i <= data.length - 1; i++) {
                                if (data[i].objectId == lastCaseId) {
                                    lastCaseId = data[i].objectId;
                                    lastCaseIDFound = true;
                                    break;
                                }
                            }
                            if (!lastCaseIDFound) {
                                _this.filter.selectedCaseId = data[0].objectId;
                            }
                            else {
                                _this.filter.selectedCaseId = lastCaseId;
                            }
                        }
                    }
                    else
                        return;
                    _this.cases = data;
                    _this.casesMap = _this.createCasesMap();
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                    _this.loadingCases = false;
                    _this.$qui.waitForEl('#newClickButton', function () {
                        document.getElementById('newClickButton').style.visibility = 'unset';
                    });
                });
            };
            FlsDocumentationListController.prototype.createCasesMap = function () {
                var _this = this;
                if (!this.cases)
                    return [];
                var casesMap = this.cases.map(function (x) { return _this.$qui.createCaseDisplayObject(x); });
                casesMap.unshift({ value: '', text: this.lng.translate(20000212, '- Alle -') });
                return casesMap;
            };
            FlsDocumentationListController = __decorate([
                QMC.Controller('QMC.Fachleistung', 'FlsDocumentationListController'),
                QMC.Inject('$location', 'FachleistungService', '$scope', '$qui', '$state', '$stateParams', '$timeout', 'UserService', 'QmcPermissionService', 'QmcLanguageService')
            ], FlsDocumentationListController);
            return FlsDocumentationListController;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsDocumentationController = /** @class */ (function () {
            /**
             * Creates an instance of FlsDocumentationController.
             * @param {FlsService} fachleistungService
             * @param {any} $qui
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             * @param {QMC.Klient.KlientService} clientService
             * @param {*} userService
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberof FlsDocumentationController
             */
            function FlsDocumentationController($location, fachleistungService, $qui, $stateParams, $scope, $state, $timeout, clientService, userService, lng, permissionService, markItemService, udfService) {
                var _this = this;
                this.$location = $location;
                this.fachleistungService = fachleistungService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.$timeout = $timeout;
                this.clientService = clientService;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.markItemService = markItemService;
                this.ui = new Fachleistung.UserInterface();
                this.cachingObjectName = 'flsCache-' + $("#session").data().personId;
                this.documentationIds = [];
                this.flsCaseIds = [];
                this.cases = [];
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.isPlaned = false;
                this.isNewDocumentation = false;
                this.isSupportPlanDocu = false;
                this.isGroup = false;
                this.formState = 'new';
                this.requiredFields = null;
                this.maxFutureDays = -1;
                this.hasMaxFutureDays = false;
                this.vehiclesMap = [];
                this.validateEmptyDrivingCost = false;
                this.ignoreConfigRoundInterval = false;
                this.selectedMarkings = [];
                this.accountabilityBoxState = 'close';
                this.standardActivityAllowedIfRequired = false;
                this.showAdditionalCosts = true;
                this.editAdditionalCosts = false;
                this.newAdditionalCosts = false;
                this.deleteAdditionalCosts = false;
                this.showDrivingCosts = true;
                this.isMarkingRequired = false;
                this.allowEmptyReports = true;
                this.isSaving = false;
                this.hideQuickDrivingCost = false;
                this.isManuelTimeVisible = false;
                this.smartAction = new QMC.Common.SmartAction(this.permissionService, this.userService, this.clientService, this.lng, this.$scope);
                this.createSummernote = null;
                this.userSettings = {};
                this.wvCarerDocumentationList = [];
                this.wvlivingAreaList = [];
                this.wvsubLivingAreaList = [];
                this.drivingAddresses = [];
                this.participantsList = [];
                this.carers = [];
                this.carersIds = [];
                this.selectedCarerList = [];
                this.zIndexCarerForm = 9999;
                this.showActivityForFirstCarerOpen = true;
                this.modifiyDescription = false;
                this.additionalFls = false;
                this.additionalFlsEnabled = false;
                this.additionalFlsText = "";
                this.emptyDescription = "";
                this.isReportTemplateFix = false;
                this.form = {
                    workingHours: {
                        abrechenbarkeitId: QMC.Common.Constants.GUID_EMPTY,
                        carerObjectId: QMC.Common.Constants.GUID_EMPTY
                    }
                };
                this.permissions = {};
                this.validation = {
                    errors: [],
                    warnings: []
                };
                this.summaryEntryDays = 0;
                this.editLockType = 'errors';
                this.resetHoursOnManualDuration = false;
                this.enableWarningReason = false;
                this.commentModalState = 'close';
                this.createForm = {
                    timeForm: null,
                    activityForm: null,
                    drivingCostsForm: [],
                    participantsForm: null,
                    additionnalCosts: [],
                };
                this.group = {
                    onlyNumberOfParticipants: false,
                    allowAdditionalExternalParticipants: false,
                    allowAdditionalInternalParticipants: false,
                    members: {
                        employee: [],
                        client: []
                    },
                    data: null,
                };
                this.loading = {
                    documentation: false,
                    case: false,
                    group: false,
                    save: false,
                    validate: false,
                    settings: false,
                    wv: true,
                    wvFirst: true,
                    requieredFields: true,
                    editorSettings: true,
                    templates: false,
                    allLoaded: function () { return !(_this.loading.documentation && _this.loading.case || _this.loading.group); },
                    allLoadersFinished: function () {
                        return !_this.loading.requieredFields && !_this.loading.documentation && !_this.loading.case && !_this.loading.group && !_this.loading.save && !_this.loading.wv && !_this.loading.settings;
                    }
                };
                this.reportForm = {
                    templateId: null,
                    items: [],
                    templates: [],
                    activeReport: null,
                    isReportViewAllowed: true,
                    isReportUpdateAllowed: true,
                    reports: [],
                    normalReportTemplates: [],
                    supportPlanTemplates: []
                };
                this.activityForm = {
                    carerId: null,
                    activityWvId: QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                    contactTypeWvId: null,
                    careTypeWvId: null,
                    miscontactWvId: QMC.Common.Constants.FLS_NO_MISCONTACT,
                    isActivityFix: false,
                    isMiscontactEnabled: false,
                    isMiscontactRequired: false
                };
                this.timeForm = {
                    dateFrom: new Date(),
                    originalTimeFrom: new Date(),
                    dateTo: new Date(),
                    originalTimeTo: new Date(),
                    hours: 0,
                    minutes: 0,
                    distributeHours: QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN,
                    distributeHoursFix: QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX,
                    isManualDuration: false,
                    isManualTimeAllowed: true,
                    isManualTimeRequired: false,
                    isManuelTimeVisible: true,
                    timeString: "",
                    splitString: "",
                    disableTime: false,
                    createDate: new Date(),
                };
                this.participantsForm = {
                    participants: [],
                    participantCount: 0,
                    participantEmployees: []
                };
                this.disableForm = false;
                this.reportTemplates = {
                    normal: [],
                    supportPlan: []
                };
                this.deleteDocu = {
                    deleteItemId: null,
                    deleteReason: null,
                    deleteText: ""
                };
                this.promptOptionsCache = {
                    title: this.lng.translate(20016030, "Fachleistungen"),
                    yesNo: true,
                    icon: "qm-icon-arrow_circle",
                    text: this.lng.translate(20000228, 'Es gibt nicht gespeicherte Änderungen, wollen Sie diese wiederherstellen?'),
                };
                this.promptOptionsTemplateChange = {
                    title: this.lng.translate(20016030, "Fachleistungen"),
                    yesNo: true,
                    icon: "qm-icon-ballpen",
                    text: this.lng.translate(20016175, 'Wenn Sie die Vorlage ändern gehen alle Änderungen verloren, wollen Sie fortfahren?'),
                };
                this.promptOptiondsDeleteDokuWithText = {
                    title: this.lng.translate(20016030, "Fachleistungen"),
                    yesNo: true,
                    icon: "qm-icon-garbage_can",
                    text: this.lng.translate(20016198, 'Achtung: die FLS enthält inhaltliche Dokumentationen im Berichttext. Sind Sie sicher, dass sie die FLS inkl. deren Inhalt unwiderruflich löschen möchten?'),
                };
                this.udfs = [];
                this.activeSupportPlanPhase = null;
                /**
                 * handel view events.
                 *
                 * @private
                 *
                 * @memberof FlsDocumentationController
                 */
                this.ignoreManualTimeOverwrite = false;
                /**
                 * Gets the catalog settings for the cases.
                 */
                this.defaultTimesSet = false;
                /**
                 * set the current report template
                 *
                 * @private
                 * @param {Guid} templateId
                 * @param {Common.IReportTemplateItem[]} template
                 *
                 * @memberof FlsDocumentationController
                 */
                this.dontTriggerReportPrompt = false;
                this.templatePromptOpen = false;
                this.isValidating = false;
                this.validationFailCounter = 0;
                /////////////// Driving COST ///////////////
                this.isDcInit = false;
                /////////////// ElaborativeWarning ///////////////
                this.elaborativeWarning = false;
                this.elaborativeWarningData = {};
                this.isNewDocumentation = $state.current.name !== "documentationdetail";
                if (!this.isNewDocumentation)
                    this.documentationIds = [$state.params.id];
                else {
                    this.flsCaseIds = $stateParams.flsCaseIds.split(',');
                    if ($stateParams.plannedDocumentationId !== undefined && $stateParams !== null)
                        this.documentationIds.push($stateParams.plannedDocumentationId);
                    else
                        this.flsCaseIds.forEach(function () { _this.documentationIds.push(_this.ui.getNewGuid()); });
                }
                this.validation.errors.push("Es wurde noch keine Validierung durchgeführt");
                this.getSmartActionClientAndEmployeeList();
                this.permissions.forbidden = document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true";
                permissionService.getPermissionsByObjectTypes([230000, 230006, 230020, 230021, 230005]).then(function (data) {
                    _this.permissions.delete = data[0].delete && data[0].moduleAccess;
                    _this.permissions.new = data[0].new && data[0].moduleAccess;
                    _this.permissions.modify = data[0].modify && data[0].moduleAccess;
                    _this.permissions.drivingCostModuleAccess = data[1].moduleAccess;
                    _this.handleReportPermission(data[2]);
                    _this.editLockType = data[3].openFile ? 'warnings' : 'errors';
                    if (!_this.isNewDocumentation) {
                        permissionService.getPermissionsForDataset(_this.documentationIds[0], 230020).then(function (dataDS) {
                            _this.handleReportPermission(dataDS[0]);
                        });
                    }
                    _this.showAdditionalCosts = _this.showAdditionalCosts && (data[4].view || data[0].moduleAccess);
                    _this.editAdditionalCosts = data[4].modify;
                    _this.deleteAdditionalCosts = data[4].delete;
                    _this.newAdditionalCosts = data[4].new;
                });
                this.getReportTemplates();
                this.fachleistungService.getFlsRequiredFields().then(function (data) {
                    _this.requiredFields = data;
                    _this.loading.requieredFields = false;
                    var previousStateCache = localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE);
                    if (previousStateCache !== null) {
                        _this.returnState = JSON.parse(previousStateCache);
                        localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                            state: _this.returnState.state,
                            params: _this.returnState.params,
                            isBackFromDocumentationDetail: true
                        }));
                    }
                    else {
                        _this.returnState = {
                            state: "documentation",
                            params: {},
                            isBackFromDocumentationDetail: true
                        };
                    }
                    _this.form.title = _this.lng.translate(20016003, "Dokumentation vom") + " " + moment().format('DD.MM.YYYY') + " (WebClient)";
                    _this.init();
                    if (_this.isNewDocumentation) {
                        _this.isInit = false;
                        _this.form.drivingCost = [];
                        _this.addDrivingCost(null, false);
                        _this.getUserConfig(_this.flsCaseIds);
                        _this.getCases(_this.flsCaseIds);
                        _this.carerActivityForm = [];
                        _this.form.carers = [];
                        _this.getCarers();
                        _this.events();
                    }
                    else {
                        _this.isInit = true;
                        _this.loadDocuWaiter();
                        _this.form.isUpdateAllowed = true;
                        udfService.getUserDefinedFields(230003).then(function (data) {
                            _this.udfs = data.sort(function (a, b) { return a.caption.localeCompare(b.caption); });
                            _this.$scope.$watch('vm.udfs', function (newVal, oldVal) {
                                if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                                    return;
                                _this.webClientValidation();
                            }, true);
                        });
                    }
                });
                $qui.init($qui.getSectionColor("/fls/documentation"), function () {
                    //$qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.bindEvents();
                    $('ul.floating-menu>li>button.floating-menu-open').on('click', function () {
                        if ($(this).find('i').attr('class') === "fa fa-bars")
                            $(this).find('i').attr('class', "fa fa-times");
                        else
                            $(this).find('i').attr('class', "fa fa-bars");
                        $(' ul.floating-menu>li>ul').toggle('display');
                    });
                });
                setTimeout(function () {
                    $('#prompt').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }, 300);
                // wait for all loader having finished to make sure form is initialized
                var loadWatcher = this.$scope.$watch('vm.loading', function () {
                    if (_this.loading.allLoadersFinished() && _this.defaultTimesSet && _this.flsDocumentationEditorSettings && (!_this.isNewDocumentation || (_this.isNewDocumentation && !_this.loading.documentation))) {
                        loadWatcher(); // clear watcher after all things are loaded for the first time
                        setTimeout(function () {
                            _this.isInit = false;
                            _this.events();
                            _this.ignoreManualTimeOverwrite = false;
                            _this.initCache();
                        }, 50);
                    }
                }, true);
                // handle save/delete button visibility for mobile view
                if (this.isMobile) {
                    $(document).scroll(function () {
                        var floatingButtons = true;
                        //only switch button visablity if bottumButtons enter/leave viewport
                        if ((document.getElementById('mobileBottomButtons').getBoundingClientRect().bottom <= (window.innerHeight || document.documentElement.clientHeight)) && floatingButtons) {
                            $('#mobileFloatingButtons').fadeOut();
                            floatingButtons = false;
                        }
                        else {
                            $('#mobileFloatingButtons').fadeIn();
                            floatingButtons = true;
                        }
                    });
                }
                if (this.isGroup) {
                    this.participantsList = this.getParticipantsList();
                }
            }
            FlsDocumentationController.prototype.loadDocuWaiter = function () {
                var _this = this;
                if (this.ui.documentationTimeForm.form[0] && !this.loading.templates)
                    this.getDocumentation(this.documentationIds[0] != undefined && this.documentationIds[0] != QMC.Common.Constants.GUID_EMPTY ? this.documentationIds[0] : this.documentationIds[1]);
                else
                    setTimeout(function () {
                        _this.loadDocuWaiter();
                    }, 250);
            };
            FlsDocumentationController.prototype.handleReportPermission = function (permission) {
                if (!permission.modify) {
                    this.allowEmptyReports = true;
                }
                this.reportForm.isReportUpdateAllowed = permission.modify;
                this.reportForm.isReportViewAllowed = permission.view;
            };
            /**
             * Init of the local storage form cache. This method is to be called after all other initialization is done (including loading existing data)
             *
             * @memberof FlsDocumentationController
             * */
            FlsDocumentationController.prototype.initCache = function () {
                var _this = this;
                var formObject = JSON.parse(window.localStorage.getItem(this.cachingObjectName));
                //check also if the form can be edited, if not there is no reason to show the cache info or to restore the cache info
                //if the form is disabled you cannot save it so no reason for showing the cache
                var t1 = angular.copy(formObject);
                var t2 = this.createCacheObject();
                if (t1)
                    delete t1.documentationIds;
                if (t2)
                    delete t2.documentationIds;
                var cacheEqual = JSON.stringify(t1) === JSON.stringify(t2);
                if (formObject && !cacheEqual && (!this.shouldDisable())
                    && ((this.isNewDocumentation && formObject.isNew) || QMC.Common.Utilities.arraysEqual(this.documentationIds, formObject.documentationIds))
                    && QMC.Common.Utilities.arraysEqual(this.flsCaseIds, formObject.caseIds)) {
                    QMC.Common.Utilities.confirm(this.promptOptionsCache, function (dataCache) {
                        if (dataCache) {
                            _this.ignoreManualTimeOverwrite = true;
                            _this.dontTriggerReportPrompt = true;
                            // form
                            _this.form.title = formObject.form.title;
                            _this.form.additionalCost = formObject.form.additionalCost;
                            _this.form.description = formObject.form.description;
                            if (formObject.form.drivingCost) {
                                _this.form.drivingCost.forEach(function (x) { return _this.deleteDrivingCost(x); });
                                _this.form.drivingCost = [];
                                formObject.form.drivingCost.forEach(function (dc) {
                                    dc.dateOfArrival = _this.$qui.createDateFromString(dc.dateOfArrival);
                                    dc.dateOfDeparture = _this.$qui.createDateFromString(dc.dateOfDeparture);
                                    dc.timeOfArrival = _this.$qui.createDateFromString(dc.timeOfArrival);
                                    dc.timeOfDeparture = _this.$qui.createDateFromString(dc.timeOfDeparture);
                                    _this.addDrivingCost(dc, false);
                                });
                            }
                            _this.form.workingHours = __assign(__assign({}, _this.form.workingHours), formObject.form.workingHours);
                            _this.form.warning = formObject.form.warning;
                            _this.form.plannedDocumentationId = formObject.form.plannedDocumentationId;
                            // time
                            if (formObject.time.dateFrom)
                                formObject.time.dateFrom = _this.$qui.createDateFromString(formObject.time.dateFrom);
                            if (formObject.time.dateTo)
                                formObject.time.dateTo = _this.$qui.createDateFromString(formObject.time.dateTo);
                            formObject.time.isManualDuration = _this.timeForm.isManualTimeAllowed ? formObject.time.isManualDuration || _this.timeForm.isManualTimeRequired : false;
                            _this.timeForm = __assign(__assign({}, _this.timeForm), formObject.time);
                            // report
                            _this.reportForm.templateId = formObject.report.templateId;
                            // carerActivityForm
                            _this.selectedCarerList = formObject.selectedCarerList;
                            // misc
                            _this.isPlaned = formObject.form.plannedDocumentationId ? true : false;
                            _this.form.plannedDocumentationId = formObject.form.plannedDocumentationId;
                            if (_this.isNewDocumentation) {
                                _this.documentationIds = formObject.documentationIds;
                                _this.createCarerActivityForm(_this.selectedCarerList);
                            }
                            _this.activityForm = formObject.activity;
                            _this.participantsForm = formObject.participants;
                            _this.elaborativeWarning = formObject.elaborativeWarning;
                            _this.elaborativeWarningData = __assign(__assign({}, _this.elaborativeWarningData), formObject.elaborativeWarningData);
                            _this.isSupportPlanDocu = formObject.isSupportPlanDocu;
                            setTimeout(function () {
                                var _a, _b, _c;
                                _this.ignoreManualTimeOverwrite = false;
                                _this.dontTriggerReportPrompt = false;
                                _this.setReportContentFromCache(_this.reportForm.reports, formObject.report.reports);
                                if (_this.isNewDocumentation) {
                                    _this.selectReport(_this.reportForm.reports[0]);
                                    var _loop_2 = function (carerId) {
                                        var cachedActivity = formObject.carerActivity.find(function (y) { return y.carerId === carerId; });
                                        var activity = _this.carerActivityForm.filter(function (y) { return y.carerId === carerId; })[0];
                                        if (activity && cachedActivity) {
                                            activity.careTypeWvId = (_a = cachedActivity === null || cachedActivity === void 0 ? void 0 : cachedActivity.careTypeWvId) !== null && _a !== void 0 ? _a : activity.careTypeWvId;
                                            activity.contactTypeWvId = (_b = cachedActivity === null || cachedActivity === void 0 ? void 0 : cachedActivity.contactTypeWvId) !== null && _b !== void 0 ? _b : activity.contactTypeWvId;
                                            activity.activityWvId = (_c = cachedActivity === null || cachedActivity === void 0 ? void 0 : cachedActivity.activityWvId) !== null && _c !== void 0 ? _c : activity.activityWvId;
                                        }
                                    };
                                    for (var _i = 0, _d = _this.selectedCarerList; _i < _d.length; _i++) {
                                        var carerId = _d[_i];
                                        _loop_2(carerId);
                                    }
                                }
                                _this.formatTimeString();
                            }, 1000);
                            _this.initCacheWatcher();
                            _this.validateDocumentation(0);
                        }
                    }, '#promptCache');
                }
                this.initCacheWatcher();
            };
            FlsDocumentationController.prototype.setReportContentFromCache = function (targetArray, sourceArray) {
                var _this = this;
                sourceArray.forEach(function (source) {
                    var target = targetArray.filter(function (x) { return x.objectId === source.objectId; })[0];
                    if (!target)
                        return;
                    target.comment = source.comment;
                    if (target.children && target.children.length && source.children && source.children.length) {
                        _this.setReportContentFromCache(target.children, source.children);
                    }
                });
            };
            FlsDocumentationController.prototype.initCacheWatcher = function () {
                var _this = this;
                setTimeout(function () {
                    _this.$scope.$watch('vm.reportForm', function (newValue, oldValue) { _this.cacheForm(newValue, oldValue); }, true);
                    _this.$scope.$watch('vm.form', function (newValue, oldValue) { _this.cacheForm(newValue, oldValue); }, true);
                    _this.$scope.$watch('vm.timeForm', function (newValue, oldValue) {
                        var oldCopy = angular.copy(oldValue);
                        var newCopy = angular.copy(newValue);
                        // remove calculated display values
                        delete newCopy.durationInHours;
                        delete oldCopy.durationInHours;
                        delete newCopy.timeString;
                        delete newCopy.timeString;
                        delete newCopy.splitString;
                        _this.cacheForm(newCopy, oldCopy);
                    }, true);
                    _this.$scope.$watch('vm.activityForm', function (newValue, oldValue) { _this.cacheForm(newValue, oldValue); }, true);
                    _this.$scope.$watch('vm.participantsForm', function (newValue, oldValue) { _this.cacheForm(newValue, oldValue); }, true);
                    _this.$scope.$watch('vm.selectedCarerList', function (newValue, oldValue) { _this.cacheForm(newValue, oldValue); }, true);
                    _this.$scope.$watch('vm.elaborativeWarning', function (newValue, oldValue) { _this.cacheForm(newValue, oldValue); }, true);
                    _this.$scope.$watch('vm.elaborativeWarningData', function (newValue, oldValue) { _this.cacheForm(newValue, oldValue); }, true);
                    _this.$scope.$watch('vm.carerActivityForm', function (newValue, oldValue) { _this.cacheForm(newValue, oldValue); }, true);
                }, 500);
            };
            FlsDocumentationController.prototype.cacheForm = function (newVal, oldVal) {
                // only update cache if something has changed
                if (!this.defaultTimesSet || newVal === oldVal || JSON.stringify(newVal) === JSON.stringify(oldVal) || !this.timeForm.dateFrom || !this.timeForm.dateTo || isNaN(this.timeForm.dateFrom.getTime()) || isNaN(this.timeForm.dateFrom.getTime()))
                    return;
                // Create new object containing all relevant forms then serialize it into sessionstorage
                window.localStorage.setItem(this.cachingObjectName, JSON.stringify(this.createCacheObject()));
            };
            FlsDocumentationController.prototype.createCacheObject = function () {
                var obj = {
                    form: {
                        title: this.form.title,
                        additionalCost: this.form.additionalCost,
                        description: this.form.description,
                        drivingCost: this.form.drivingCost,
                        workingHours: this.form.workingHours,
                        warning: this.form.warning,
                        plannedDocumentationId: this.form.plannedDocumentationId
                    },
                    report: {
                        reports: this.reportForm.reports,
                        templateId: this.reportForm.templateId
                    },
                    time: {
                        dateFrom: this.timeForm.dateFrom,
                        dateTo: this.timeForm.dateTo,
                        durationInHours: this.timeForm.isManualDuration ? this.hoursMinutesToDecimal(this.timeForm.hours, this.timeForm.minutes) : 0,
                        isManualDuration: this.timeForm.isManualDuration,
                        hours: this.timeForm.hours,
                        minutes: this.timeForm.minutes,
                        distributeHours: this.timeForm.distributeHours
                    },
                    activity: this.activityForm,
                    participants: this.participantsForm,
                    documentationIds: this.documentationIds,
                    caseIds: this.flsCaseIds,
                    isNew: this.isNewDocumentation,
                    selectedCarerList: this.selectedCarerList,
                    elaborativeWarning: this.elaborativeWarning,
                    elaborativeWarningData: this.elaborativeWarningData,
                    carerActivity: [],
                    isSupportPlanDocu: this.isSupportPlanDocu
                };
                if (this.isNewDocumentation)
                    this.carerActivityForm.forEach(function (x) { return obj.carerActivity.push({ carerId: x.carerId, activityWvId: x.activityWvId, contactTypeWvId: x.contactTypeWvId, careTypeWvId: x.careTypeWvId }); });
                obj.form.drivingCost.forEach(function (dc) { delete dc.watcherList; delete dc.$$hashKey; });
                obj.report.reports.forEach(function (dc) { delete dc.$$hashKey; });
                return obj;
            };
            /**
            * Init default values, check for data in the localStorage.
            *
            * @private
            *
            * @memberof FlsDocumentationController
            */
            FlsDocumentationController.prototype.init = function () {
                var _a;
                this.isInit = true;
                if (this.$stateParams.plannedDocumentationId !== undefined)
                    this.form.plannedDocumentationId = this.$stateParams.plannedDocumentationId;
                var flsObject = localStorage.getItem('flsObject') ? JSON.parse(localStorage.getItem('flsObject')) : undefined;
                if (flsObject && this.form.plannedDocumentationId !== undefined) {
                    this.isPlaned = true;
                    if (this.$stateParams.flsCaseIds === flsObject.flsCaseId) {
                        this.timeForm.dateFrom = this.$qui.createDateFromString(flsObject.dateFrom);
                        this.timeForm.dateTo = this.$qui.createDateFromString(flsObject.dateTo);
                    }
                    else {
                        this.timeForm.dateFrom = new Date();
                        this.timeForm.dateTo = moment().add(2, 'hours').toDate();
                    }
                    this.form.description = flsObject.description;
                    this.selectedCarerList = [(_a = flsObject.carerId) !== null && _a !== void 0 ? _a : $('#session').data().personId];
                }
                if (this.isGroup)
                    this.form.participantCount = 0;
            };
            /**
             * Create the forms, create events
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.initForm = function () {
                var _this = this;
                if (this.requiredFields) {
                    this.ui.documentationActivityForm.form[0].required = this.requiredFields.workingHours.activityWvId;
                    this.ui.documentationActivityForm.form[1].required = this.requiredFields.workingHours.activityWvId;
                    this.ui.documentationActivityForm.form[2].required = this.requiredFields.workingHours.contactTypeWvId;
                    this.ui.documentationActivityForm.form[3].required = this.requiredFields.workingHours.careTypeWvId;
                    this.ui.documentationActivityForm.form[5].required = this.requiredFields.workingHours.miscontactWvId;
                    this.ui.documentationActivityForm.form[6].required = this.requiredFields.workingHours.miscontactWvId;
                }
                this.$qui.functionWaiter("createForm.activityForm", this);
                this.$qui.functionWaiter("createForm.timeForm", this);
                if (this.isNewDocumentation)
                    this.isInit = false;
                setTimeout(function () {
                    _this.events();
                }, 1000);
            };
            FlsDocumentationController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.reportForm.templateId', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.getReportTemplateItems(_this.reportForm.templateId);
                });
                this.$scope.$watch('vm.timeForm.dateFrom', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    //this setting should be applied only for new entries and in case of saved entries after the user changes the date from/to
                    _this.ui.documentationTimeForm.form[0].config.roundInterval = _this.configRoundInterval;
                    _this.ui.documentationTimeForm.form[0].config.startRoundType = _this.configStartRoundType;
                    _this.ui.documentationTimeForm.form[0].config.endRoundType = _this.configEndRoundType;
                    _this.ignoreConfigRoundInterval = false;
                    if ((moment(_this.timeForm.dateFrom).toDate().getTime() === moment(_this.timeForm.originalTimeFrom).toDate().getTime()) &&
                        (moment(_this.timeForm.dateTo).toDate().getTime() === moment(_this.timeForm.originalTimeTo).toDate().getTime())) {
                        _this.ignoreConfigRoundInterval = true;
                    }
                    _this.getWv(_this.flsCaseIds, _this.documentationIds[0]);
                    _this.getCatalogSettings();
                    if (_this.ignoreManualTimeOverwrite || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    if (!_this.isInit) {
                        _this.validateDocumentation();
                        if (_this.form.drivingCost) {
                            for (var _i = 0, _a = _this.form.drivingCost; _i < _a.length; _i++) {
                                var cost = _a[_i];
                                if (!isNaN(_this.timeForm.dateFrom.valueOf())) {
                                    if (!cost.dateOfDeparture)
                                        cost.dateOfDeparture = angular.copy(_this.timeForm.dateFrom);
                                }
                            }
                        }
                    }
                });
                this.$scope.$watch('vm.timeForm.dateTo', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(oldVal) || _this.isInit)
                        return;
                    //this setting should be applied only for new entries and in case of saved entries after the user changes the date from/to
                    _this.ui.documentationTimeForm.form[0].config.roundInterval = _this.configRoundInterval;
                    _this.ui.documentationTimeForm.form[0].config.startRoundType = _this.configStartRoundType;
                    _this.ui.documentationTimeForm.form[0].config.endRoundType = _this.configEndRoundType;
                    _this.ignoreConfigRoundInterval = false;
                    if ((moment(_this.timeForm.dateFrom).toDate().getTime() === moment(_this.timeForm.originalTimeFrom).toDate().getTime()) &&
                        (moment(_this.timeForm.dateTo).toDate().getTime() === moment(_this.timeForm.originalTimeTo).toDate().getTime())) {
                        _this.ignoreConfigRoundInterval = true;
                    }
                    if (_this.ignoreManualTimeOverwrite || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.validateDocumentation();
                });
                this.$scope.$watch('vm.timeForm.isManualDuration', function (newVal, oldVal) {
                    if (_this.ignoreManualTimeOverwrite || JSON.stringify(newVal) === JSON.stringify(oldVal) || _this.isInit)
                        return;
                    if (_this.resetHoursOnManualDuration && _this.timeForm.isManualDuration) {
                        _this.timeForm.disableTime = true;
                        _this.timeForm.dateFrom = moment(_this.timeForm.dateFrom).startOf('day').toDate();
                        _this.timeForm.dateTo = moment(_this.timeForm.dateTo).startOf('day').toDate();
                    }
                    else {
                        _this.timeForm.disableTime = false;
                        if (_this.resetHoursOnManualDuration) {
                            _this.timeForm.dateFrom = moment(_this.timeForm.dateFrom).startOf('day').add(_this.flsDocumentationEditorSettings.defaultHour, 'h').toDate();
                            _this.timeForm.dateTo = moment(_this.timeForm.dateFrom).add(_this.ui.convertHours(_this.timeForm.hours, _this.timeForm.minutes), 'h').toDate();
                        }
                    }
                    _this.validateDocumentation();
                    if (_this.timeForm.isManualDuration && !_this.ignoreManualTimeOverwrite) {
                        var conv = _this.$qui.convertDec(_this.timeForm.durationInHours);
                        _this.timeForm.hours = conv[0];
                        _this.timeForm.minutes = conv[1];
                    }
                });
                this.$scope.$watch('vm.timeForm.distributeHours', function (newVal, oldVal) {
                    _this.formatTimeString();
                    if (_this.ignoreManualTimeOverwrite || newVal === oldVal)
                        return;
                    if (_this.timeForm.distributeHours && _this.timeForm.isManualTimeAllowed)
                        _this.timeForm.isManualDuration = false;
                    _this.validateDocumentation();
                });
                this.$scope.$watch('vm.timeForm.hours', function (newVal, oldVal) {
                    if (_this.ignoreManualTimeOverwrite || newVal === oldVal)
                        return;
                    _this.manualTimeWatch();
                    _this.formatTimeString();
                    _this.timeForm.durationInHours = _this.hoursMinutesToDecimal(_this.timeForm.hours, _this.timeForm.minutes);
                    _this.$qui.scopeApply(_this.$scope);
                }, true);
                this.$scope.$watch('vm.timeForm.minutes', function (newVal, oldVal) {
                    if (_this.ignoreManualTimeOverwrite || newVal === oldVal)
                        return;
                    _this.manualTimeWatch();
                    _this.formatTimeString();
                    _this.timeForm.durationInHours = _this.hoursMinutesToDecimal(_this.timeForm.hours, _this.timeForm.minutes);
                    _this.$qui.scopeApply(_this.$scope);
                }, true);
                this.$scope.$watch('vm.timeForm.durationInHours', function (newVal, oldVal) {
                    if (_this.ignoreManualTimeOverwrite || newVal === oldVal)
                        return;
                    _this.formatTimeString();
                    if (_this.timeForm.isManualDuration && !_this.ignoreManualTimeOverwrite) {
                        var conv = _this.$qui.convertDec(_this.timeForm.durationInHours);
                        _this.timeForm.hours = conv[0];
                        _this.timeForm.minutes = conv[1];
                    }
                    _this.$qui.scopeApply(_this.$scope);
                }, true);
                this.$scope.$watch('vm.form.workingHours.abrechenbarkeitId', function () { _this.validateDocumentation(); });
                this.$scope.$watch('vm.activityForm.careTypeWvId', function () { _this.validateDocumentation(); });
                this.$scope.$watch('vm.activityForm.activityWvId', function () { _this.validateDocumentation(); });
                this.$scope.$watch('vm.activityForm.contactTypeWvId', function () { _this.validateDocumentation(); });
                this.$scope.$watch('vm.activityForm.miscontactWvId', function () { _this.validateDocumentation(); });
                this.$scope.$watch('vm.activityForm.isMiscontactEnabled', function () { _this.validateDocumentation(); });
                this.$scope.$watch('vm.participantsForm.participantsCount', function () { _this.validateDocumentation(); });
                this.$scope.$watch('vm.reportForm.templateId', function () { _this.webClientValidation(); });
                this.$scope.$watch('vm.selectedMarkings', function () { _this.webClientValidation(); });
                this.$scope.$watch('vm.selectedCarerList', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    //make sure list entries are unique!
                    if (_this.selectedCarerList && _this.selectedCarerList.length > 0) {
                        var seen_1 = {};
                        var withoutDubs = _this.selectedCarerList.filter(function (item) {
                            return seen_1.hasOwnProperty(item) ? false : (seen_1[item] = true);
                        });
                        if (withoutDubs.length !== _this.selectedCarerList.length) {
                            _this.selectedCarerList = withoutDubs;
                            return;
                        }
                    }
                    if (!_this.isInit && _this.selectedCarerList.length > 0) {
                        _this.getWv(_this.flsCaseIds, _this.documentationIds[0]);
                    }
                    else if (!_this.isInit && _this.selectedCarerList.length === 0) {
                        //when the last carer is removed, remove also his activity form
                        _this.createCarerActivityForm(_this.selectedCarerList);
                        _this.lastWvGetRequest = "";
                    }
                    //always validate for getting also the error when no carer is selected
                    _this.webClientValidation();
                });
                if (!this.allowEmptyReports) {
                    this.$scope.$watch('vm.reportForm.activeReport.comment', function (newValue, oldValue) {
                        if (newValue === oldValue)
                            return;
                        _this.webClientValidation();
                    });
                }
                this.createTypeAhead();
            };
            FlsDocumentationController.prototype.manualTimeWatch = function () {
                if (!this.timeForm.isManualDuration)
                    return;
                var hours = this.cleanInputNumber(this.timeForm.hours);
                var minutes = this.cleanInputNumber(this.timeForm.minutes);
                while (minutes >= 60) {
                    minutes = minutes - 60;
                    hours = hours + 1;
                }
                if (this.restrictDaysOnManualDuration) {
                    var dayCount = Math.max(1, Math.ceil(Math.abs(this.timeForm.dateFrom.getTime() - this.timeForm.dateTo.getTime()) / 8.64e7));
                    if (hours >= dayCount * 24) {
                        hours = dayCount * 24;
                        minutes = 0;
                    }
                }
                this.timeForm.hours = hours;
                this.timeForm.minutes = minutes;
                this.validateDocumentation();
            };
            FlsDocumentationController.prototype.formatTimeString = function () {
                var _a;
                var time = (_a = (this.timeForm.isManualDuration ? this.hoursMinutesToDecimal(this.timeForm.hours, this.timeForm.minutes) : this.timeForm.durationInHours)) !== null && _a !== void 0 ? _a : 0;
                var splittedTime = time / (this.cases.length > 0 ? this.cases.length : 1);
                if (this.showTime) {
                    this.timeForm.timeString = this.getTimeStringFromDecimal(time);
                    this.timeForm.splitString = this.lng.translate(20016194, 'Entspricht pro Fall') + ': ' + this.getTimeStringFromDecimal(splittedTime);
                }
                else {
                    this.timeForm.timeString = time.toFixed(2).toString().replace('.', ',');
                    this.timeForm.splitString = this.lng.translate(20016194, 'Entspricht pro Fall') + ': ' + splittedTime.toFixed(2).toString().replace('.', ',');
                }
                if (this.flsCaseIds.length < 2 || !this.timeForm.distributeHours) {
                    this.timeForm.splitString = "";
                }
            };
            FlsDocumentationController.prototype.getTimeStringFromDecimal = function (time) {
                var conv = this.$qui.convertDec(time);
                var minutes = conv[1].toString();
                if (conv[1] < 10)
                    minutes = "0" + minutes;
                return conv[0] + ":" + minutes;
            };
            FlsDocumentationController.prototype.cleanInputNumber = function (inputNumber) {
                //remove commas and leading minus characters and
                //possibility to remove content of input box completely
                if (isNaN(inputNumber)) {
                    inputNumber = 0;
                }
                //kill leading zeros
                inputNumber = +inputNumber;
                return Math.round(inputNumber);
            };
            FlsDocumentationController.prototype.hoursMinutesToDecimal = function (hours, minutes) {
                return (hours !== null && hours !== void 0 ? hours : 0) + ((minutes !== null && minutes !== void 0 ? minutes : 0) / 60);
            };
            FlsDocumentationController.prototype.createTypeAhead = function () {
                var vm = this;
                $('#departure .typeahead').typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        process(vm.drivingAddresses.map(function (obj) {
                            return obj.value;
                        }));
                    },
                    updater: function (item) {
                        return item;
                    }
                });
                $('#destination .typeahead').typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        process(vm.drivingAddresses.map(function (obj) {
                            return obj.value;
                        }));
                    },
                    updater: function (item) {
                        return item;
                    }
                });
            };
            FlsDocumentationController.prototype.getUserConfig = function (caseIds) {
                var _this = this;
                if (this.userConfig || this.loading.settings) {
                    return;
                }
                var load = 0;
                this.loading.settings = true;
                this.fachleistungService.getDocEndingConfirmForFlsCase(caseIds[0]).then(function (data) {
                    var lockDate = _this.$qui.createDateFromString(data.lockDate);
                    if (data.hasLockDate) {
                        _this.userSettings.isLockedByDate = true;
                        _this.userSettings.lockDate = moment(lockDate).add(1, 'days').toDate();
                        _this.ui.documentationTimeForm.form[0].startDate = moment(lockDate).add(1, 'days').toDate();
                    }
                    load++;
                    _this.loading.settings = load < 4;
                });
                this.userService.getUserSettings(["FLS.SHOWDATETO", "SHOWTIMEINSTEADOFDECIMAL", "FLS.ADDITIONAL_TIMELESS_ENTRY", "FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT", "FLS.DOCUSUMMARYITEMS", "FLS.HIDE_QUICK_DRIVINGCOST", "FLS.ZEITPLANUNG.ALLOW_MANUELLEZEITENDEUHRZEIT", "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER"]).then(function (data) {
                    _this.userSettings.dateToEnabled = $.grep(data, function (e) { return e.key === "FLS.SHOWDATETO"; })[0].value === "true";
                    _this.ui.documentationTimeForm.form[0].config.displayDateTo = _this.userSettings.dateToEnabled;
                    _this.showTime = $.grep(data, function (e) { return e.key === "SHOWTIMEINSTEADOFDECIMAL"; })[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : $.grep(data, function (e) { return e.key === "SHOWTIMEINSTEADOFDECIMAL"; })[0].value.toLowerCase() === "true";
                    _this.additionalFlsEnabled = $.grep(data, function (e) { return e.key === "FLS.ADDITIONAL_TIMELESS_ENTRY"; })[0].value === "true";
                    _this.additionalFlsText = _this.additionalFlsEnabled ? $.grep(data, function (e) { return e.key === "FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT"; })[0].value : "";
                    _this.additionalFls = _this.additionalFlsEnabled;
                    _this.summaryEntryDays = $.grep(data, function (e) { return e.key === "FLS.DOCUSUMMARYITEMS"; })[0].value === "" ? 0 : parseInt(data[4].value);
                    _this.hideQuickDrivingCost = $.grep(data, function (e) { return e.key === "FLS.HIDE_QUICK_DRIVINGCOST"; })[0].value.toLowerCase() === "true";
                    load++;
                    _this.loading.settings = load < 4;
                });
                this.userService.getUserSettings(["FLS.ZEITPLANUNG.ALLOW_MANUELLEZEITENDEUHRZEIT", "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER"], false).then(function (data) {
                    _this.isManuelTimeVisible = $.grep(data, function (e) { return e.key === "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER"; })[0].value.toLowerCase() === "true";
                    var allowManual = $.grep(data, function (e) { return e.key === "FLS.ZEITPLANUNG.ALLOW_MANUELLEZEITENDEUHRZEIT"; })[0].value.toLowerCase() === "true";
                    _this.timeForm.isManuelTimeVisible = _this.isManuelTimeVisible;
                    _this.timeForm.isManualTimeAllowed = _this.isManuelTimeVisible && allowManual;
                    load++;
                    _this.loading.settings = load < 4;
                });
                this.fachleistungService.getUserConfig().then(function (data) {
                    var _a;
                    _this.userConfig = data;
                    if (_this.flsCaseIds.length > 1 && data.multipleCasesDistributeTime) {
                        _this.timeForm.distributeHours = true;
                        _this.timeForm.isManualDuration = true;
                    }
                    else
                        _this.timeForm.distributeHours = false;
                    _this.timeForm.distributeHoursFix = data.multipleCasesDistributeTimeFix;
                    _this.resetHoursOnManualDuration = data.multipleCasesResetOnDistributeTime;
                    _this.restrictDaysOnManualDuration = data.restrictDaysOnManualDuration;
                    _this.validateEmptyDrivingCost = data.allowEmptyDrivingCost;
                    if (data.defaultReportTitleType === 1 && _this.isNewDocumentation)
                        _this.form.title = "";
                    if (data.defaultReportTitleType === 2 && _this.isNewDocumentation)
                        _this.form.title = data.defaultReportTitle;
                    _this.defaultActivities = {
                        careType: data.defaultCareType,
                        contactType: data.defaultContactType,
                        activityType: data.defaultActivityType
                    };
                    if (data.drivingCostOverlapCheck !== 'fe55229f-b052-4d3a-b2d1-e127b0d08879') {
                        _this.$scope.$watch('vm.form.drivingCost', function (newValue, oldValue) {
                            if (newValue === oldValue || !newValue)
                                return;
                            _this.validateDocumentation();
                        }, true);
                    }
                    _this.enableWarningReason = data.enableWarningReason;
                    var endDate = moment().add(data.daysAllowedCreatingReportsForFuture, 'days').toDate();
                    var startDate = moment().subtract(data.daysAllowedCreatingReportsForPast, 'days').toDate();
                    if (!_this.isNewDocumentation) {
                        startDate = moment(_this.timeForm.createDate).subtract(data.daysAllowedCreatingReportsForPast, 'days').toDate();
                    }
                    _this.hasMaxFutureDays = data.isLockedCreatingForFuture;
                    _this.maxFutureDays = data.daysAllowedCreatingReportsForFuture;
                    if ((data.isLockedCreatingForPast && _this.editLockType === 'errors') && (_this.ui.documentationTimeForm.form[0].startDate < startDate || _this.ui.documentationTimeForm.form[0].startDate === null)) {
                        _this.ui.documentationTimeForm.form[0].startDate = moment(startDate).startOf('day').toDate();
                    }
                    if (data.isLockedCreatingForFuture && _this.editLockType === 'errors')
                        _this.ui.documentationTimeForm.form[0].endDate = moment(endDate).endOf('day').toDate();
                    _this.timeForm.isManualTimeRequired = data.isManualTimeRequired;
                    _this.timeForm.isManualTimeAllowed = data.allowManualTimes || data.isManualTimeRequired;
                    if (!_this.timeForm.isManualTimeAllowed) {
                        if (!_this.isNewDocumentation && _this.timeForm.isManualDuration) {
                            var prevDur_1 = _this.timeForm.durationInHours;
                            setTimeout(function () {
                                _this.timeForm.durationInHours = prevDur_1;
                            }, 250);
                        }
                        _this.timeForm.isManualDuration = false;
                    }
                    else if (_this.isNewDocumentation) {
                        _this.timeForm.isManualDuration = data.manualTimeDefault;
                    }
                    _this.showAdditionalCosts = _this.showAdditionalCosts && data.showAdditionalCosts;
                    _this.showDrivingCosts = data.showDrivingCosts;
                    _this.isMarkingRequired = data.isMarkingRequired;
                    _this.allowEmptyReports = data.allowEmptyReports;
                    _this.form.warning = (_a = _this.form.warning) !== null && _a !== void 0 ? _a : false;
                    _this.initForm();
                    _this.formatTimeString();
                    load++;
                    _this.loading.settings = load < 4;
                });
            };
            FlsDocumentationController.prototype.getCurrentGenericWvList = function () {
                var _a;
                return this.wvList ? this.wvList : (_a = this.wvCarerDocumentationList[0]) === null || _a === void 0 ? void 0 : _a.documentationCarerWvModel;
            };
            FlsDocumentationController.prototype.setUpdateAllowedOnDescriptionChange = function () {
                this.modifiyDescription = true;
            };
            FlsDocumentationController.prototype.isCommentEditAllowed = function () {
                return this.isNewDocumentation || this.form.isUpdateAllowed || this.editLockType === 'warnings';
            };
            /**
             * Get a single documentation by id
             *
             * @private
             * @param {Guid} id
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.getDocumentation = function (id) {
                var _this = this;
                this.loading.documentation = true;
                this.fachleistungService.getFlsDocumentation(id).then(function (data) {
                    var _a;
                    var _b;
                    _this.carersIds = [];
                    _this.carersIds.push(data.isGroupDocumentation ? $('#session').data().personId : data.workingHours.carerObjectId);
                    _this.flsCaseIds = [data.flsCaseId];
                    _this.getCases(_this.flsCaseIds);
                    _this.getUserConfig(_this.flsCaseIds);
                    _this.formState = "detail";
                    _this.form = data;
                    _this.form.warning = (_b = data.warning) !== null && _b !== void 0 ? _b : false;
                    _this.isSupportPlanDocu = data.isSupportPlanDocu;
                    _this.form.dateFrom = _this.$qui.createDateFromString(data.dateFrom);
                    _this.form.dateTo = _this.$qui.createDateFromString(data.dateTo);
                    _this.form.isUpdateAllowed = data.isUpdateAllowed;
                    if (_this.form.description != null && _this.strip(_this.form.description).length > 0)
                        _this.commentModalState = 'open';
                    if (_this.form.dateFrom.getDay() !== _this.form.dateTo.getDay())
                        _this.ui.documentationTimeForm.form[0].config.dateToEnabled = true;
                    var hours = 0, minutes = 0;
                    if (data.workingHours.isManualDuration) {
                        hours = parseInt(data.workingHours.durationInHours.toString().split('.')[0]);
                        minutes = Math.round((data.workingHours.durationInHours - hours) * 60);
                    }
                    _this.ignoreManualTimeOverwrite = true;
                    _this.timeForm = {
                        dateFrom: _this.$qui.createDateFromString(data.dateFrom),
                        dateTo: _this.$qui.createDateFromString(data.dateTo),
                        originalTimeFrom: _this.$qui.createDateFromString(data.dateFrom),
                        originalTimeTo: _this.$qui.createDateFromString(data.dateTo),
                        hours: hours,
                        minutes: minutes,
                        distributeHours: QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN,
                        distributeHoursFix: QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX,
                        isManualDuration: data.workingHours.isManualDuration,
                        isManualTimeAllowed: _this.timeForm.isManualTimeAllowed || _this.timeForm.isManualTimeRequired,
                        isManuelTimeVisible: _this.timeForm.isManuelTimeVisible,
                        timeString: "",
                        splitString: "",
                        durationInHours: data.workingHours.durationInHours,
                        disableTime: false,
                        createDate: _this.$qui.createDateFromString(data.createDate),
                        isManualTimeRequired: _this.timeForm.isManualTimeRequired
                    };
                    _this.formatTimeString();
                    _this.getCatalogSettings();
                    _this.getWv(_this.flsCaseIds, id);
                    if (_this.form.reports) {
                        _this.dontTriggerReportPrompt = true;
                        _this.reportForm.isReportViewAllowed = data.isReportViewAllowed;
                        _this.reportForm.isReportUpdateAllowed = data.isReportUpdateAllowed;
                        if (_this.form.reportTemplateId) {
                            _this.reportForm.templateId = _this.form.reportTemplateId;
                            _this.getReportTemplateItems(_this.form.reportTemplateId, data.isSupportPlanDocu, true);
                        }
                        else {
                            _this.reportForm.templateId = null;
                        }
                        _this.reportForm.reports = data.reports;
                        _this.isReportEntryCommented(_this.reportForm.reports);
                        if ((!_this.reportForm.reports || _this.reportForm.reports.length <= 0) && (!_this.reportForm.activeReport || _this.reportForm.activeReport.comment === "")) {
                            _this.reportForm.reports = [];
                            if (_this.reportForm.templates && _this.reportForm.templates.length > 0)
                                _this.selectDefaultTemplate();
                        }
                        setTimeout(function () {
                            _this.dontTriggerReportPrompt = false;
                        }, 1000);
                    }
                    if (!data.isReportUpdateAllowed) {
                        $('#changeTemplate').attr('disabled', 'disabled');
                    }
                    if (!data.isReportViewAllowed) {
                        $('#reportBox').remove();
                    }
                    if (_this.form.workingHours) {
                        _this.activityForm = {
                            carerId: data.authorPersonObjectId,
                            activityWvId: data.workingHours.activityWvId,
                            careTypeWvId: data.workingHours.careTypeWvId,
                            contactTypeWvId: data.workingHours.contactTypeWvId,
                            miscontactWvId: data.workingHours.miscontactWvId,
                            isActivityFix: _this.activityForm.isActivityFix,
                            isMiscontactEnabled: _this.requiredFields.workingHours.miscontactWvId || data.workingHours.miscontactWvId && data.workingHours.miscontactWvId !== QMC.Common.Constants.FLS_NO_MISCONTACT,
                            isMiscontactRequired: _this.requiredFields.workingHours.miscontactWvId
                        };
                    }
                    ;
                    if (_this.form.drivingCost === null)
                        _this.form.drivingCost = [];
                    for (var _i = 0, _c = _this.form.drivingCost; _i < _c.length; _i++) {
                        var element = _c[_i];
                        var hours_1 = void 0, minutes_1 = void 0;
                        _a = _this.$qui.convertDec(element.duration), hours_1 = _a[0], minutes_1 = _a[1];
                        element.hours = hours_1;
                        element.minutes = minutes_1;
                        element.dateOfDeparture = element.dateOfDeparture != null ?
                            _this.$qui.createDateFromString(element.dateOfDeparture) :
                            _this.$qui.createDateFromString(_this.timeForm.dateFrom);
                        element.timeOfDeparture = element.dateOfDeparture != null ?
                            _this.$qui.createDateFromString(element.dateOfDeparture) :
                            _this.$qui.createDateFromString(_this.timeForm.dateFrom);
                        element.dateOfArrival = element.dateOfArrival != null ?
                            _this.$qui.createDateFromString(element.dateOfArrival) :
                            _this.$qui.createDateFromString(_this.timeForm.dateTo);
                        element.timeOfArrival = element.dateOfArrival != null ?
                            _this.$qui.createDateFromString(element.dateOfArrival) :
                            _this.$qui.createDateFromString(_this.timeForm.dateFrom);
                        var arrivalTime = _this.$qui.createDateFromString(element.dateOfDeparture);
                        arrivalTime.setHours(arrivalTime.getHours() + hours_1);
                        if (_this.$qui.createDateFromString(arrivalTime.getTime() + minutes_1 * 60000) != element.timeOfArrival) {
                            element.timeOfArrival = _this.$qui.createDateFromString(arrivalTime.getTime() + minutes_1 * 60000);
                        }
                        element.isCarPool = element.drivingCostType === 1;
                        element.isPrivate = element.drivingCostType === 0;
                        element.synchronize = false;
                        element.isBlocked = element.isCarPool;
                    }
                    _this.addDrivingCost(null, _this.form.drivingCost.length > 0);
                    if (_this.form.drivingCost[0] && _this.form.drivingCost[0].mileageArrival === 0) {
                        _this.updateMileage(_this.form.drivingCost[0], 'distance');
                    }
                    if (data.isGroupDocumentation) {
                        if (data.participants)
                            _this.participantsForm.participants = data.participants.filter(function (x) { return !x.isEmployee; }).map(function (x) { return (x.objectId); });
                        if (data.participants)
                            _this.participantsForm.participantEmployees = data.participants.filter(function (x) { return x.isEmployee; }).map(function (x) { return (x.objectId); });
                        _this.participantsForm.participantCount = data.participantCount;
                        _this.isGroup = true;
                    }
                    _this.elaborativeWarning = data.warning && Object.keys(data.warningReasons).length > 0;
                    _this.elaborativeWarningData = _this.getInternalElobaritveWarningObject(data.warningReasons);
                    _this.isReportTemplateFix = data.isReportTemplateFix;
                    _this.defaultReportTemplateId = data.reportTemplateId && data.reportTemplateId !== QMC.Common.Constants.GUID_EMPTY ? data.reportTemplateId : _this.defaultReportTemplateId;
                    if (_this.defaultReportTemplateId)
                        _this.reportForm.templateId = data.reportTemplateId;
                    setTimeout(function () {
                        _this.loading.documentation = false;
                        _this.timeForm.hours = hours;
                        _this.timeForm.minutes = minutes;
                    }, 500);
                });
            };
            /**
             * get the current fls cases
             *
             * @private
             * @param {Guid[]} caseIds
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.getCases = function (caseIds) {
                var _this = this;
                this.loading.case = true;
                this.fachleistungService.getFlsCases(caseIds).then(function (data) {
                    var _a, _b;
                    _this.cases = data;
                    for (var _i = 0, data_3 = data; _i < data_3.length; _i++) {
                        var element = data_3[_i];
                        _this.participantsList.push(element.clientObjectId);
                    }
                    if (_this.flsCaseIds.length === 1) {
                        if (_this.formState === 'new') {
                            _this.form.workingHours.abrechenbarkeitId = data[0].defaultAccountableRuleId;
                            _this.form.referencedPersonId = data[0].clientObjectId;
                        }
                        _this.permissions.isAccountableRuleFix = data[0].isAccountableRuleFix;
                    }
                    else {
                        _this.permissions.isAccountableRuleFix = true;
                        _this.form.workingHours.abrechenbarkeitId = QMC.Common.Constants.GUID_EMPTY;
                        for (var _c = 0, data_4 = data; _c < data_4.length; _c++) {
                            var element = data_4[_c];
                            _this.permissions.isAccountableRuleFix = _this.permissions.isAccountableRuleFix && element.isAccountableRuleFix;
                            if (!element.isAccountableRuleFix && (!_this.form.workingHours.abrechenbarkeitId || _this.form.workingHours.abrechenbarkeitId === QMC.Common.Constants.GUID_EMPTY))
                                _this.form.workingHours.abrechenbarkeitId = element.defaultAccountableRuleId;
                        }
                    }
                    // open accountability box if no rule is selected, DA-2941
                    if (_this.isNewDocumentation && (!_this.form.workingHours.abrechenbarkeitId || _this.form.workingHours.abrechenbarkeitId === QMC.Common.Constants.GUID_EMPTY)) {
                        _this.$qui.waitForEl('#accountabilityBox', function () {
                            _this.accountabilityBoxState = 'open';
                        });
                    }
                    // Group Stuff.
                    _this.isGroup = data[0].isGroup && data[0].isServiceBaseTypeGroup;
                    if (_this.isGroup) {
                        _this.getGroup(data[0].clientObjectId);
                        _this.getCatalogSettings();
                    }
                    if (caseIds.length === 1)
                        _this.getSupportPlanTargetTemplates(data[0].clientObjectId);
                    _this.loading.case = false;
                    // Check if any case is paused
                    _this.pausedCases = [];
                    _this.fachleistungService.getFlsCasePaused(caseIds).then(function (pauseData) {
                        for (var _i = 0, _a = _this.cases; _i < _a.length; _i++) {
                            var curCase = _a[_i];
                            if (pauseData[curCase.objectId]) {
                                _this.pausedCases.push(curCase);
                            }
                        }
                        if (_this.pausedCases.length > 0) {
                            $('#casePausedModal').modal('show');
                        }
                    });
                    // reporttemplate preselection by case
                    if (_this.isNewDocumentation) {
                        _this.isReportTemplateFix = data.some(function (x) { return x.isReportTemplateFix; });
                        if (_this.isReportTemplateFix)
                            _this.defaultReportTemplateId = (_a = data.filter(function (x) { return x.reportTemplateId && x.reportTemplateId !== QMC.Common.Constants.GUID_EMPTY && x.isReportTemplateFix; })[0]) === null || _a === void 0 ? void 0 : _a.reportTemplateId;
                        else
                            _this.defaultReportTemplateId = (_b = data.filter(function (x) { return x.reportTemplateId && x.reportTemplateId !== QMC.Common.Constants.GUID_EMPTY; })[0]) === null || _b === void 0 ? void 0 : _b.reportTemplateId;
                        if (_this.defaultReportTemplateId)
                            _this.reportForm.templateId = _this.defaultReportTemplateId;
                    }
                }).catch(function () {
                    _this.$qui.notify({
                        message: _this.lng.translate(20002066, "Der gewählte Fall steht nicht mehr zur Verfügung, die Planung kann nicht editiert oder dokumentiert werden!"),
                        title: _this.lng.translate(20002067, "Editieren nicht möglich"),
                        icon: "qm-icon-information",
                        status: "info",
                        timer: 8000
                    });
                    _this.loading.case = false;
                    _this.disableForm = true;
                });
            };
            /**
             * get the fls group details
             *
             * @private
             * @param {Guid} id
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.getGroup = function (id) {
                var _this = this;
                this.loading.group = true;
                this.fachleistungService.getFlsGroupDetail(id).then(function (data) {
                    _this.group = {
                        onlyNumberOfParticipants: data.onlyNumberOfParticipants,
                        allowAdditionalExternalParticipants: data.allowAdditionalExternalParticipants,
                        allowAdditionalInternalParticipants: data.allowAdditionalInternalParticipants,
                        members: {
                            employee: data.members.filter(function (x) { return x.objectType === 120000; }).map(function (x) { return ({ value: x.objectId, text: _this.$qui.createPersonDisplay(x.lastName, x.foreName, x.shortCaption, x.personNumber), group: x.objectTypeCaption, subText: x.institute }); }),
                            client: data.members.filter(function (x) { return x.objectType !== 120000; }).map(function (x) { return ({ value: x.objectId, text: _this.$qui.createPersonDisplay(x.lastName, x.foreName, x.shortCaption, x.personNumber), group: x.objectTypeCaption, subText: x.institute }); }),
                        },
                        data: data,
                    };
                    _this.loading.group = false;
                    _this.$qui.functionWaiter("createForm.participantsForm", _this);
                    if (_this.group.allowAdditionalInternalParticipants && !_this.group.onlyNumberOfParticipants) {
                        _this.clientService.getPersonListByObjectType(140000, '', true).then(function (dataClient) {
                            var groupValues = dataClient.map(function (x) { return ({ value: x.objectId, text: _this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber), group: _this.lng.translate(21002000, 'Klient'), subText: x.institute }); });
                            var _loop_3 = function (member) {
                                if (!_this.group.members.client.some(function (x) { return x.value === member.value; }))
                                    _this.group.members.client.push(member);
                            };
                            // remove duplicates
                            for (var _i = 0, groupValues_1 = groupValues; _i < groupValues_1.length; _i++) {
                                var member = groupValues_1[_i];
                                _loop_3(member);
                            }
                            _this.$qui.functionWaiter("createForm.participantsForm", _this);
                            _this.loading.group = false;
                        });
                    }
                });
            };
            /**
             * get the current carer list for the additional carers for which to create the documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.getCarers = function () {
                var _this = this;
                this.loading.wv = true;
                if (!this.isGroup) {
                    this.fachleistungService.getCarerListForCase(this.flsCaseIds[0], true).then(function (data) {
                        _this.carers = data.map(function (x) { return ({
                            value: x.objectId, text: _this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber)
                        }); });
                        _this.carersIds = data.map(function (carerId) { return carerId.objectId; });
                        _this.getWv(_this.flsCaseIds, null);
                    });
                }
                else {
                    this.carersIds.push($('#session').data().personId);
                    this.getWv(this.flsCaseIds, null);
                }
            };
            /**
             * create a new activity form for the selected carer the user just selected
             *
             * @private carerId = the personObjektId for the carer is selected
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.createCarerActivityForm = function (carerIds) {
                var _this = this;
                var _a, _b;
                if (this.isGroup || !this.carerActivityForm) {
                    // DA-1834, make sure wvs are still valid
                    var wvCarerList = this.wvCarerDocumentationList[0].documentationCarerWvModel;
                    var carer = this.carers.filter(function (carer) { return carer.value === _this.form.carers[0]; })[0];
                    this.ensureActivityValidity(this.activityForm, carer, wvCarerList, true);
                    return;
                }
                if (!this.defaultActivities) {
                    setTimeout(function () { _this.createCarerActivityForm(carerIds); }, 50);
                    return;
                }
                var onlyRemove = carerIds.length === 0 ? true : false;
                var _loop_4 = function (i) {
                    var filterCarer = carerIds.filter(function (carer) { return carer === _this.carerActivityForm[i].carerId; });
                    if (filterCarer.length === 0) {
                        this_1.carerActivityForm.splice(i, 1);
                        onlyRemove = true;
                    }
                };
                var this_1 = this;
                for (var i = 0; i < this.carerActivityForm.length; i++) {
                    _loop_4(i);
                }
                if (!onlyRemove) {
                    var lastList = angular.copy(this.carerActivityForm);
                    this.carerActivityForm = [];
                    var _loop_5 = function (carerId) {
                        var carer = this_2.carers.filter(function (carer) { return carer.value === carerId; })[0];
                        var wvCarerList = this_2.getCarerWvList(carerId);
                        // if we already had this carer just push it
                        var existed = lastList.filter(function (x) { return x.carerId === carerId; })[0];
                        if (existed) {
                            this_2.ensureActivityValidity(existed, carer, wvCarerList);
                            this_2.carerActivityForm.push(existed);
                        }
                        else {
                            var carerActForm = {
                                carerId: carerId,
                                activityWvId: QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                                contactTypeWvId: null,
                                careTypeWvId: null,
                                miscontactWvId: QMC.Common.Constants.FLS_NO_MISCONTACT,
                                isActivityFix: false,
                                careTypeWv: [],
                                contactTypeWv: [],
                                activityWv: [],
                                carerName: '',
                                errors: [],
                                warnings: [],
                                watcherList: [],
                                activityBoxOpen: carerId === $('#session').data().personId ? 'open' : 'close',
                                isMiscontactEnabled: false
                            };
                            carerActForm.zIndex = this_2.zIndexCarerForm - this_2.carerActivityForm.length - 1;
                            carerActForm.activityCarerDescr = this_2.lng.translate(20016205, 'Tätigkeit für') + (((_a = carer === null || carer === void 0 ? void 0 : carer.text) === null || _a === void 0 ? void 0 : _a.length) ? ": " + carer.text : " " + this_2.lng.translate(20016009, 'Dokumentation'));
                            carerActForm.carerName = carer === null || carer === void 0 ? void 0 : carer.text;
                            this_2.applyWvs(carerActForm, carer, wvCarerList);
                            this_2.carerActivityForm.push(carerActForm);
                            // DA-1401 if this is not the first carer, use activities from first carer if aplicable
                            // only change activity if it is not fixed and standard is not valid with not just two options available (standard and one alternative)
                            if (this_2.checkIfWvIsPresentById(wvCarerList.activityWv, this_2.carerActivityForm[0].activityWvId) && !carerActForm.isActivityFix && wvCarerList.activityWv.length !== 2 && !this_2.standardActivityAllowedIfRequired)
                                carerActForm.activityWvId = this_2.carerActivityForm[0].activityWvId;
                            if (this_2.checkIfWvIsPresentById(wvCarerList.careTypeWv, this_2.carerActivityForm[0].careTypeWvId))
                                carerActForm.careTypeWvId = this_2.carerActivityForm[0].careTypeWvId;
                            if (this_2.checkIfWvIsPresentById(wvCarerList.contactTypeWv, this_2.carerActivityForm[0].contactTypeWvId))
                                carerActForm.contactTypeWvId = this_2.carerActivityForm[0].contactTypeWvId;
                            if (this_2.checkIfWvIsPresentById(wvCarerList.miscontactWv, this_2.carerActivityForm[0].miscontactWvId))
                                carerActForm.miscontactWvId = ((_b = this_2.carerActivityForm[0]) === null || _b === void 0 ? void 0 : _b.isMiscontactEnabled) ? this_2.carerActivityForm[0].miscontactWvId : QMC.Common.Constants.FLS_NO_MISCONTACT;
                            carerActForm.isMiscontactEnabled = this_2.requiredFields.workingHours.miscontactWvId || (carerActForm.miscontactWvId && carerActForm.miscontactWvId !== QMC.Common.Constants.FLS_NO_MISCONTACT);
                            var index_1 = this_2.carerActivityForm.length - 1;
                            this_2.carerActivityForm[index_1].watcherList = [];
                            this_2.carerActivityForm[index_1].watcherList.push(this_2.$scope.$watch('vm.carerActivityForm[' + index_1 + '].careTypeWvId', function (newValue, oldValue) {
                                if (newValue !== oldValue && _this.carerActivityForm[index_1])
                                    _this.validateDocumentation(0);
                            }));
                            this_2.carerActivityForm[index_1].watcherList.push(this_2.$scope.$watch('vm.carerActivityForm[' + index_1 + '].activityWvId', function (newValue, oldValue) {
                                if (newValue !== oldValue && _this.carerActivityForm[index_1])
                                    _this.validateDocumentation(0);
                            }));
                            this_2.carerActivityForm[index_1].watcherList.push(this_2.$scope.$watch('vm.carerActivityForm[' + index_1 + '].contactTypeWvId', function (newValue, oldValue) {
                                if (newValue !== oldValue && _this.carerActivityForm[index_1])
                                    _this.validateDocumentation(0);
                            }));
                            this_2.carerActivityForm[index_1].watcherList.push(this_2.$scope.$watch('vm.carerActivityForm[' + index_1 + '].isMiscontactEnabled', function (newValue, oldValue) {
                                if (newValue !== oldValue && _this.carerActivityForm[index_1])
                                    _this.validateDocumentation(0);
                            }));
                            this_2.carerActivityForm[index_1].watcherList.push(this_2.$scope.$watch('vm.carerActivityForm[' + index_1 + '].miscontactWvId', function (newValue, oldValue) {
                                if (newValue !== oldValue && _this.carerActivityForm[index_1])
                                    _this.validateDocumentation(0);
                            }));
                            this_2.validateDocumentation(0);
                        }
                    };
                    var this_2 = this;
                    for (var _i = 0, carerIds_1 = carerIds; _i < carerIds_1.length; _i++) {
                        var carerId = carerIds_1[_i];
                        _loop_5(carerId);
                    }
                }
                else {
                    this.webClientValidation();
                }
            };
            FlsDocumentationController.prototype.showActivityResetNotification = function (carerName, area, caption) {
                this.$qui.notify({
                    message: this.$qui.formatString(this.lng.translate(20016241, 'Die {0} {1} ist an dem Dokumentationsdatum ungültig'), area, caption),
                    title: ((carerName === null || carerName === void 0 ? void 0 : carerName.length) ? "<strong>" + carerName + "</strong>:" : '') + this.$qui.formatString(this.lng.translate(0, 'Die {0} wurde zurückgesetzt'), area),
                    icon: "qm-icon-information",
                    status: "info",
                    timer: 8000
                });
            };
            FlsDocumentationController.prototype.ensureActivityValidity = function (form, carer, currentWvs, useActvityForm) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (useActvityForm === void 0) { useActvityForm = false; }
                var previousValues = {
                    activity: form.activityWvId,
                    activityCaption: (_c = (_b = (_a = form.activityWv) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x.value === form.activityWvId; })[0]) === null || _b === void 0 ? void 0 : _b.text) !== null && _c !== void 0 ? _c : '',
                    contact: form.contactTypeWvId,
                    contactCaption: (_f = (_e = (_d = form.contactTypeWv) === null || _d === void 0 ? void 0 : _d.filter(function (x) { return x.value === form.contactTypeWvId; })[0]) === null || _e === void 0 ? void 0 : _e.text) !== null && _f !== void 0 ? _f : '',
                    care: form.careTypeWvId,
                    careCaption: (_j = (_h = (_g = form.careTypeWv) === null || _g === void 0 ? void 0 : _g.filter(function (x) { return x.value === form.careTypeWvId; })[0]) === null || _h === void 0 ? void 0 : _h.text) !== null && _j !== void 0 ? _j : ''
                };
                this.applyWvs(form, carer, currentWvs, useActvityForm);
                if (this.checkIfWvIsPresentById(currentWvs.activityWv, previousValues.activity))
                    form.activityWvId = previousValues.activity;
                else
                    this.showActivityResetNotification(carer === null || carer === void 0 ? void 0 : carer.text, this.lng.translate(20016046, 'Tätigkeit'), previousValues.activityCaption);
                if (this.checkIfWvIsPresentById(currentWvs.careTypeWv, previousValues.care))
                    form.careTypeWvId = previousValues.care;
                else
                    this.showActivityResetNotification(carer === null || carer === void 0 ? void 0 : carer.text, this.lng.translate(20016051, 'Betreuungsart'), previousValues.careCaption);
                if (this.checkIfWvIsPresentById(currentWvs.contactTypeWv, previousValues.contact))
                    form.contactTypeWvId = previousValues.contact;
                else
                    this.showActivityResetNotification(carer === null || carer === void 0 ? void 0 : carer.text, this.lng.translate(20016049, 'Kontaktart'), previousValues.contactCaption);
            };
            FlsDocumentationController.prototype.applyWvs = function (carerActForm, carer, wvCarerList, useActvityForm) {
                var _a, _b, _c, _d;
                if (useActvityForm === void 0) { useActvityForm = false; }
                wvCarerList = wvCarerList !== null && wvCarerList !== void 0 ? wvCarerList : this.wvCarerDocumentationList[0].documentationCarerWvModel;
                if (!wvCarerList.activityWv)
                    wvCarerList.activityWv = [];
                carerActForm.activityWv = this.getActivityList(carer === null || carer === void 0 ? void 0 : carer.objectId, wvCarerList);
                carerActForm.careTypeWv = this.getCareTypeList(carer === null || carer === void 0 ? void 0 : carer.objectId, wvCarerList);
                carerActForm.contactTypeWv = this.getContactList(carer === null || carer === void 0 ? void 0 : carer.objectId, wvCarerList);
                carerActForm.miscontactWv = this.getMiscontactList(carer === null || carer === void 0 ? void 0 : carer.objectId, wvCarerList);
                this.getCatalogSettings(useActvityForm ? null : carerActForm);
                if (this.defaultActivities.careType !== (null || QMC.Common.Constants.GUID_EMPTY) && this.checkIfWvIsPresentById(wvCarerList.careTypeWv, this.defaultActivities.careType))
                    carerActForm.careTypeWvId = this.defaultActivities.careType;
                if (this.defaultActivities.contactType !== (null || QMC.Common.Constants.GUID_EMPTY) && this.checkIfWvIsPresentById(wvCarerList.contactTypeWv, this.defaultActivities.contactType))
                    carerActForm.contactTypeWvId = this.defaultActivities.contactType;
                if (!carerActForm.isActivityFix && (this.defaultActivities.activityType !== (null || QMC.Common.Constants.GUID_EMPTY) && this.checkIfWvIsPresentById(wvCarerList.activityWv, this.defaultActivities.activityType))) {
                    carerActForm.activityWvId = this.defaultActivities.activityType;
                }
                else if (!carerActForm.isActivityFix && wvCarerList.activityWv.length === 2 && !this.standardActivityAllowedIfRequired) {
                    wvCarerList.activityWv.forEach(function (element) {
                        if (element.objectId !== QMC.Common.Constants.DEFAULT_ACTIVITY_ID) {
                            carerActForm.activityWvId = element.objectId;
                        }
                    });
                }
                // if we come from a planning update carerForm with selected values from planning
                if (this.isPlaned && !this.carerActivityForm.length && localStorage.getItem('flsObject')) {
                    var plannedFlsObject = JSON.parse(localStorage.getItem('flsObject'));
                    carerActForm.activityWvId = (_a = plannedFlsObject.activity) !== null && _a !== void 0 ? _a : carerActForm.activityWvId;
                    carerActForm.careTypeWvId = (_b = plannedFlsObject.careType) !== null && _b !== void 0 ? _b : carerActForm.careTypeWvId;
                    carerActForm.contactTypeWvId = (_c = plannedFlsObject.contactType) !== null && _c !== void 0 ? _c : carerActForm.contactTypeWvId;
                    carerActForm.miscontactWvId = (_d = plannedFlsObject.miscontact) !== null && _d !== void 0 ? _d : carerActForm.miscontactWvId;
                    carerActForm.isMiscontactEnabled = carerActForm.miscontactWvId && carerActForm.miscontactWvId !== QMC.Common.Constants.FLS_NO_MISCONTACT;
                }
            };
            FlsDocumentationController.prototype.getWarningErrorsCount = function (getForWarnings) {
                var _a, _b;
                if (getForWarnings === void 0) { getForWarnings = true; }
                if (this.isNewDocumentation) {
                    var count = 0;
                    for (var i = 0; (_b = i < ((_a = this.carerActivityForm) === null || _a === void 0 ? void 0 : _a.length)) !== null && _b !== void 0 ? _b : 0; i++) {
                        if (getForWarnings) {
                            count = this.carerActivityForm[i].warnings.length > 0 ? count + this.carerActivityForm[i].warnings.length : count + 0;
                        }
                        else {
                            count = this.carerActivityForm[i].errors.length > 0 ? count + this.carerActivityForm[i].errors.length : count + 0;
                        }
                    }
                    return count;
                }
                return 0;
            };
            FlsDocumentationController.prototype.getCatalogSettings = function (carerActivityForm) {
                var _this = this;
                var _a;
                if (carerActivityForm === void 0) { carerActivityForm = null; }
                this.loading.editorSettings = true;
                this.fachleistungService.getCatalogSettings(this.flsCaseIds, this.documentationIds[0], this.timeForm.dateFrom, (_a = carerActivityForm === null || carerActivityForm === void 0 ? void 0 : carerActivityForm.carerId) !== null && _a !== void 0 ? _a : $('#session').data().personId).then(function (data) {
                    var _a, _b, _c;
                    _this.flsDocumentationEditorSettings = data;
                    _this.configRoundInterval = data.hasStartHourRounding || data.hasEndHourRound ? Math.max(data.timeSetMinuteInterval, (_c = (_b = (_a = _this.ui.documentationTimeForm.form[0]) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.roundInterval) !== null && _c !== void 0 ? _c : 0) : 0;
                    _this.configStartRoundType = data.hasStartHourRounding ? data.startRoundingType : null;
                    _this.configEndRoundType = data.hasEndHourRound ? data.endRoundingType : null;
                    //this setting should be applied only for new entries and in case of saved entries after the user changes the date from/to
                    if (_this.isNewDocumentation) {
                        if (_this.configRoundInterval > 0) {
                            _this.ui.documentationTimeForm.form[0].config.roundInterval = _this.configRoundInterval;
                        }
                        if (!_this.isPlaned && !_this.defaultTimesSet) {
                            _this.timeForm.dateFrom.setHours(data.defaultHour);
                            _this.timeForm.dateFrom.setMinutes(0);
                            _this.timeForm.dateTo.setHours(data.defaultHour + 1);
                            _this.timeForm.dateTo.setMinutes(0);
                            if (_this.createForm.timeForm)
                                _this.createForm.timeForm();
                        }
                        if (_this.form.drivingCost[0]) {
                            _this.form.drivingCost[0].dateOfArrival.setHours(data.defaultHour);
                            _this.form.drivingCost[0].dateOfArrival.setMinutes(0);
                            _this.form.drivingCost[0].dateOfDeparture.setHours(data.defaultHour);
                            _this.form.drivingCost[0].dateOfDeparture.setMinutes(0);
                            _this.form.drivingCost[0].timeOfArrival.setHours(data.defaultHour);
                            _this.form.drivingCost[0].timeOfArrival.setMinutes(0);
                            _this.form.drivingCost[0].timeOfDeparture.setHours(data.defaultHour);
                            _this.form.drivingCost[0].timeOfDeparture.setMinutes(0);
                        }
                    }
                    _this.defaultTimesSet = true;
                    _this.standardActivityAllowedIfRequired = data.isActivityStandardValidValue;
                    if (carerActivityForm === null) {
                        _this.requiredFields.workingHours.contactTypeWvId = data.isContactTypeRequiered || _this.requiredFields.workingHours.contactTypeWvId;
                        _this.requiredFields.workingHours.careTypeWvId = data.isCareTypeRequiered || _this.requiredFields.workingHours.careTypeWvId;
                    }
                    else {
                        carerActivityForm.requiredFields = _this.requiredFields;
                        carerActivityForm.requiredFields.workingHours.contactTypeWvId = data.isContactTypeRequiered || carerActivityForm.requiredFields.workingHours.contactTypeWvId || _this.requiredFields.workingHours.contactTypeWvId;
                        carerActivityForm.requiredFields.workingHours.careTypeWvId = data.isCareTypeRequiered || carerActivityForm.requiredFields.workingHours.careTypeWvId || _this.requiredFields.workingHours.careTypeWvId;
                    }
                    // if we got a fix activity Id set the activity to it!
                    if (_this.flsCaseIds.length === 1) {
                        if (carerActivityForm === null) {
                            _this.activityForm.isActivityFix = (data.fixActivityId && data.fixActivityId !== QMC.Common.Constants.GUID_EMPTY);
                            if (_this.activityForm.isActivityFix)
                                _this.activityForm.activityWvId = data.fixActivityId;
                        }
                        else {
                            carerActivityForm.isActivityFix = (data.fixActivityId && data.fixActivityId !== QMC.Common.Constants.GUID_EMPTY);
                            if (carerActivityForm.isActivityFix)
                                carerActivityForm.activityWvId = data.fixActivityId;
                        }
                    }
                    _this.loading.editorSettings = false;
                    _this.$qui.functionWaiter("createForm.activityForm", _this);
                }).catch(function () {
                    _this.loading.editorSettings = false;
                    _this.disableForm = true;
                });
            };
            FlsDocumentationController.prototype.shouldDisable = function () {
                return this.form.isSigned ? this.form.isSigned : (!this.isNewDocumentation && !this.showSaveButton()) || this.hasPrevMonthLock() || this.disableForm;
            };
            FlsDocumentationController.prototype.showSaveButton = function () {
                return ((this.modifiyDescription || this.form.isUpdateAllowed || this.editLockType === 'warnings' || this.formState == 'new') && (this.pausedCases && !(this.pausedCases.length > 0 && this.editLockType === 'errors')));
            };
            FlsDocumentationController.prototype.showDeleteButton = function () {
                return this.form.isDeleteAllowed && (this.pausedCases && !(this.pausedCases.length > 0 && this.editLockType === 'errors')) && !this.hasPrevMonthLock();
            };
            FlsDocumentationController.prototype.hasPrevMonthLock = function () {
                if (this.isNewDocumentation || this.editLockType === 'warnings')
                    return false; // DAA-481
                if (!this.userConfig || !this.timeForm || !this.timeForm.dateFrom)
                    return true; // no settings loaded / not init => block
                var res = false;
                if (moment(this.timeForm.dateFrom).startOf('month') < moment().startOf('month') && this.userConfig.isLockedCreatingForPreviousMonth) {
                    var i = 0;
                    var dtmin = new moment().startOf('month');
                    while (i < this.userConfig.daysAllowedCreatingReportsForPreviousMonth) {
                        dtmin = dtmin.add(1, 'day');
                        if (!((dtmin.day() === 6) || (dtmin.day() === 0)))
                            i++;
                    }
                    if (dtmin.toDate() < this.timeForm.dateFrom) {
                        res = true;
                    }
                }
                this.addOrRemoveError(this.lng.translate(20016225, 'Die Dokumentation kann aufgrund der Sperre Vormonat nicht mehr verändert werden. Ausgenommen ist das Bemerkungsfeld'), res);
                return res;
            };
            FlsDocumentationController.prototype.getWv = function (caseIds, documentationId) {
                var _this = this;
                var carerIds = this.isNewDocumentation ? this.selectedCarerList : this.carersIds;
                if (!carerIds || carerIds.length === 0) {
                    carerIds = [$('#session').data().personId];
                }
                ;
                var getRequestString = JSON.stringify({ caseIds: caseIds, documentationId: documentationId, carerIds: carerIds, date: this.timeForm.dateFrom });
                if (this.lastWvGetRequest === getRequestString)
                    return;
                this.lastWvGetRequest = getRequestString;
                this.loading.wv = true;
                this.fachleistungService.getFlsDocumentationWvModel(caseIds, documentationId, carerIds, this.timeForm.dateFrom).then(function (data) {
                    //sort wvs alphanumerically
                    data.forEach(function (carer) {
                        for (var wv in carer.documentationCarerWvModel) {
                            if (Array.isArray(carer.documentationCarerWvModel[wv])) {
                                console.log(wv, carer.documentationCarerWvModel[wv]);
                                carer.documentationCarerWvModel[wv] = carer.documentationCarerWvModel[wv].sort(function (a, b) { var _a, _b; return ((_a = a.caption) !== null && _a !== void 0 ? _a : a.name).localeCompare(((_b = b.caption) !== null && _b !== void 0 ? _b : b.name), undefined, { sensitivity: 'base' }); });
                            }
                        }
                    });
                    _this.wvCarerDocumentationList = data;
                    if (!_this.isNewDocumentation || _this.isGroup) {
                        //the carersIds will always be filled for an existing documentation in the getDocumentation() function with the ReferencePersonId of the Documentation
                        _this.wvList = _this.getCarerWvList(_this.carersIds[0]);
                    }
                    else {
                        //DA-4495 check if the session user can be a carer before adding him/her to the selectedCarerList
                        if (_this.selectedCarerList.length === 0 && _this.carersIds.some(function (x) { return x === $('#session').data().personId; })) {
                            _this.selectedCarerList.push($('#session').data().personId);
                        }
                        _this.createCarerActivityForm(_this.selectedCarerList);
                    }
                    _this.wvlivingAreaList = _this.getLivingAreaWvList();
                    if (_this.wvlivingAreaList.length > 0) {
                        _this.livingAreaId = _this.wvlivingAreaList[0].value;
                    }
                    //only do this part when you create a group fls, for a new documentation with carers the settings are loaded and set in createCarerActivityForm
                    if (_this.isNewDocumentation && _this.isGroup) {
                        _this.$timeout(function () {
                            _this.userService.getUserSettings(["FLS.DEFAULTCARETYPE", "FLS.DEFAULTCONTACTTYPE", "FLS.DEFAULTACTIVITYTYPE"], false).then(function (data) {
                                var wvCarerList = _this.getCarerWvList($('#session').data().personId);
                                if (!wvCarerList.activityWv)
                                    wvCarerList.activityWv = [];
                                _this.activityForm.carerId = $('#session').data().personId;
                                if (data[0].value !== (null || QMC.Common.Constants.GUID_EMPTY) && _this.checkIfWvIsPresentById(wvCarerList.careTypeWv, data[0].value))
                                    _this.activityForm.careTypeWvId = data[0].value;
                                if (data[1].value !== (null || QMC.Common.Constants.GUID_EMPTY) && _this.checkIfWvIsPresentById(wvCarerList.contactTypeWv, data[1].value))
                                    _this.activityForm.contactTypeWvId = data[1].value;
                                if (!_this.activityForm.isActivityFix && (data[2].value !== (null || QMC.Common.Constants.GUID_EMPTY) && _this.checkIfWvIsPresentById(wvCarerList.activityWv, data[2].value)))
                                    _this.activityForm.activityWvId = data[2].value;
                                else if (!_this.activityForm.isActivityFix && wvCarerList.activityWv.length === 2 && !_this.standardActivityAllowedIfRequired) {
                                    wvCarerList.activityWv.forEach(function (element) {
                                        if (element.objectId !== QMC.Common.Constants.DEFAULT_ACTIVITY_ID) {
                                            _this.activityForm.activityWvId = element.objectId;
                                        }
                                    });
                                }
                            });
                        });
                    }
                    _this.loading.wvFirst = false;
                    _this.loading.wv = false;
                    _this.createCarerActivityForm(carerIds);
                    _this.validateDocumentation();
                });
            };
            FlsDocumentationController.prototype.getCarerWvList = function (carerId) {
                var _a, _b;
                for (var _i = 0, _c = this.wvCarerDocumentationList; _i < _c.length; _i++) {
                    var element = _c[_i];
                    if (element.carerId === carerId) {
                        return element.documentationCarerWvModel;
                    }
                }
                ;
                // no wv found go with default as failsafe
                return (_b = (_a = this.wvCarerDocumentationList[0]) === null || _a === void 0 ? void 0 : _a.documentationCarerWvModel) !== null && _b !== void 0 ? _b : {};
            };
            FlsDocumentationController.prototype.checkIfWvIsPresentById = function (list, id) {
                if (!list)
                    list = [];
                for (var _i = 0, list_2 = list; _i < list_2.length; _i++) {
                    var element = list_2[_i];
                    if (element.objectId === id
                        //failsafe if any of the involved values is undefined
                        || (!id && element.objectId === QMC.Common.Constants.GUID_EMPTY)
                        || (!element.objectId && id === QMC.Common.Constants.GUID_EMPTY))
                        return true;
                }
                return false;
            };
            FlsDocumentationController.prototype.getDrivingCostCategoryWv = function () {
                if (this.wvList && this.wvList.drivingCostCategoryWv.length > 0) {
                    return this.wvList.drivingCostCategoryWv;
                }
                else {
                    var wvCarerList = this.getCarerWvList($('#session').data().personId);
                    return wvCarerList.drivingCostCategoryWv;
                }
            };
            FlsDocumentationController.prototype.getDrivingCostCategoryList = function () {
                var _a, _b, _c;
                if (this.wvList && ((_a = this.wvList.drivingCostCategoryWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return (_b = this.wvList.drivingCostCategoryWv) === null || _b === void 0 ? void 0 : _b.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                }
                else {
                    var wvCarerList = this.getCarerWvList($('#session').data().personId);
                    return (_c = wvCarerList.drivingCostCategoryWv) === null || _c === void 0 ? void 0 : _c.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                }
            };
            FlsDocumentationController.prototype.getDrivingCostCharingList = function () {
                var _a, _b, _c;
                if (this.wvList && ((_a = this.wvList.drivingCostChargingMethodWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return (_b = this.wvList.drivingCostChargingMethodWv) === null || _b === void 0 ? void 0 : _b.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                }
                else {
                    var wvCarerList = this.getCarerWvList($('#session').data().personId);
                    return (_c = wvCarerList.drivingCostChargingMethodWv) === null || _c === void 0 ? void 0 : _c.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                }
            };
            FlsDocumentationController.prototype.getActivityList = function (carerId, wvCarerList) {
                var _a;
                if (carerId === void 0) { carerId = QMC.Common.Constants.GUID_EMPTY; }
                if (wvCarerList === void 0) { wvCarerList = this.getCarerWvList($('#session').data().personId); }
                if (carerId === QMC.Common.Constants.GUID_EMPTY && this.wvList && ((_a = this.wvList.activityWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return this.wvList.activityWv.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                }
                else {
                    return wvCarerList.activityWv ? wvCarerList.activityWv.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); }) : [];
                }
            };
            FlsDocumentationController.prototype.getContactList = function (carerId, wvCarerList) {
                var _a;
                if (carerId === void 0) { carerId = QMC.Common.Constants.GUID_EMPTY; }
                if (wvCarerList === void 0) { wvCarerList = this.getCarerWvList($('#session').data().personId); }
                if (carerId === QMC.Common.Constants.GUID_EMPTY && this.wvList && ((_a = this.wvList.contactTypeWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return this.wvList.contactTypeWv.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                }
                else {
                    return wvCarerList.contactTypeWv ? wvCarerList.contactTypeWv.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); }) : [];
                }
            };
            FlsDocumentationController.prototype.getCareTypeList = function (carerId, wvCarerList) {
                var _a;
                if (carerId === void 0) { carerId = QMC.Common.Constants.GUID_EMPTY; }
                if (wvCarerList === void 0) { wvCarerList = this.getCarerWvList($('#session').data().personId); }
                if (carerId === QMC.Common.Constants.GUID_EMPTY && this.wvList && ((_a = this.wvList.careTypeWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return this.wvList.careTypeWv.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                }
                else {
                    return wvCarerList.careTypeWv ? wvCarerList.careTypeWv.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); }) : [];
                }
            };
            FlsDocumentationController.prototype.getMiscontactList = function (carerId, wvCarerList) {
                var _a;
                if (carerId === void 0) { carerId = QMC.Common.Constants.GUID_EMPTY; }
                if (wvCarerList === void 0) { wvCarerList = this.getCarerWvList($('#session').data().personId); }
                if (carerId === QMC.Common.Constants.GUID_EMPTY && this.wvList && ((_a = this.wvList.miscontactWv) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    return this.wvList.miscontactWv.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                }
                else {
                    return wvCarerList.miscontactWv ? wvCarerList.miscontactWv.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); }) : [];
                }
            };
            FlsDocumentationController.prototype.getLivingAreaWvList = function () {
                if (this.wvList && this.wvList.livingAreaWvList.length > 0) {
                    var livingAreaWvList = this.wvList.livingAreaWvList.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                    livingAreaWvList.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: this.lng.translate(20000212, '- Alle -'), isFix: true });
                    return livingAreaWvList;
                }
                else {
                    //get the wvList for the current user
                    var wvCarerList = this.getCarerWvList($('#session').data().personId);
                    var livingAreaWvList = wvCarerList.livingAreaWvList.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                    livingAreaWvList.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: this.lng.translate(20000212, '- Alle -'), isFix: true });
                    return livingAreaWvList;
                }
            };
            FlsDocumentationController.prototype.getSubLivingAreaWvList = function () {
                if (this.livingAreaId && this.livingAreaId !== '') {
                    var data = [];
                    var livingAreaName = this.getlivingAreaName(this.livingAreaId);
                    if (livingAreaName !== '' && livingAreaName) {
                        data = this.wvList.subLivingAreaWvList[livingAreaName];
                        if (data.length > 0) {
                            data = data.map(function (obj) {
                                return {
                                    value: obj.objectId,
                                    text: obj.name
                                };
                            });
                            data.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: this.lng.translate(20000212, '- Alle -'), isFix: true });
                        }
                    }
                    return data;
                }
            };
            FlsDocumentationController.prototype.getlivingAreaName = function (livingAreaId) {
                var livingAreaType = this.wvList.livingAreaWvList.filter(function (livingAreaType) { return livingAreaType.objectId === livingAreaId; });
                if (livingAreaType && livingAreaType.length > 0) {
                    var livingAreaName = livingAreaType[0].name;
                    return livingAreaName.substring(0, 1).toLowerCase() + livingAreaName.substring(1);
                }
            };
            FlsDocumentationController.prototype.getParticipantsList = function () {
                return this.group.members.client;
            };
            FlsDocumentationController.prototype.getParticipantEmployeesList = function () {
                return this.group.members.employee;
            };
            FlsDocumentationController.prototype.getAccountabilityRuleName = function (id) {
                if (!this.wvList)
                    return '';
                for (var _i = 0, _a = this.wvList.abrechenbarkeitWv; _i < _a.length; _i++) {
                    var rule = _a[_i];
                    if (rule.objectId === id)
                        return rule.caption;
                }
                return '';
            };
            /////////////// REPORT FUNCTIONS ///////////////
            /**
             * get the report templates from api
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.getReportTemplates = function () {
                var _this = this;
                this.loading.templates = true;
                this.fachleistungService.getReportTemplates().then(function (data) {
                    _this.loading.templates = false;
                    _this.reportForm.templates = data;
                    _this.reportForm.normalReportTemplates = data;
                    if (_this.isNewDocumentation) {
                        _this.selectDefaultTemplate();
                    }
                    _this.reportTemplates.normal = data.map(function (x) { return ({ text: x.caption, value: x.id }); });
                });
            };
            FlsDocumentationController.prototype.selectDefaultTemplate = function () {
                if (this.defaultReportTemplateId) {
                    this.getReportTemplateItems(this.reportForm.templateId);
                    return;
                }
                this.reportForm.templateId = this.reportForm.templates[0].objectId;
                for (var _i = 0, _a = this.reportForm.templates; _i < _a.length; _i++) {
                    var element = _a[_i];
                    if (element.isDefault) {
                        this.reportForm.templateId = element.objectId;
                        break;
                    }
                }
                this.getReportTemplateItems(this.reportForm.templateId);
            };
            /**
             * get the report template items
             *
             * @private
             * @param {Guid} templateId
             * @returns {void}
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.getReportTemplateItems = function (templateId, changeReportType, noPrompt) {
                var _this = this;
                if (changeReportType === void 0) { changeReportType = false; }
                if (noPrompt === void 0) { noPrompt = false; }
                if (!templateId) {
                    this.reportForm.templateId = this.form.reportTemplateId;
                    return;
                }
                var option = !this.isSupportPlanDocu ? "getReportTemplateItems" : "getSupportPlanTargetTemplateItems";
                this.fachleistungService[option](templateId).then(function (data) {
                    _this.setReportTemplate(templateId, data, changeReportType, noPrompt);
                });
            };
            FlsDocumentationController.prototype.setReportTemplate = function (templateId, template, changeReportType, noPrompt) {
                var _this = this;
                if (changeReportType === void 0) { changeReportType = false; }
                if (noPrompt === void 0) { noPrompt = false; }
                if (this.templatePromptOpen)
                    return;
                if (!noPrompt && this.isReportEntryCommented(this.reportForm.reports) && !this.dontTriggerReportPrompt) {
                    this.templatePromptOpen = true;
                    QMC.Common.Utilities.confirm(this.promptOptionsTemplateChange, function (response) {
                        _this.dontTriggerReportPrompt = true;
                        if (response) {
                            _this.setReportTemplateItems(templateId, template);
                        }
                        else {
                            _this.reportForm.templateId = _this.form.reportTemplateId;
                            if (changeReportType) {
                                _this.isSupportPlanDocu = !_this.isSupportPlanDocu;
                                _this.toggleSupportPlan(true, false);
                            }
                        }
                        setTimeout(function () {
                            var _a;
                            _this.dontTriggerReportPrompt = false;
                            _this.templatePromptOpen = false;
                            // the backdrop sometimes remained...
                            (_a = $('.modal-backdrop')) === null || _a === void 0 ? void 0 : _a.remove();
                        }, 500);
                    }, '#promptTemplate', true);
                }
                else {
                    this.setReportTemplateItems(templateId, template);
                }
            };
            FlsDocumentationController.prototype.setReportTemplateItems = function (templateId, template) {
                var _this = this;
                if (templateId !== this.form.reportTemplateId || this.reportForm.reports.length === 0)
                    this.reportForm.reports = this.createReportTemplateRecursive(template);
                this.$timeout(function () {
                    if (!_this.isReportEntryCommented(_this.reportForm.reports))
                        _this.reportForm.activeReport = _this.reportForm.reports[0];
                });
                this.form.reportTemplateId = templateId;
            };
            FlsDocumentationController.prototype.isReportEntryCommented = function (items, setFirstCommented) {
                if (setFirstCommented === void 0) { setFirstCommented = true; }
                if (this.reportForm.activeReport) {
                    for (var _i = 0, _a = this.reportForm.reports; _i < _a.length; _i++) {
                        var tempItem = _a[_i];
                        if (tempItem.objectId == this.reportForm.activeReport.objectId)
                            tempItem.comment = this.reportForm.activeReport.comment;
                    }
                }
                for (var _b = 0, items_2 = items; _b < items_2.length; _b++) {
                    var entry = items_2[_b];
                    if (entry.comment && this.strip(entry.comment).length > 0) {
                        if (setFirstCommented) {
                            this.reportForm.activeReport = entry;
                        }
                        return true;
                    }
                    if (entry.children && entry.children.length > 0 && this.isReportEntryCommented(entry.children, setFirstCommented))
                        return true;
                    if (items.length === items.indexOf(entry))
                        return false;
                }
            };
            /**
             * create the report template structure recursive
             *
             * @private
             * @param {Common.IReportTemplateItem[]} template
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.createReportTemplateRecursive = function (template) {
                var result = [];
                for (var _i = 0, template_1 = template; _i < template_1.length; _i++) {
                    var templateItem = template_1[_i];
                    var item = {
                        caption: templateItem.caption,
                        children: [],
                        comment: '',
                        templateReferenceId: templateItem.objectId,
                        wvChildId: templateItem.reportItemId,
                        objectId: templateItem.objectId,
                        icon: this.isSupportPlanDocu ? templateItem.measureId ? 'qm-icon-lifebelt' : templateItem.targetId ? 'qm-icon-target' : 'qm-icon-elements' : ''
                    };
                    if (templateItem.children.length > 0)
                        item.children = this.createReportTemplateRecursive(templateItem.children);
                    result.push(item);
                }
                return result;
            };
            /**
             * Select and set the report template item
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.selectReport = function (reportItem) {
                this.reportForm.activeReport = reportItem;
                $('#reportSummernote').find('.note-editable').trigger('focus');
            };
            /**
             * get the support plan from api
             *
             * @private
             * @param {Guid} id
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.getSupportPlanTargetTemplates = function (id) {
                var _this = this;
                this.fachleistungService.getSupportPlanTargetTemplates(id).then(function (dataSupportPlan) {
                    dataSupportPlan = dataSupportPlan.sort(function (a, b) {
                        var fromA = moment(a.dateFrom);
                        var fromB = moment(b.dateFrom);
                        return fromA < fromB ? 1 : fromA > fromB ? -1 : 0;
                    });
                    _this.reportForm.supportPlanTemplates = dataSupportPlan;
                    _this.reportTemplates.supportPlan = dataSupportPlan.map(function (x) { return ({ text: x.caption, subText: x.supportPlanCaption, value: x.id }); });
                    if (_this.isSupportPlanDocu) {
                        _this.reportForm.templates = dataSupportPlan;
                    }
                    // Select the first entry from the array
                    var firstTemplate = dataSupportPlan[0];
                    if (firstTemplate) {
                        //get active phase from careplan
                        _this.fachleistungService.getSupportPlanActivePhase(firstTemplate.supportPlanId).then(function (dataPhase) {
                            if (dataPhase.careplanId) {
                                if ((dataPhase.phase != 'CareSummarization') && (dataPhase.phaseState != 'IsDone')) {
                                    _this.activeSupportPlanPhase = dataPhase;
                                }
                            }
                        });
                    }
                });
            };
            /**
             * get the phase of the support plan
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.getActiveSupportPlanPhase = function () {
                var result = '';
                if (this.activeSupportPlanPhase) {
                    result = QMC.Common.SupportPlanHelper.getActiveSupportPlanPhase(this.activeSupportPlanPhase.phase, this.lng);
                }
                return result;
            };
            /**
             * get the state of the support plan phase
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.getActiveSupportPlanPhaseState = function () {
                var result = '';
                if (this.activeSupportPlanPhase) {
                    result = QMC.Common.SupportPlanHelper.getActiveSupportPlanPhaseState(this.activeSupportPlanPhase.phaseState, this.lng);
                }
                return result;
            };
            /**
            * get the color of the support plan phase
            *
            * @private
            *
            * @memberOf FlsDocumentationController
            */
            FlsDocumentationController.prototype.getActiveSupportPlanPhaseColor = function () {
                var result = '';
                if (this.activeSupportPlanPhase) {
                    result = QMC.Common.SupportPlanHelper.getActiveSupportPlanPhaseColor(this.activeSupportPlanPhase.phaseState);
                }
                return result;
            };
            /**
            * get the text of the support plan phase
            *
            * @private
            *
            * @memberOf FlsDocumentationController
            */
            FlsDocumentationController.prototype.getActiveSupportPlanPhaseText = function () {
                var result = '';
                var today = new Date();
                if (this.activeSupportPlanPhase) {
                    result = QMC.Common.SupportPlanHelper.getActiveSupportPlanPhaseText(this.activeSupportPlanPhase, this.lng, this.$qui);
                }
                return result;
            };
            /**
            *  generate the Link to support plan frontend
            *
            * @private
            *
            * @memberOf FlsDocumentationController
            */
            FlsDocumentationController.prototype.getActiveSupportPlanLink = function () {
                var sUrl = '';
                if (this.activeSupportPlanPhase && this.activeSupportPlanPhase.careplanId) {
                    sUrl = QMC.Common.SupportPlanHelper.getActiveSupportPlanLink(this.activeSupportPlanPhase.careplanId.toString());
                }
                return sUrl;
            };
            /**
            *  switches to support plan templates
            *
            * @private
            *
            * @memberOf FlsDocumentationController
            */
            FlsDocumentationController.prototype.toggleSupportPlan = function (dontSetTemplates, overwrite) {
                if (dontSetTemplates === void 0) { dontSetTemplates = false; }
                if (overwrite === void 0) { overwrite = true; }
                if (this.isSupportPlanDocu) {
                    this.reportForm.templates = this.reportForm.supportPlanTemplates;
                }
                else {
                    this.reportForm.templates = this.reportForm.normalReportTemplates;
                }
                if (overwrite && (!dontSetTemplates || !(this.isNewDocumentation && this.form.isSupportPlanDocu))) {
                    this.reportForm.templateId = this.defaultReportTemplateId && !this.isSupportPlanDocu ? this.defaultReportTemplateId : this.reportForm.templates[0].id;
                    this.getReportTemplateItems(this.reportForm.templateId, true);
                }
            };
            /////////////// SAVELOGIC ///////////////
            /**
             * Validate the current documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.allowSaveAnyway = function () {
                var allow = this.validation.errors.length === 0;
                if (this.carerActivityForm && this.carerActivityForm.length > 0)
                    this.carerActivityForm.forEach(function (x) {
                        allow = allow && x.errors.length === 0;
                    });
                return allow;
            };
            FlsDocumentationController.prototype.validateDocumentation = function (debounce, saveAnyway, doServerValidation, afterSuccessfullValidationAction) {
                var _this = this;
                if (debounce === void 0) { debounce = 1500; }
                if (saveAnyway === void 0) { saveAnyway = false; }
                if (doServerValidation === void 0) { doServerValidation = false; }
                if (afterSuccessfullValidationAction === void 0) { afterSuccessfullValidationAction = function () { }; }
                if (this.loading.save)
                    return;
                var exitValidation = function () {
                    _this.loading.validate = _this.isValidating;
                    _this.$qui.scopeApply(_this.$scope);
                };
                this.validation.errors = [];
                this.validation.warnings = [];
                if (isNaN(this.timeForm.dateFrom.valueOf()) || isNaN(this.timeForm.dateTo.valueOf())) {
                    this.webClientValidation();
                    return;
                }
                if (this.timeForm.dateFrom.getSeconds())
                    this.timeForm.dateFrom.setSeconds(0);
                if (this.timeForm.dateFrom.getMilliseconds())
                    this.timeForm.dateFrom.setMilliseconds(0);
                if (this.timeForm.dateTo.getSeconds())
                    this.timeForm.dateTo.setSeconds(0);
                if (this.timeForm.dateTo.getMilliseconds())
                    this.timeForm.dateTo.setMilliseconds(0);
                if (this.loading.requieredFields) {
                    setTimeout(function () { _this.validateDocumentation(debounce); }, 500);
                    return;
                }
                this.loading.validate = true;
                this.webClientValidation();
                var references = [];
                if (this.cases && this.cases.length > 0) {
                    for (var _i = 0, _a = this.cases; _i < _a.length; _i++) {
                        var curCase = _a[_i];
                        references.push({
                            caseId: curCase.objectId,
                            referenceId: curCase.clientObjectId,
                            accountabilityId: curCase.isAccountableRuleFix ? curCase.defaultAccountableRuleId : this.form.workingHours.abrechenbarkeitId
                        });
                    }
                }
                else {
                    this.loading.validate = this.isValidating;
                    return;
                }
                var carer = [];
                if (this.carerActivityForm && this.carerActivityForm.length > 0) {
                    for (var _b = 0, _c = this.carerActivityForm; _b < _c.length; _b++) {
                        var curCarer = _c[_b];
                        carer.push({
                            carerId: curCarer.carerId,
                            activityTypeId: curCarer.activityWvId,
                            contactTypeId: curCarer.contactTypeWvId,
                            careTypeId: curCarer.careTypeWvId,
                            miscontactId: curCarer.miscontactWvId
                        });
                    }
                }
                else if (this.isGroup || !this.isNewDocumentation) {
                    carer.push({
                        carerId: this.isGroup ? $("#session").data().personId : this.form.workingHours.carerObjectId,
                        activityTypeId: this.activityForm.activityWvId,
                        careTypeId: this.activityForm.careTypeWvId,
                        contactTypeId: this.activityForm.contactTypeWvId,
                        miscontactId: this.activityForm.miscontactWvId
                    });
                }
                else {
                    exitValidation();
                    return;
                }
                setTimeout(function () {
                    var _a;
                    var duration = _this.timeForm.durationInHours;
                    if (_this.timeForm.isManualDuration) {
                        duration = _this.form.durationInHours = _this.hoursMinutesToDecimal(_this.timeForm.hours, _this.timeForm.minutes);
                    }
                    var validationObject = null;
                    if (_this.isNewDocumentation && !_this.isGroup) {
                        var isManual = _this.timeForm.isManualDuration || (_this.timeForm.distributeHours && _this.cases.length > 1); // if we got multiple cases && ditribute hours is set, validate as if manual duration DA-1127,
                        for (var _i = 0, _b = _this.carerActivityForm; _i < _b.length; _i++) {
                            var element = _b[_i];
                            validationObject = {
                                dateFrom: _this.timeForm.dateFrom,
                                dateTo: _this.timeForm.dateTo,
                                hasManualDuration: isManual,
                                manualDuration: isManual ? _this.timeForm.distributeHours ? duration / references.length : duration : 0,
                                documentationId: _this.formState === 'new' ? QMC.Common.Constants.GUID_EMPTY : _this.documentationIds[0],
                                references: references,
                                carer: carer,
                                requestId: _this.$qui.generateGuid(),
                                ignoreConfigRoundInterval: (_this.ignoreConfigRoundInterval || _this.ui.documentationTimeForm.form[0].config.roundInterval === 0)
                            };
                        }
                    }
                    else {
                        validationObject = {
                            dateFrom: _this.timeForm.dateFrom,
                            dateTo: _this.timeForm.dateTo,
                            hasManualDuration: _this.timeForm.isManualDuration,
                            manualDuration: _this.timeForm.isManualDuration ? _this.timeForm.distributeHours ? duration / references.length : duration : 0,
                            documentationId: _this.formState === 'new' ? QMC.Common.Constants.GUID_EMPTY : _this.documentationIds[0],
                            references: references,
                            carer: carer,
                            requestId: _this.$qui.generateGuid(),
                            ignoreConfigRoundInterval: (_this.ignoreConfigRoundInterval || _this.ui.documentationTimeForm.form[0].config.roundInterval === 0)
                        };
                    }
                    if ((_a = _this.form) === null || _a === void 0 ? void 0 : _a.drivingCost) {
                        validationObject.drivingCost = [];
                        for (var _c = 0, _d = _this.form.drivingCost; _c < _d.length; _c++) {
                            var cost = _d[_c];
                            if (_this.ui.convertHours(cost.hours, cost.minutes >= 0 ? cost.minutes : 0) > 0 || cost.drivingDistance > 0 || cost.isCarPool || cost.isPrivate)
                                validationObject.drivingCost.push({
                                    objectId: cost.objectId,
                                    dateOfArrival: cost.isPrivate || cost.isCarPool ? _this.$qui.addTimeToDate(cost.dateOfArrival, cost.timeOfArrival) : null,
                                    dateOfDeparture: cost.isPrivate || cost.isCarPool ? _this.$qui.addTimeToDate(cost.dateOfDeparture, cost.timeOfDeparture) : null,
                                    drivingDistance: cost.drivingDistance,
                                    duration: _this.ui.convertHours(cost.hours, cost.minutes >= 0 ? cost.minutes : 0),
                                    chargingMethodId: cost.chargingMethodId,
                                    drivingCostCategoryId: cost.drivingCostCategoryId
                                });
                        }
                    }
                    // failsafe to make absolutely sure to not validate with manual duration, when there is none
                    if (validationObject != null) {
                        if (validationObject.hasManualDuration && !validationObject.manualDuration) {
                            validationObject.manualDuration = 0;
                        }
                    }
                    else {
                        exitValidation();
                        return;
                    }
                    if (_this.lastValidation) {
                        var last = JSON.parse(_this.lastValidation);
                        var current = angular.copy(validationObject);
                        delete last.requestId;
                        delete current.requestId;
                        if (JSON.stringify(last) === JSON.stringify(current)) {
                            exitValidation();
                            return;
                        }
                        ;
                    }
                    if (references.length === 0) {
                        exitValidation();
                        return;
                    }
                    _this.lastValidation = JSON.stringify(validationObject);
                    if (!doServerValidation) {
                        exitValidation();
                        return;
                    }
                    _this.isValidating = true;
                    _this.fachleistungService.checkForWarningsAndErrors([validationObject], false).then(function (data) {
                        if (JSON.parse(_this.lastValidation).requestId !== validationObject.requestId)
                            return;
                        _this.isValidating = false;
                        if (_this.isGroup || !_this.isNewDocumentation) {
                            data.forEach(function (result) {
                                for (var key in result.validation) {
                                    result.validation[key].errors.forEach(function (msg) { _this.addValidation(msg, "errors"); });
                                    result.validation[key].warnings.forEach(function (msg) { _this.addValidation(msg, "warnings"); });
                                }
                            });
                        }
                        else {
                            data.forEach(function (result) {
                                _this.carerActivityForm.forEach(function (form) {
                                    var _a, _b, _c, _d;
                                    form.warnings = form.warnings.concat((_b = (_a = result.validation[form.carerId]) === null || _a === void 0 ? void 0 : _a.warnings) !== null && _b !== void 0 ? _b : []);
                                    form.errors = form.errors.concat((_d = (_c = result.validation[form.carerId]) === null || _c === void 0 ? void 0 : _c.errors) !== null && _d !== void 0 ? _d : []);
                                });
                            });
                        }
                        _this.removeValidation(_this.lng.translate(21003033, "Die Leistung konnte nicht validiert werden."), "errors");
                        _this.validationFailCounter = 0;
                        _this.loading.validate = false;
                        afterSuccessfullValidationAction(saveAnyway);
                    }).catch(function () {
                        _this.loading.validate = false;
                        _this.validation.errors = [];
                        _this.validation.warnings = [];
                        _this.validation.errors.push(_this.lng.translate(21003033, "Die Leistung konnte nicht validiert werden."));
                        _this.isValidating = false;
                        if (_this.validationFailCounter < 5)
                            setTimeout(function () {
                                _this.validateDocumentation(0);
                                _this.validationFailCounter++;
                            }, 2500);
                    }).finally(function () {
                        _this.loading.validate = false;
                        _this.$qui.scopeApply(_this.$scope);
                    });
                }, debounce);
            };
            /**
             * returns true if error
             * */
            FlsDocumentationController.prototype.webClientValidation = function () {
                var _this = this;
                var _a, _b, _c, _d, _e;
                var result = this.hasPrevMonthLock();
                // WebClient specific validation
                result = this.addOrRemoveError(this.lng.translate(20016228, 'Bitte geben Sie einen validen Wert für Pflichtfeld ‘Gültig von’ ein'), (!this.ui.documentationTimeForm.form[0].config.dateFromNotRequired && isNaN(this.timeForm.dateFrom.valueOf()))) || result;
                result = this.addOrRemoveError(this.lng.translate(20016209, 'Mindestens ein Erbringer muss ausgewählt werden.'), (this.selectedCarerList != undefined && this.selectedCarerList.length === 0 && !this.isGroup && this.isNewDocumentation)) || result;
                result = this.addOrRemoveError(this.lng.translate(20016226, 'Markierungen sind Pflicht. Bitte mindestens eine Markierung markieren.'), ((this.selectedMarkings === null || this.selectedMarkings.length === 0) && this.isMarkingRequired)) || result;
                result = this.addOrRemoveError(this.lng.translate(21003034, 'Bitte einen gültigen Zeitraum angeben.'), (!this.timeForm.dateFrom || !this.timeForm.dateTo || (!this.timeForm.isManualDuration && isNaN(this.timeForm.dateFrom.getTime()))
                    || (!this.timeForm.isManualDuration && isNaN(this.timeForm.dateFrom.getTime())) || this.timeForm.dateFrom > this.timeForm.dateTo)) || result;
                var noReports = true;
                if (this.reportForm.reports)
                    noReports = !this.isReportEntryCommented(this.reportForm.reports, false);
                result = this.addOrRemoveError(this.lng.translate(20016207, "Der Bericht enthält noch keinen Text."), ((!this.allowEmptyReports && noReports) && this.reportForm.templates.length > 0)) || result;
                // if no carer activity forms present, use single form, if thats null as well iterate over an empty array (do nothing)
                var actFormArr = ((_a = this.carerActivityForm) === null || _a === void 0 ? void 0 : _a.length) ? this.carerActivityForm : [this.activityForm];
                var _loop_6 = function (actFormToCheck) {
                    actFormToCheck.warnings = [];
                    actFormToCheck.errors = [];
                    // reset miscontact if disabled
                    if (!actFormToCheck.isMiscontactEnabled)
                        actFormToCheck.miscontactWvId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                    var requiredFields = (_b = actFormToCheck.requiredFields) !== null && _b !== void 0 ? _b : this_3.requiredFields;
                    result = this_3.addOrRemoveError(this_3.lng.translate(20016190, 'Standard ist keine gültige Tätigkeit'), !this_3.standardActivityAllowedIfRequired && actFormToCheck.activityWvId === "bcafd3ce-f25c-410a-a623-75c77eb15d5c" //WVKonstante GC_STANDARDTAETIGKEIT_MA_EXCLUDE
                    ) || result;
                    if (requiredFields) {
                        if (requiredFields.workingHours.activityWvId)
                            result = this_3.addOrRemoveError(this_3.lng.translate(21003030, "Die Tätigkeit muss ausgewählt werden"), (!actFormToCheck.activityWvId || actFormToCheck.activityWvId === QMC.Common.Constants.GUID_EMPTY), actFormToCheck) || result;
                        if (requiredFields.workingHours.careTypeWvId)
                            result = this_3.addOrRemoveError(this_3.lng.translate(21003031, "Die Betreuungsart muss ausgewählt werden"), (!actFormToCheck.careTypeWvId || actFormToCheck.careTypeWvId === QMC.Common.Constants.GUID_EMPTY), actFormToCheck) || result;
                        if (requiredFields.workingHours.contactTypeWvId)
                            result = this_3.addOrRemoveError(this_3.lng.translate(21003032, "Die Kontaktart muss ausgewählt werden"), (!actFormToCheck.contactTypeWvId || actFormToCheck.contactTypeWvId === QMC.Common.Constants.GUID_EMPTY), actFormToCheck) || result;
                        result = this_3.addOrRemoveError(this_3.lng.translate(20016243, "Die Fehlkontaktart muss ausgewählt werden"), actFormToCheck.isMiscontactEnabled && (!actFormToCheck.miscontactWvId || actFormToCheck.miscontactWvId === QMC.Common.Constants.FLS_NO_MISCONTACT), actFormToCheck) || result;
                        result = this_3.checkTitle() || result;
                        if (requiredFields.drivingCost.drivingCostCategoryId) {
                            var error = false;
                            if (((_c = this_3.form.drivingCost) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                                for (var _i = 0, _a = this_3.form.drivingCost; _i < _a.length; _i++) {
                                    var cost = _a[_i];
                                    if ((!cost.drivingCostCategoryId || cost.drivingCostCategoryId === QMC.Common.Constants.GUID_EMPTY) &&
                                        (this_3.validateEmptyDrivingCost || parseFloat(cost.drivingDistance + '') > 0 || parseFloat(cost.hours + '') > 0 || parseFloat(cost.minutes + '') > 0)) {
                                        error = true;
                                        break;
                                    }
                                }
                            }
                            result = this_3.addOrRemoveError(this_3.lng.translate(21003035, "Für jeden Fahrtkostensatz muss eine Fahrtkostenart ausgewählt sein."), (error)) || result;
                        }
                        if (!this_3.validateEmptyDrivingCost && ((_d = this_3.form.drivingCost) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                            var error = false;
                            for (var _b = 0, _c = this_3.form.drivingCost; _b < _c.length; _b++) {
                                var cost = _c[_b];
                                if ((cost.comment || cost.departure || cost.destination || cost.drivingCostCategoryId || cost.isPrivate || cost.isCarPool)
                                    && (!(parseFloat(cost.drivingDistance + '') > 0 || parseFloat(cost.hours + '') > 0 || parseFloat(cost.minutes + '') > 0))) {
                                    error = true;
                                    break;
                                }
                            }
                            result = this_3.addOrRemoveError(this_3.lng.translate(21003045, "Mindestens ein Fahrtkostensatz hat keine Angaben über Dauer oder Strecke."), (error)) || result;
                        }
                    }
                    if (!this_3.isNewDocumentation || this_3.isGroup) {
                        ['warnings', 'errors'].forEach(function (mode) {
                            actFormToCheck[mode].forEach(function (entry) {
                                _this.addIfNotPresent(_this.validation[mode], entry);
                            });
                        });
                    }
                };
                var this_3 = this;
                for (var _i = 0, actFormArr_1 = actFormArr; _i < actFormArr_1.length; _i++) {
                    var actFormToCheck = actFormArr_1[_i];
                    _loop_6(actFormToCheck);
                }
                var dcDefect = false;
                if (this.form.drivingCost && ((_e = this.form.drivingCost) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                    dcDefect = this.form.drivingCost.some(function (cost) { return cost.isCarPool && (!cost.vehicleId || cost.vehicleId === QMC.Common.Constants.GUID_EMPTY); });
                }
                result = this.addOrRemoveError(this.lng.translate(20016180, "Mindestens ein Fahrtkostensatz mit Fuhrparkbezug hat kein ausgewähltes Fahrzeug"), dcDefect) || result;
                result = this.addOrRemoveError(this.lng.translate(20016216, "Die manuelle Dauer muss größer 0 sein."), this.timeForm.isManualDuration && (this.timeForm.isManualTimeRequired && this.timeForm.hours <= 0 && this.timeForm.minutes <= 0)) || result;
                this.udfs.forEach(function (udf) {
                    result = _this.addOrRemoveError(_this.lng.translate(20002065, 'In diesem Tab sind nicht alle Pflichtfelder ausgefüllt') + ": " + udf.caption, !udf.isValid);
                });
                return result;
            };
            FlsDocumentationController.prototype.checkTitle = function () {
                if (!this.requiredFields)
                    return;
                if (this.requiredFields.fls.title) {
                    return this.addOrRemoveError(this.lng.translate(20016196, "Es muss ein Berichttitel angegeben werden."), (!this.form.title || this.form.title.length === 0));
                }
                return false;
            };
            FlsDocumentationController.prototype.addOrRemoveError = function (error, add, carerActForm) {
                if (carerActForm === void 0) { carerActForm = null; }
                if (add)
                    this.addValidation(error, "errors", carerActForm);
                else
                    this.removeValidation(error, "errors", carerActForm);
                return add;
            };
            FlsDocumentationController.prototype.addValidation = function (msg, mode, carerActForm) {
                var _this = this;
                if (carerActForm === void 0) { carerActForm = null; }
                if (!carerActForm || carerActForm[mode] === undefined) {
                    this.addIfNotPresent(this.validation[mode], msg);
                }
                else {
                    // error is already added globally
                    if (this.validation[mode].some(function (x) { return x === msg; }))
                        return;
                    if (!this.checkPresentForMoreCarers(msg, mode)) {
                        this.addIfNotPresent(carerActForm[mode], msg);
                    }
                    else {
                        this.addIfNotPresent(this.validation[mode], msg);
                        this.carerActivityForm.forEach(function (carerForm) {
                            _this.removeValidation(msg, "errors", carerForm);
                        });
                    }
                }
            };
            FlsDocumentationController.prototype.addIfNotPresent = function (arr, str) {
                if (!arr.some(function (x) { return x === str; }))
                    arr.push(str);
            };
            FlsDocumentationController.prototype.checkPresentForMoreCarers = function (msg, mode) {
                var _a;
                return ((_a = this.carerActivityForm) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x[mode].some(function (y) { return y === msg; }); }).length) > 1;
            };
            FlsDocumentationController.prototype.removeValidation = function (error, mode, carerActForm) {
                var _a, _b;
                if (carerActForm === void 0) { carerActForm = null; }
                var src = ((_a = this.carerActivityForm) === null || _a === void 0 ? void 0 : _a.length) ? carerActForm !== null && carerActForm !== void 0 ? carerActForm : this.validation : this.validation;
                src[mode] = (_b = src[mode]) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return x !== error; });
            };
            /**
             * Strip html tags
             *
             * @private
             * @param {any} html
             * @returns {string}
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.strip = function (html) {
                if (!html)
                    return "";
                var textEl = document.createElement("div");
                textEl.innerHTML = html;
                return textEl.textContent.trim();
            };
            /**
             * calls the validation that calls the saveDocumentationAction if successful validated
             *
             * @private
             * @param {any} saveAnyway
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.saveDocumentation = function (saveAnyway) {
                $('#validationModal').modal('show');
                this.lastValidation = null;
                this.validateDocumentation(0, saveAnyway, true, this.saveDocumentationAction.bind(this));
            };
            /**
             * Prepare the data to put / post the documentation
             *
             * @private
             * @param {any} saveAnyway
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.saveDocumentationAction = function (saveAnyway) {
                var _this = this;
                if ((this.validation.warnings.length + this.validation.errors.length === 0) && (this.getWarningErrorsCount(true) + this.getWarningErrorsCount(false) === 0) || saveAnyway && !this.loading.validate) {
                    setTimeout(function () {
                        var form = __assign({}, _this.form);
                        if (_this.strip(_this.emptyDescription).length > 0) {
                            form.description = _this.emptyDescription;
                        }
                        form.flsCaseId = _this.flsCaseIds[0];
                        if (!form.drivingCost)
                            form.drivingCost = [];
                        for (var _i = 0, _a = form.drivingCost; _i < _a.length; _i++) {
                            var element = _a[_i];
                            if (!element.drivingDistance || isNaN(parseFloat(element.drivingDistance + '')))
                                element.drivingDistance = 0;
                            element.duration = _this.ui.convertHours(element.hours, element.minutes >= 0 ? element.minutes : 0);
                            element.drivingCostType = element.isPrivate ? 0 : element.isCarPool ? 1 : 2;
                        }
                        form.workingHours = {
                            abrechenbarkeitId: form.workingHours.abrechenbarkeitId,
                            activityWvId: _this.activityForm.activityWvId,
                            contactTypeWvId: _this.activityForm.contactTypeWvId,
                            careTypeWvId: _this.activityForm.careTypeWvId,
                            miscontactWvId: _this.activityForm.isMiscontactEnabled ? _this.activityForm.miscontactWvId : QMC.Common.Constants.FLS_NO_MISCONTACT
                        };
                        form.isManualDuration = _this.timeForm.isManualDuration;
                        form.dateFrom = _this.timeForm.dateFrom;
                        form.dateTo = _this.timeForm.dateTo;
                        if (!_this.userSettings.dateToEnabled) {
                            form.dateTo = new Date(form.dateFrom.getFullYear(), form.dateFrom.getMonth(), form.dateFrom.getDate(), form.dateTo.getHours(), form.dateTo.getMinutes(), form.dateTo.getSeconds());
                        }
                        if (_this.isGroup) {
                            _this.formatParticipants(form);
                            form.participantCount = _this.participantsForm.participantCount;
                        }
                        form.reports = _this.reportForm.reports;
                        //(<IFlsDocumentationCreate>this.form).isSupportPlanDocu = this.isSupportPlanDocu;
                        form.isSupportPlanDocu = _this.isSupportPlanDocu;
                        form.isManualDuration = _this.timeForm.isManualDuration;
                        if (form.isManualDuration) {
                            _this.timeForm.durationInHours = form.durationInHours = _this.hoursMinutesToDecimal(_this.timeForm.hours, _this.timeForm.minutes); // + unary operator, convert the var into number
                        }
                        form.reportTemplateId = _this.reportForm.templateId;
                        form.isReportTemplateFix = _this.isReportTemplateFix;
                        //Driving Cost
                        _this.formatDrivingCost(form);
                        //remove driving cost if not allowed
                        if (!_this.permissions.drivingCostModuleAccess)
                            delete form.drivingCost;
                        //ellaborative Warning
                        if (form.warning && _this.elaborativeWarning) {
                            form.warningReasons = {};
                            for (var item in _this.elaborativeWarningData) {
                                if (_this.elaborativeWarningData[item].active)
                                    form.warningReasons[item] = _this.elaborativeWarningData[item].comment;
                            }
                        }
                        document.body.scrollTop = document.documentElement.scrollTop = 0;
                        _this.loading.save = true;
                        $('#validationModal').modal('hide');
                        if (_this.formState === 'new') {
                            _this.postDocumentation(form);
                        }
                        else {
                            _this.putDocumentation(form);
                        }
                        _this.udfs.forEach(function (x) { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
                    });
                }
            };
            /**
             * Updates an existing fls documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.putDocumentation = function (form) {
                var _this = this;
                //Special case when a docu with manual duration was opened, manual duration is foridden and time was not changed while editing
                if (this.timeForm.durationInHours !== this.diffHours(form.dateFrom, form.dateTo) && this.timeForm.isManualDuration && !this.timeForm.isManualTimeAllowed) {
                    form.isManualDuration = true;
                    form.durationInHours = this.timeForm.durationInHours;
                }
                this.fachleistungService.putFlsDocumentation(form.id, form, this.carersIds[0], this.modifiyDescription && this.shouldDisable()).then(function () {
                    _this.isSaving = false;
                    _this.ui.notify(_this.ui.successNote);
                    if ($('.modal-backdrop') !== null)
                        $('.modal-backdrop').remove();
                    _this.leaveState();
                }).catch(function (e) { return _this.handleSaveActionError(e); });
            };
            FlsDocumentationController.prototype.diffHours = function (dt2, dt1) {
                var diff = (dt2.getTime() - dt1.getTime()) / 1000;
                diff /= (60 * 60);
                return Math.abs(Math.round(diff));
            };
            /**
             * Post an existing fls documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.postDocumentation = function (form) {
                var _this = this;
                //Carers
                for (var _i = 0, _a = this.carerActivityForm; _i < _a.length; _i++) {
                    var element = _a[_i];
                    if (element.errors.length === 0) {
                        var addCarer = {
                            carerId: element.carerId,
                            workingHours: {
                                activityWvId: element.activityWvId,
                                contactTypeWvId: element.contactTypeWvId,
                                careTypeWvId: element.careTypeWvId,
                                miscontactWvId: element.isMiscontactEnabled ? element.miscontactWvId : QMC.Common.Constants.FLS_NO_MISCONTACT
                            }
                        };
                        form.carers.push(addCarer);
                    }
                }
                //remove duplicates
                form.carers = form.carers.slice().reverse().filter(function (v, i, a) { return a.findIndex(function (t) { return (t.carerId === v.carerId); }) === i; }).reverse();
                // make sure only ´currently selected carers remain
                form.carers = form.carers.filter(function (x) { return _this.selectedCarerList.indexOf(x.carerId) >= 0; });
                // create array of docus, one for each case (new multiple cases)
                var dataArray = [];
                for (var i = 0; i < this.flsCaseIds.length; i++) {
                    var data = jQuery.extend(true, {}, form);
                    data.flsCaseId = this.flsCaseIds[i];
                    data.documentationId = this.documentationIds[i];
                    for (var _b = 0, _c = this.cases; _b < _c.length; _b++) {
                        var element = _c[_b];
                        if (element.objectId === this.flsCaseIds[i]) {
                            data.referencedPersonId = element.clientObjectId;
                            if (element.isAccountableRuleFix)
                                data.workingHours.abrechenbarkeitId = element.defaultAccountableRuleId;
                        }
                    }
                    data.additionalFls = this.additionalFls;
                    data.additionalFlsText = this.additionalFls ? this.additionalFlsText : "";
                    dataArray.push(data);
                }
                this.fachleistungService.postFlsDocumentation(dataArray, this.timeForm.distributeHours, null, dataArray.length > 1 || dataArray[0].carers.length > 1).then(function () {
                    _this.isSaving = false;
                    _this.ui.notify(_this.ui.successNote);
                    _this.continueDialog();
                }).catch(function (e) { return _this.handleSaveActionError(e); });
            };
            /**
             * Format the form particiants, by group members
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.formatParticipants = function (form) {
                var _a, _b;
                if (form === void 0) { form = this.form; }
                form.participants = new Array();
                var participants = (_a = this.participantsForm.participantEmployees) !== null && _a !== void 0 ? _a : [];
                if (!this.group.onlyNumberOfParticipants)
                    participants = participants.concat((_b = this.participantsForm.participants) !== null && _b !== void 0 ? _b : []);
                if (participants && participants.length > 0) {
                    var _loop_7 = function (part) {
                        var members = this_4.group.data.members.filter(function (x) { return x.objectId === part; });
                        if (members.length > 0) {
                            form.participants.push({
                                objectId: members[0].objectId,
                                isEmployee: members[0].objectType === QMC.Common.Constants.OBJECTTYPE_EMPLOYEE,
                                isGroupMember: true
                            });
                        }
                        else {
                            form.participants.push({
                                objectId: part,
                                isEmployee: false,
                                isGroupMember: false
                            });
                        }
                    };
                    var this_4 = this;
                    for (var _i = 0, participants_1 = participants; _i < participants_1.length; _i++) {
                        var part = participants_1[_i];
                        _loop_7(part);
                    }
                }
                if (!this.group.onlyNumberOfParticipants) {
                    if (form.participants)
                        form.participantCount = form.participants.length;
                    else
                        form.participantCount = 0;
                }
            };
            FlsDocumentationController.prototype.inArray = function (array, id) {
                if (!array || !id)
                    return null;
                for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                    var element = array_1[_i];
                    return (element.objectId === id);
                }
                return false;
            };
            /**
             * Checks if the user should be asked if the docu should be signed right away, and asks him.
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.continueDialog = function () {
                $('#afterSaveActionModal').modal('show');
            };
            FlsDocumentationController.prototype.leaveState = function () {
                var _this = this;
                localStorage.removeItem(this.cachingObjectName);
                localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                    state: this.$state.$current.name,
                    params: {
                        plannedDocumentationId: this.$stateParams.plannedDocumentationId,
                        flsCaseIds: this.$stateParams.flsCaseIds
                    }
                }));
                if ($('.modal-backdrop') !== null)
                    $('.modal-backdrop').remove();
                this.$timeout(function () {
                    _this.$state.go(_this.returnState.state, _this.returnState.params);
                });
            };
            FlsDocumentationController.prototype.afterSaveAction = function (action) {
                $('#afterSaveActionModal').modal('hide');
                // saving completed, clear cache
                localStorage.removeItem(this.cachingObjectName);
                switch (action) {
                    case 'sign':
                        this.$state.go("signaturedetail", { id: this.documentationIds[0] });
                        break;
                    case 'more':
                        this.$state.go('documentationnew', { flsCaseIds: this.flsCaseIds, plannedDocumentationId: undefined }, { reload: true });
                        break;
                    default:
                        this.leaveState();
                        break;
                }
            };
            /**
             * get the smart action client list
             *
             * @private
             *
             * @memberOf TagebuchListController
             */
            FlsDocumentationController.prototype.getSmartActionClientAndEmployeeList = function () {
                var _this = this;
                var lngTagClient = this.lng.translate(21002000, 'Klient');
                var lngTagEmployee = this.lng.translate(20000235, 'Mitarbeiter');
                this.clientService.getClientAndEmployeeList('', true).then(function (data) {
                    _this.smartClientAndEmployeeList = data.map(function (obj) {
                        var textValue = '';
                        if (obj.objectType === 140000) {
                            textValue = obj.displayTitle + ' (' + lngTagClient + ')';
                        }
                        else {
                            textValue = obj.displayTitle + ' (' + lngTagEmployee + ')';
                        }
                        return {
                            text: textValue,
                            value: obj.objectId,
                            objType: obj.objectType
                        };
                    });
                }).finally(function () { return _this.$qui.functionWaiter('createSummernote', _this); });
            };
            FlsDocumentationController.prototype.handleSaveActionError = function (e) {
                if (e.data)
                    e = e.data;
                this.saveErrors = [];
                // first try to gather all error msgs in one handy array
                if (typeof e === 'string')
                    this.saveErrors.push(e);
                if (typeof e === 'object') {
                    if (e.fieldErrors)
                        this.saveErrors = this.saveErrors.concat(e.fieldErrors);
                    if (e.FieldErrors)
                        this.saveErrors = this.saveErrors.concat(e.FieldErrors);
                    if (e.fieldError)
                        this.saveErrors.push(e.fieldError);
                    if (e.FieldError)
                        this.saveErrors.push(e.FieldError);
                    if (e.globalErrors)
                        this.saveErrors = this.saveErrors.concat(e.globalErrors);
                    if (e.GlobalErrors)
                        this.saveErrors = this.saveErrors.concat(e.GlobalErrors);
                    if (e.globalError)
                        this.saveErrors.push(e.globalError);
                    if (e.GlobalError)
                        this.saveErrors.push(e.GlobalError);
                }
                if (Array.isArray(e)) {
                    this.saveErrors = this.saveErrors.concat(e);
                }
                $('#saveErrorModal').modal('show');
            };
            FlsDocumentationController.prototype.afterErrorAction = function (action) {
                $('#saveErrorModal').modal('hide');
                // saving completed, clear cache
                switch (action) {
                    case 'reloadCacheless':
                        localStorage.removeItem(this.cachingObjectName);
                        this.$state.reload();
                        break;
                    case 'reload':
                        this.$state.reload();
                        break;
                    case 'case':
                        this.$state.go('case');
                        break;
                    case 'docu':
                        this.$state.go('documentation');
                        break;
                    default:
                        this.leaveState();
                        break;
                }
            };
            /////////////// DELETE DOCUMENTATION ///////////////
            /**
             * delete the current fls documentation
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.deleteDocumentation = function () {
                var _this = this;
                console.log("delete docu", this.deleteDocu);
                this.fachleistungService.deleteFlsDocumentation(this.deleteDocu.deleteItemId, { deleteReasonText: this.deleteDocu.deleteText, deleteReasonWvId: this.deleteDocu.deleteReason }).then(function () {
                    _this.ui.notify(_this.ui.deleteNote);
                    _this.leaveState();
                }).catch(function (e) { return _this.handleSaveActionError(e); });
            };
            /**
             * open die delete modal, prepare the data.
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.openDeleteDokuModal = function () {
                this.deleteDocu.deleteItemId = this.form.objectId;
                if (this.isReportEntryCommented(this.reportForm.reports)) {
                    QMC.Common.Utilities.confirm(this.promptOptiondsDeleteDokuWithText, function (response) {
                        if (response) {
                            $('#deleteDokuModal').modal('toggle');
                        }
                    }, '#promptDeleteDokuWithText');
                }
                else {
                    $('#deleteDokuModal').modal('toggle');
                }
            };
            /////////////// ADDITIONAL COST ///////////////
            /**
             * add an additional cost
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.addAdditionalCost = function () {
                var wv = this.getCurrentGenericWvList();
                var newCost = {
                    id: null,
                    objectId: null,
                    additionalCostTypeId: wv.additionalCostTypeWv.length > 0 ? wv.additionalCostTypeWv[0].objectId : null,
                    accountabilityTypeId: wv.additionalCostAccountabilityTypeWv.length > 0 ? wv.additionalCostAccountabilityTypeWv[0].objectId : null,
                    amount: 0,
                    quantity: 1,
                    durration: 0,
                    comment: "",
                    additionalCostType: null,
                    accountabilityType: null,
                };
                if (!this.form.additionalCost)
                    this.form.additionalCost = [];
                if (wv.additionalCostAccountabilityTypeWv.length >= 2)
                    newCost.accountabilityTypeId = wv.additionalCostAccountabilityTypeWv[1].objectId;
                this.form.additionalCost.push(newCost);
            };
            /**
             * remove an additional cost
             *
             * @private
             * @param {(IFlsDocumentationAdditionalCostCreate | IFlsDocumentationAdditionalCostUpdate)} cost
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.deleteAdditionalCost = function (cost) {
                this.form.additionalCost = this.form.additionalCost.filter(function (obj) {
                    return obj !== cost;
                });
            };
            FlsDocumentationController.prototype.initDcData = function () {
                var _this = this;
                if (this.isDcInit)
                    return;
                this.isDcInit = true;
                this.loading.ressources = true;
                this.fachleistungService.getVehicleList().then(function (dataV) {
                    _this.vehiclesMap = dataV.map(function (x) { return ({ value: x.objectId, text: x.displayTitle }); });
                    _this.vehiclesMap.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: '' });
                    _this.loading.ressources = false;
                });
                this.clientService.getAllAddresses().then(function (data) {
                    _this.drivingAddresses = _this.ui.formatAddresses(data);
                });
            };
            /**
             * add a driving cost
             *
             * @private
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.addDrivingCost = function (cost, isLoadingTheDocumentation) {
                var _this = this;
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (!isLoadingTheDocumentation) {
                    if (this.loading.wv || !this.requiredFields || !this.requiredFields.drivingCost) {
                        setTimeout(function () {
                            _this.addDrivingCost(cost, false);
                        }, 500);
                        return;
                    }
                    if (!cost) {
                        cost = {
                            hours: 0,
                            minutes: 0,
                            duration: 0,
                            drivingDistance: 0,
                            drivingCostCategoryId: this.getdrivingCostCategoryId(),
                            chargingMethodId: "ecaf4b95-1915-4370-9d9a-b5842bd797cb",
                            departure: "",
                            destination: "",
                            vehicle: "",
                            dateOfArrival: (_a = this.form.dateFrom) !== null && _a !== void 0 ? _a : new Date(),
                            dateOfDeparture: (_b = this.form.dateFrom) !== null && _b !== void 0 ? _b : new Date(),
                            timeOfArrival: (_c = this.form.dateFrom) !== null && _c !== void 0 ? _c : new Date(),
                            timeOfDeparture: (_d = this.form.dateFrom) !== null && _d !== void 0 ? _d : new Date(),
                            isPrivate: false,
                            isCarPool: false,
                            synchronize: true,
                            mileageArrival: 0,
                            mileageDeparture: 0,
                            comment: "",
                            drivingCostType: 0,
                            isBlocked: false,
                            isDrivingValidating: false,
                            objectId: QMC.Common.Constants.GUID_EMPTY,
                            vehicleId: QMC.Common.Constants.GUID_EMPTY,
                            watcherList: null
                        };
                        if (this.flsDocumentationEditorSettings) {
                            cost.dateOfArrival.setHours(this.flsDocumentationEditorSettings.defaultHour);
                            (_e = cost.dateOfArrival) === null || _e === void 0 ? void 0 : _e.setMinutes(0);
                            cost.dateOfDeparture.setHours(this.flsDocumentationEditorSettings.defaultHour);
                            cost.dateOfDeparture.setMinutes(0);
                            cost.timeOfArrival.setHours(this.flsDocumentationEditorSettings.defaultHour);
                            cost.timeOfArrival.setMinutes(0);
                            cost.timeOfDeparture.setHours(this.flsDocumentationEditorSettings.defaultHour);
                            cost.timeOfDeparture.setMinutes(0);
                        }
                    }
                    else {
                        cost.isPrivate = cost.isPrivate || (!cost.vehicleId && !cost.dateOfDeparture);
                        cost.isCarPool = cost.isCarPool || (!cost.isPrivate && !cost.dateOfDeparture);
                        if (!cost.dateOfArrival)
                            cost.dateOfArrival = (_f = this.form.dateFrom) !== null && _f !== void 0 ? _f : new Date();
                        if (!cost.dateOfDeparture)
                            cost.dateOfDeparture = (_g = this.form.dateFrom) !== null && _g !== void 0 ? _g : new Date();
                        if (!cost.timeOfArrival)
                            cost.timeOfArrival = (_h = this.form.dateFrom) !== null && _h !== void 0 ? _h : new Date();
                        if (!cost.timeOfDeparture)
                            cost.timeOfDeparture = (_j = this.form.dateFrom) !== null && _j !== void 0 ? _j : new Date();
                        cost.synchronize = true;
                    }
                    cost.dateOfArrival.setSeconds(0);
                    cost.dateOfDeparture.setSeconds(0);
                    cost.timeOfArrival.setSeconds(0);
                    cost.timeOfDeparture.setSeconds(0);
                    if (!this.form.drivingCost) {
                        this.form.drivingCost = [];
                    }
                    else {
                        if (this.form.drivingCost.length === 1 && !this.form.drivingCost[0].objectId) {
                            //the drivingCost array is filled when creating the forms, documentationDrivingCostsForm, is not a real IFlsDocumentationDrivingCost
                            //since we are filling the array with the right one here, remove the one created automatically
                            this.form.drivingCost = [];
                        }
                    }
                    var index = this.form.drivingCost.length;
                    this.form.drivingCost.push(cost);
                    this.addEventValidations(index);
                }
                else {
                    for (var i = 0; i < this.form.drivingCost.length; i++) {
                        this.addEventValidations(i);
                    }
                }
            };
            FlsDocumentationController.prototype.getdrivingCostCategoryId = function () {
                var wv = this.getCurrentGenericWvList();
                if (wv && wv.drivingCostCategoryWv.length > 0) {
                    return this.requiredFields.drivingCost.drivingCostCategoryId && wv.drivingCostCategoryWv.length === 1 ? wv.drivingCostCategoryWv[0].objectId : null;
                }
                else {
                    var wvCarerList = this.getCarerWvList($('#session').data().personId);
                    return this.requiredFields.drivingCost.drivingCostCategoryId && wvCarerList.drivingCostCategoryWv && wvCarerList.drivingCostCategoryWv.length === 1 ? wvCarerList.drivingCostCategoryWv[0].objectId : null;
                }
            };
            FlsDocumentationController.prototype.addEventValidations = function (index) {
                var _this = this;
                var isDcTabActive = function () {
                    return $('#drivingCostTab').hasClass('active');
                };
                this.$timeout(function () {
                    _this.createTypeAhead();
                    _this.form.drivingCost[index].watcherList = [];
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].isPrivate', function (newValue, oldValue) {
                        if (!_this.loading.save && isDcTabActive && newValue && newValue !== oldValue) {
                            _this.form.drivingCost[index].isCarPool = false;
                            _this.initCostArrDep(_this.form.drivingCost[index]);
                            _this.$qui.scopeApply(_this.$scope);
                        }
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].isCarPool', function (newValue, oldValue) {
                        if (!_this.loading.save && isDcTabActive && newValue && newValue !== oldValue) {
                            _this.form.drivingCost[index].isPrivate = false;
                            _this.initCostArrDep(_this.form.drivingCost[index]);
                            _this.$qui.scopeApply(_this.$scope);
                            _this.validateDocumentation(0);
                        }
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].drivingDistance', function (newValue, oldValue) {
                        if (!_this.loading.save && isDcTabActive && newValue !== oldValue && _this.form.drivingCost[index]) {
                            _this.updateMileage(_this.form.drivingCost[index], 'distance');
                            _this.webClientValidation();
                        }
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].mileageDeparture', function (newValue, oldValue) {
                        if (!_this.loading.save && isDcTabActive && newValue !== oldValue && _this.form.drivingCost[index])
                            _this.updateMileage(_this.form.drivingCost[index], 'departure');
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].mileageArrival', function (newValue, oldValue) {
                        if (!_this.loading.save && isDcTabActive && newValue !== oldValue && _this.form.drivingCost[index])
                            _this.updateMileage(_this.form.drivingCost[index], 'arrival');
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].timeOfArrival', function (newValue, oldValue) {
                        if (!_this.loading.save && isDcTabActive && newValue !== oldValue && _this.form.drivingCost[index])
                            _this.validateDrivingTime(_this.form.drivingCost[index], 'timeOfArrival');
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].timeOfDeparture', function (newValue, oldValue) {
                        if (!_this.loading.save && isDcTabActive && newValue !== oldValue && _this.form.drivingCost[index])
                            _this.validateDrivingTime(_this.form.drivingCost[index], 'timeOfDeparture');
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].dateOfArrival', function (newValue, oldValue) {
                        if (!_this.loading.save && isDcTabActive && newValue !== oldValue && _this.form.drivingCost[index])
                            _this.validateDrivingTime(_this.form.drivingCost[index], 'arrival');
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].dateOfDeparture', function (newValue, oldValue) {
                        if (!_this.loading.save && isDcTabActive && newValue !== oldValue && _this.form.drivingCost[index])
                            _this.validateDrivingTime(_this.form.drivingCost[index], 'departure');
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].hours', function (newValue, oldValue) {
                        if (!_this.loading.save && newValue !== oldValue && _this.form.drivingCost[index]) {
                            _this.form.drivingCost[index].hours = _this.cleanInputNumber(_this.form.drivingCost[index].hours);
                            _this.webClientValidation();
                            _this.validateDrivingTime(_this.form.drivingCost[index], 'costHoursMinutes');
                        }
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].minutes', function (newValue, oldValue) {
                        if (!_this.loading.save && newValue !== oldValue && _this.form.drivingCost[index]) {
                            var minutes = _this.cleanInputNumber(_this.form.drivingCost[index].minutes);
                            var hours = _this.cleanInputNumber(_this.form.drivingCost[index].hours);
                            while (minutes >= 60) {
                                minutes = minutes - 60;
                                hours = hours + 1;
                            }
                            _this.form.drivingCost[index].minutes = minutes;
                            _this.form.drivingCost[index].hours = hours;
                            _this.webClientValidation();
                            _this.validateDrivingTime(_this.form.drivingCost[index], 'costHoursMinutes');
                        }
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].synchronize', function (newValue, oldValue) {
                        var _a;
                        if (!_this.loading.save && isDcTabActive && newValue !== oldValue && ((_a = _this.form.drivingCost[index]) === null || _a === void 0 ? void 0 : _a.synchronize)) {
                            if (!_this.form.drivingCost[index].mileageDeparture)
                                _this.form.drivingCost[index].mileageDeparture = 0;
                            if (!_this.form.drivingCost[index].mileageArrival)
                                _this.form.drivingCost[index].mileageArrival = 0;
                            if (!_this.form.drivingCost[index].drivingDistance)
                                _this.form.drivingCost[index].drivingDistance = 0;
                            _this.form.drivingCost[index].drivingDistance = _this.form.drivingCost[index].mileageArrival - _this.form.drivingCost[index].mileageDeparture;
                            _this.validateDrivingTime(_this.form.drivingCost[index], 'departure');
                        }
                    }));
                    _this.form.drivingCost[index].watcherList.push(_this.$scope.$watch('vm.form.drivingCost[' + index + '].drivingCostCategoryId', function (newValue, oldValue) {
                        if (!_this.loading.save && newValue !== oldValue && _this.form.drivingCost[index])
                            _this.webClientValidation();
                    }));
                });
            };
            /**
             * remove a driving cost
             *
             * @private
             * @param {(IFlsDocumentationAdditionalCostCreate | IFlsDocumentationAdditionalCostUpdate)} cost
             *
             * @memberof FlsDocumentationController
             */
            FlsDocumentationController.prototype.deleteDrivingCost = function (cost) {
                if (cost.watcherList)
                    for (var _i = 0, _a = cost.watcherList; _i < _a.length; _i++) {
                        var element = _a[_i];
                        element();
                    }
                this.form.drivingCost = this.form.drivingCost.filter(function (obj) {
                    return obj !== cost;
                });
                this.webClientValidation();
            };
            FlsDocumentationController.prototype.getMileage = function (cost, index) {
                if (cost.isPrivate || !cost.vehicleId || cost.vehicleId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                var sum = 0;
                var first = true;
                for (var i = 0; i < index; i++) {
                    if (this.form.drivingCost[i].vehicleId === cost.vehicleId) {
                        first = false;
                        sum = sum + parseInt(this.form.drivingCost[i].mileageArrival + "");
                    }
                }
                if (!first) {
                    cost.mileageDeparture = sum;
                    cost.mileageArrival = sum + parseInt(cost.drivingDistance + "");
                    return;
                }
                this.fachleistungService.getMileage(cost.vehicleId).then(function (mileage) {
                    console.log(mileage);
                    cost.mileageDeparture = mileage;
                    cost.mileageArrival = parseInt(mileage + "") + parseInt(cost.drivingDistance + "");
                });
            };
            FlsDocumentationController.prototype.updateMileage = function (cost, origin) {
                var _this = this;
                if (!cost.mileageDeparture)
                    cost.mileageDeparture = 0;
                if (!cost.mileageArrival)
                    cost.mileageArrival = 0;
                if (!cost.drivingDistance)
                    cost.drivingDistance = 0;
                if ((!cost.synchronize && cost.drivingDistance === 0) || (!cost.isCarPool && !cost.isPrivate))
                    return;
                switch (origin) {
                    case 'arrival':
                        var current_1 = parseFloat(cost.mileageArrival.toString());
                        setTimeout(function () {
                            if (current_1 !== parseFloat(cost.mileageArrival.toString()))
                                return;
                            if (parseFloat(cost.mileageArrival.toString()) < parseFloat(cost.mileageDeparture.toString()))
                                cost.mileageArrival = parseInt(cost.mileageDeparture.toString());
                            var calcDist = parseFloat(cost.mileageArrival.toString()) - parseFloat(cost.mileageDeparture.toString());
                            if (calcDist !== Math.round(cost.drivingDistance))
                                cost.drivingDistance = calcDist;
                            _this.$qui.scopeApply(_this.$scope);
                        }, 500);
                        break;
                    case 'departure':
                        cost.mileageArrival = Math.round(parseFloat(cost.mileageDeparture.toString()) + parseFloat(cost.drivingDistance.toString()));
                        break;
                    case 'distance':
                        cost.mileageArrival = Math.round(parseFloat(cost.mileageDeparture.toString()) + parseFloat(cost.drivingDistance.toString()));
                        break;
                }
                this.$qui.scopeApply(this.$scope);
            };
            FlsDocumentationController.prototype.validateDrivingTime = function (cost, origin) {
                var _a, _b;
                if (cost.isDrivingValidating || this.lastDrivingCost === JSON.stringify(cost) || this.isSaving)
                    return;
                if (!$('#drivingCostTab').hasClass('active') || origin === 'costHoursMinutes')
                    return; //only redo validation if the tab is active or base data is changed
                cost.isDrivingValidating = true;
                var init = (!cost.dateOfDeparture || !cost.dateOfArrival || !cost.timeOfDeparture || !cost.timeOfArrival) && (cost.isPrivate || cost.isCarPool);
                if (!cost.dateOfDeparture)
                    cost.dateOfDeparture = this.$qui.createDateFromString(angular.copy(this.timeForm.dateFrom));
                if (!cost.dateOfArrival)
                    cost.dateOfArrival = this.$qui.createDateFromString(angular.copy(this.timeForm.dateTo));
                if (!cost.timeOfDeparture)
                    cost.timeOfDeparture = this.$qui.createDateFromString(angular.copy(this.timeForm.dateFrom));
                if (!cost.timeOfArrival)
                    cost.timeOfArrival = this.$qui.createDateFromString(angular.copy(this.timeForm.dateTo));
                // make sure all values are consistent and complete
                cost.timeOfArrival = this.$qui.addTimeToDate(cost.dateOfArrival, cost.timeOfArrival);
                cost.timeOfDeparture = this.$qui.addTimeToDate(cost.dateOfDeparture, cost.timeOfDeparture);
                cost.dateOfArrival = angular.copy(cost.timeOfArrival);
                cost.dateOfDeparture = angular.copy(cost.timeOfDeparture);
                if (init) {
                    var hourMinutes = this.getHoursMinutesForDrivingCost(cost);
                    cost.hours = hourMinutes[0];
                    cost.minutes = hourMinutes[1];
                }
                var hours = 0;
                var minutes = 0;
                switch (origin) {
                    case 'costHoursMinutes':
                        if ((cost.hours === 0 && cost.hours === null) || (cost.minutes === 0 && cost.minutes === null)) {
                            cost.dateOfDeparture = this.$qui.createDateFromString(angular.copy(this.timeForm.dateFrom));
                            cost.dateOfArrival = this.$qui.createDateFromString(angular.copy(this.timeForm.dateTo));
                            cost.timeOfDeparture = this.$qui.createDateFromString(angular.copy(this.timeForm.dateFrom));
                            cost.timeOfArrival = this.$qui.createDateFromString(angular.copy(this.timeForm.dateTo));
                            break;
                        }
                        hours = cost.hours;
                        minutes = (cost.minutes === 0 || cost.minutes === null) ? 0 : cost.minutes;
                        var arrivalTime = this.$qui.createDateFromString(cost.dateOfDeparture);
                        arrivalTime.setHours(arrivalTime.getHours() + hours);
                        if (!cost.synchronize || (cost.synchronize && !(cost.isCarPool || cost.isPrivate))) {
                        }
                        else {
                            if (this.$qui.createDateFromString(arrivalTime.getTime() + minutes * 60000) !== cost.timeOfArrival) {
                                var newDateTime = this.$qui.addTimeToDate(cost.dateOfDeparture, cost.timeOfDeparture);
                                newDateTime = moment(newDateTime).add(hours, 'hours').add(minutes, 'minutes').toDate();
                                cost.dateOfArrival = newDateTime;
                                cost.timeOfArrival = newDateTime;
                            }
                        }
                        break;
                    case 'arrival':
                    case 'timeOfArrival':
                        if (cost.timeOfArrival < cost.timeOfDeparture) {
                            cost.timeOfDeparture = angular.copy(cost.timeOfArrival);
                            cost.dateOfDeparture = angular.copy(cost.dateOfArrival);
                        }
                        _a = this.getHoursMinutesForDrivingCost(cost), hours = _a[0], minutes = _a[1];
                        if (!cost.synchronize || (cost.synchronize && !(cost.isCarPool || cost.isPrivate))) {
                        }
                        else {
                            cost.hours = hours;
                            cost.minutes = minutes;
                        }
                        break;
                    case 'departure':
                    case 'timeOfDeparture':
                        if (cost.timeOfArrival < cost.timeOfDeparture) {
                            cost.timeOfArrival = angular.copy(cost.timeOfDeparture);
                            cost.dateOfArrival = angular.copy(cost.dateOfDeparture);
                        }
                        _b = this.getHoursMinutesForDrivingCost(cost), hours = _b[0], minutes = _b[1];
                        if (!cost.synchronize || (cost.synchronize && !(cost.isCarPool || cost.isPrivate))) {
                        }
                        else {
                            cost.hours = hours;
                            cost.minutes = minutes;
                        }
                        break;
                }
                cost.isDrivingValidating = false;
                this.lastDrivingCost = JSON.stringify(cost);
                this.$qui.scopeApply(this.$scope);
            };
            FlsDocumentationController.prototype.getHoursMinutesForDrivingCost = function (cost) {
                var _a;
                var hours = 0;
                var minutes = 0;
                _a = this.$qui.convertDec((cost.timeOfArrival.getTime() - cost.timeOfDeparture.getTime()) / 36e5), hours = _a[0], minutes = _a[1];
                if (minutes === 60) {
                    minutes = 0;
                    hours = hours + 1;
                }
                return [hours, minutes];
            };
            FlsDocumentationController.prototype.initCostArrDep = function (cost) {
                if (!isNaN(this.timeForm.dateFrom.valueOf())) {
                    if (!cost.dateOfDeparture)
                        cost.dateOfDeparture = angular.copy(this.timeForm.dateFrom);
                }
                this.validateDrivingTime(cost, 'costHoursMinutes');
                this.updateMileage(cost, 'departure');
            };
            FlsDocumentationController.prototype.formatDrivingCost = function (form) {
                if (form === void 0) { form = this.form; }
                for (var _i = 0, _a = form.drivingCost; _i < _a.length; _i++) {
                    var element = _a[_i];
                    if (!element.isPrivate)
                        delete element.vehicle;
                    if (!element.isCarPool)
                        delete element.vehicleId;
                    if (!element.isPrivate && !element.isCarPool) {
                        delete element.dateOfDeparture;
                        delete element.dateOfArrival;
                        delete element.timeOfArrival;
                        delete element.timeOfDeparture;
                    }
                    else {
                        element.timeOfArrival.setSeconds(0, 0);
                        element.timeOfDeparture.setSeconds(0, 0);
                        element.dateOfArrival.setSeconds(0, 0);
                        element.dateOfDeparture.setSeconds(0, 0);
                    }
                    delete element.isCarPool;
                    delete element.isPrivate;
                    delete element.synchronize;
                    element.duration = this.hoursMinutesToDecimal(element.hours, element.minutes);
                }
            };
            FlsDocumentationController.prototype.openElaborativeWarningModal = function () {
                if (this.elaborativeWarning) {
                    $('#elaborativeWarningModal').modal('show');
                }
            };
            FlsDocumentationController.prototype.createElobaritveWarningObject = function () {
                var result = {};
                for (var item in this.elaborativeWarningData) {
                    if (this.elaborativeWarningData[item].active)
                        result[item] = this.elaborativeWarningData[item].comment;
                }
                return result;
            };
            FlsDocumentationController.prototype.getInternalElobaritveWarningObject = function (data) {
                var result = {};
                for (var id in data) {
                    result[id] = { active: true, comment: data[id] };
                }
                return result;
            };
            FlsDocumentationController = __decorate([
                QMC.Controller('QMC.Fachleistung', 'FlsDocumentationController'),
                QMC.Inject('$location', 'FachleistungService', '$qui', '$stateParams', '$scope', '$state', '$timeout', 'KlientService', 'UserService', 'QmcLanguageService', 'QmcPermissionService', 'QmcMarkItemService', 'QmcUdfService')
            ], FlsDocumentationController);
            return FlsDocumentationController;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsDocumentationEndingConfirmationController = /** @class */ (function () {
            function FlsDocumentationEndingConfirmationController(flsService, $scope, $qui, userService, permissionService, lng) {
                this.flsService = flsService;
                this.$scope = $scope;
                this.$qui = $qui;
                this.userService = userService;
                this.permissionService = permissionService;
                this.lng = lng;
                this.isLoading = false;
                this.setDate = null;
                this.cases = [];
                this.init();
                $qui.init($qui.getSectionColor("/fls/documentation"), function () {
                    //$qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                this.promptOptions = {
                    title: "Fachleistungen",
                    yesNo: true,
                    icon: "qm-icon-clock",
                    text: this.lng.translate(20016137, 'Erfassungsende wirklich setzen? Änderungen werden bis zu dem angegebenen Datum nicht mehr möglich sein.')
                };
            }
            FlsDocumentationEndingConfirmationController.prototype.init = function () {
                var _this = this;
                this.isLoading = true;
                this.cases = [];
                this.userService.getUserSettings(['FACHLSDOKU.ERFASSUNGENDE.AKTIV'], false).then(function (data) {
                    _this.permissionService.getPermissionsByObjectTypes([230017]).then(function (dataPerm) {
                        _this.newPermission = data[0].value.toLowerCase() === "true" && dataPerm[0].new;
                        _this.modifyPermission = data[0].value.toLowerCase() === "true" && dataPerm[0].modify;
                        _this.deletePermission = data[0].value.toLowerCase() === "true" && dataPerm[0].delete;
                        _this.viewPermission = data[0].value.toLowerCase() === "true" && dataPerm[0].view;
                        if (_this.viewPermission)
                            _this.flsService.getDocEndingConfirmList().then(function (data) {
                                // Format lock date for date input fields
                                for (var i = 0; i < data.length; i++) {
                                    if (data[i].lockDate !== null) {
                                        data[i].lockDate = _this.$qui.createDateFromString(data[i].lockDate.toString());
                                        data[i].dbLockDate = _this.$qui.createDateFromString(data[i].lockDate.toString());
                                    }
                                    else {
                                        data[i].lockDate = null;
                                        data[i].dbLockDate = null;
                                    }
                                }
                                _this.cases = data;
                                _this.isLoading = false;
                            });
                    });
                });
            };
            FlsDocumentationEndingConfirmationController.prototype.setLockDates = function () {
                for (var i = 0; i < this.cases.length; i++) {
                    if (this.cases[i].dbLockDate !== null) {
                        if (this.cases[i].dbLockDate < this.setDate) {
                            this.cases[i].lockDate = this.setDate;
                        }
                        else {
                            this.cases[i].lockDate = this.cases[i].dbLockDate;
                        }
                    }
                    else {
                        this.cases[i].lockDate = this.setDate;
                    }
                }
            };
            FlsDocumentationEndingConfirmationController.prototype.saveLockDates = function () {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data) {
                        for (var _i = 0, _a = _this.cases; _i < _a.length; _i++) {
                            var cCase = _a[_i];
                            if (!cCase.lockDate)
                                continue;
                            if (!cCase.id && cCase.id !== QMC.Common.Constants.GUID_EMPTY) {
                                _this.postLockDate(cCase);
                            }
                            else {
                                _this.putLockDate(cCase);
                            }
                        }
                        setTimeout(function () {
                            _this.init();
                        }, 500);
                    }
                });
            };
            FlsDocumentationEndingConfirmationController.prototype.postLockDate = function (flsCase) {
                this.flsService.postDocEndingConfirm(flsCase);
            };
            FlsDocumentationEndingConfirmationController.prototype.putLockDate = function (flsCase) {
                this.flsService.putDocEndingConfirm(flsCase.id, flsCase);
            };
            FlsDocumentationEndingConfirmationController = __decorate([
                QMC.Controller('QMC.Fachleistung', 'FlsDocumentationEndingConfirmationController'),
                QMC.Inject('FachleistungService', '$scope', '$qui', 'UserService', 'QmcPermissionService', 'QmcLanguageService')
            ], FlsDocumentationEndingConfirmationController);
            return FlsDocumentationEndingConfirmationController;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsPlanedRawListController = /** @class */ (function () {
            function FlsPlanedRawListController($location, flsService, $qui, $scope, $stateParams, $state, userService) {
                var _this = this;
                this.$location = $location;
                this.flsService = flsService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.userService = userService;
                this.ui = new Fachleistung.UserInterface();
                this.checkedCasesCount = 0;
                this.loading = true;
                this.createRawTable = null;
                this.createPlanedTable = null;
                this.contingentTargetDate = new Date();
                $qui.init($qui.getSectionColor("/fls/documentation"), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                    state: this.$state.$current.name,
                    params: {}
                }));
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                // Get days to the past to get pled/raw docus for
                this.userService.getUserSettings(["FLS.PLANEDRAWDAYS"]).then(function (data) {
                    var days = parseInt(data[0].value);
                    if (isNaN(days) || days === null || days === undefined)
                        days = QMC.Common.UserSettingConstantsAndDefaults.PLANEDRAWDAYS;
                    _this.userService.getUserSettings(["FLS.PLANEDDAYSFUTURE"]).then(function (data) {
                        var daysFuture = parseInt(data[0].value);
                        if (isNaN(daysFuture) || daysFuture === null || daysFuture === undefined)
                            daysFuture = QMC.Common.UserSettingConstantsAndDefaults.PLANEDDAYSFUTURE;
                        _this.GetPlanedAndRawDocumentations(days, daysFuture);
                    });
                });
                this.cards = false;
                if (QMC.Common.Constants.IS_MOBILE)
                    this.cards = true;
            }
            /////////////// DISPLAY LOGIC ///////////////
            FlsPlanedRawListController.prototype.writeFlsObjectToLocalStorage = function (data) {
                console.log("storage", data);
                var flsObject = data;
                var cacheObject = {
                    dateFrom: flsObject.dateFrom,
                    timeFrom: flsObject.dateFrom,
                    dateTo: flsObject.dateTo,
                    timeTo: flsObject.dateTo,
                    flsCaseId: flsObject.flsCaseId,
                    description: flsObject.description
                };
                localStorage.setItem('flsObject', JSON.stringify(cacheObject));
                window.location.hash = "#/fls/documentation/new/" + cacheObject.flsCaseId + "?plannedDocumentationId=" + data.objectId;
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
            * GetPlanedDocumentations
            * @description Gets all planed but not docuemented documentations in the past x days.
            */
            FlsPlanedRawListController.prototype.GetPlanedAndRawDocumentations = function (days, daysFuture) {
                var _this = this;
                this.flsService.getPlannedDocumentations(days, daysFuture).then(function (data) {
                    _this.ui.planedDocuTable.data = data;
                    if (_this.createPlanedTable)
                        _this.createPlanedTable();
                });
                this.flsService.getRawDocumentations(days).then(function (data) {
                    _this.ui.rawDocuTable.data = data;
                    if (_this.createRawTable)
                        _this.createRawTable();
                });
                this.loading = false;
            };
            FlsPlanedRawListController = __decorate([
                QMC.Controller('QMC.Fachleistung', 'FlsPlanedRawListController'),
                QMC.Inject('$location', 'FachleistungService', '$qui', '$scope', '$stateParams', '$state', 'UserService')
            ], FlsPlanedRawListController);
            return FlsPlanedRawListController;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsWeekplannerListController = /** @class */ (function () {
            function FlsWeekplannerListController($location, fachleistungsService, $qui, terminService, aznService, $scope, $state, $timeout, lng, permissionService, userService, $stateParams) {
                var _this = this;
                this.fachleistungsService = fachleistungsService;
                this.$qui = $qui;
                this.terminService = terminService;
                this.aznService = aznService;
                this.$scope = $scope;
                this.$state = $state;
                this.$timeout = $timeout;
                this.lng = lng;
                this.userService = userService;
                this.$stateParams = $stateParams;
                this.typeFlsDocumentation = 'FlsDocumentation';
                this.typeAppointment = 'Appointment';
                this.typeAzn = 'AZN';
                this.dragMode = this.typeFlsDocumentation;
                this.formState = 'new';
                this.validation = {
                    errors: [],
                    warnings: [],
                    type: this.typeFlsDocumentation
                };
                // loading
                this.wvLoading = false;
                this.copyLoading = false;
                this.calendarLoading = false;
                this.validationLoading = false;
                this.caseLoading = false;
                // calender data
                this.caseFilterObject = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.caseFilter = '';
                this.aznList = [];
                this.eventList = [];
                this.ui = new Fachleistung.UserInterface();
                this.colorFlsDocumentation = '#333333';
                this.colorPlannedFlsDocumentation = '#3F51B5';
                this.colorAzn = '#FE9700';
                this.colorPlannedAzn = '#876c4c';
                this.colorAppointment = '#4CAF50';
                // permissions
                this.permissions = {
                    fls: { new: false, modify: false, delete: false },
                    azn: { new: false, modify: false, delete: false }
                };
                // Case pagination
                this.currentPage = 0;
                this.pageSize = 7;
                this.numberOfPages = 0;
                // AZNTypes pagination
                this.aznCurrentPage = 0;
                this.aznPageSize = 10;
                this.aznNumberOfPages = 0;
                this.showWeekends = false;
                this.showHoliday = false;
                this.showVacation = true;
                this.showPublicHoliday = true;
                this.eventLength = 60;
                this.showUnplannableCases = false;
                this.slotDuration = 30;
                this.getFutureCases = false;
                this.getPastCases = false;
                this.selectedPerson = sessionStorage.getItem('weekplanner:lastSelectedPerson') ? sessionStorage.getItem('weekplanner:lastSelectedPerson') : $("#session").data().personId;
                this.loadingAllCases = false;
                this.formFirstInit = true;
                this.lastFlsValidationRequestId = '';
                this.firstLoad = true;
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    setTimeout(_this.events, 300);
                });
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                this.showWeekends = localStorage.getItem('weekplanner:showWeeks') === 'true';
                var keys = [];
                keys.push("FLS.WEEKPLANNER.SHOWHOLIDAY");
                keys.push("FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES");
                keys.push("FLS.WEEKPLANNER_INCLUDE_PAST_CASES");
                keys.push("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH");
                keys.push('CALENDAR.SLOTDURATION');
                keys.push('WEEKPLANNER.SHOWUNPLANNABLECASES');
                keys.push("FLS.WEEKPLANNER.SHOWVACATION");
                keys.push("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY");
                keys.push(QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY);
                this.userService.getUserSettings(keys).then(function (data) {
                    var _a, _b, _c;
                    _this.showHoliday = data[0].value === "" ? _this.showHoliday : data[0].value.toLowerCase() === "true";
                    _this.getFutureCases = data[1].value === "" ? _this.getFutureCases : data[1].value.toLowerCase() === "true";
                    _this.getPastCases = data[2].value === "" ? _this.getPastCases : data[2].value.toLowerCase() === "true";
                    _this.eventLength = data[3].value === "" ? _this.eventLength : parseInt(data[3].value);
                    _this.slotDuration = data[4].value && data[4].value.length > 0 ? parseInt(data[4].value) : _this.slotDuration;
                    _this.showUnplannableCases = ((_a = data[5].value) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
                    _this.showVacation = data[6].value === "" ? _this.showVacation : ((_b = data[6].value) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'true';
                    _this.showPublicHoliday = data[7].value === "" ? _this.showPublicHoliday : ((_c = data[7].value) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'true';
                    _this.caseFilterObject = data[8].value === '' ? _this.caseFilterObject : JSON.parse(data[8].value);
                    _this.getWv();
                });
                this.promptOptions = {
                    title: "Wochenplanung",
                    yesNo: true,
                    icon: "",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.fachleistungsService.getAllPossibleCarer().then(function (data) {
                    data.sort(function (a, b) { return (a.displayTitle.toLocaleLowerCase() > b.displayTitle.toLocaleLowerCase()) ? 1 : ((b.displayTitle.toLocaleLowerCase() > a.displayTitle.toLocaleLowerCase()) ? -1 : 0); });
                    _this.possibleCarer = data;
                    _this.possibleCarerMap = data.map(function (x) { return ({ text: _this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber), value: x.objectId }); });
                    _this.$scope.$watch('vm.selectedPerson', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            _this.copyCandidates = [];
                            _this.resetCalendar();
                            _this.getCases();
                            sessionStorage.setItem('weekplanner:lastSelectedPerson', _this.selectedPerson);
                        }
                    });
                    _this.$scope.$watch('vm.form.carerId', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            _this.selectedPerson = newVal;
                            _this.getAllCases();
                        }
                    });
                    if (_this.possibleCarer.filter(function (x) { return x.objectId === sessionStorage.getItem('weekplanner:lastSelectedPerson'); }).length === 0)
                        sessionStorage.setItem('weekplanner:lastSelectedPerson', _this.selectedPerson);
                    if (!_this.possibleCarer.some(function (x) { return x.objectId === _this.selectedPerson; }))
                        _this.selectedPerson = $("#session").data().personId;
                    _this.getAllCases();
                    _this.getCases();
                    _this.$scope.$watch('vm.caseFilterObject.onlyCurrentCases', function (newVal, oldVal) {
                        if (newVal === oldVal)
                            return;
                        _this.toggleShowCurrentOnly();
                    });
                });
                //ObjectType: FlsZeitplanungSoll
                permissionService.getPermissionsByObjectType(230007).then(function (data) {
                    _this.permissions.fls.delete = data[0].delete && data[0].moduleAccess;
                    _this.permissions.fls.new = data[0].new && data[0].moduleAccess;
                    _this.permissions.fls.modify = data[0].modify && data[0].moduleAccess;
                    // check only for view permission
                    if (data[0].view && data[0].moduleAccess) {
                        _this.dragMode = _this.typeFlsDocumentation;
                    }
                    else {
                        _this.dragMode = "NoPlanningAllowed";
                    }
                    _this.setNewButton();
                });
                permissionService.getPermissionsByObjectType(411010).then(function (data) {
                    _this.permissions.azn.delete = data[0].new;
                    _this.permissions.azn.new = data[0].new;
                    _this.permissions.azn.modify = data[0].new;
                    // set the dragMode to typeAZN only when the dragMode is not arleady set to typeFlsDocumentation, check only for view permission
                    if (data[0].view && data[0].moduleAccess) {
                        _this.dragMode = _this.dragMode === _this.typeFlsDocumentation ? _this.typeFlsDocumentation : _this.typeAzn;
                    }
                    else {
                        _this.dragMode = _this.dragMode === _this.typeFlsDocumentation ? _this.typeFlsDocumentation : "NoPlanningAllowed";
                    }
                    _this.setNewButton();
                });
                this.getWv();
                this.getAznWv();
            }
            /******************* Misc *******************/
            FlsWeekplannerListController.prototype.getCaseList = function () {
                var _a;
                //this.$timeout(this.filterEvents);
                return (_a = this.cases) !== null && _a !== void 0 ? _a : [];
            };
            FlsWeekplannerListController.prototype.getAllCases = function () {
                var _this = this;
                var request = JSON.stringify({
                    carerId: this.selectedPerson
                });
                if (this.lastAllCaseRequest === request)
                    return;
                this.lastAllCaseRequest = request;
                this.allCases = [];
                this.allCasesMap = [];
                this.loadingAllCases = true;
                this.fachleistungsService.getCasesList(QMC.Common.Constants.GUID_EMPTY, false, this.selectedPerson).then(function (data) {
                    if (!_this.getFutureCases) {
                        data = data.filter(function (item) { return moment(item.dateFrom).toDate() <= new Date(); });
                    }
                    if (!_this.getPastCases) {
                        data = data.filter(function (item) { return !item.dateTo || moment(item.dateTo).endOf("day").toDate() >= new Date(); });
                    }
                    _this.allCases = data;
                    data.forEach(function (x) { return x.displayTitle = _this.$qui.createCaseDisplayObject(x).text; });
                    _this.allCasesMap = data.map(function (x) { return _this.$qui.createCaseDisplayObject(x); });
                    _this.loadingAllCases = false;
                });
            };
            FlsWeekplannerListController.prototype.handleFilterChange = function () {
                if (this.caseFilter.length > 0) {
                    this.currentPage = 0;
                }
                this.numberOfPages = Math.ceil(this.getCaseList().length / this.pageSize);
            };
            FlsWeekplannerListController.prototype.events = function () {
                var _this = this;
                if (!this.$scope)
                    return;
                this.handleFilterChange();
                this.$scope.$watch('vm.caseFilter', function (newVal, oldVal) {
                    if (newVal !== oldVal)
                        _this.filterEvents();
                });
                this.$scope.$watch('vm.showWeekends', function (newVal, oldVal) {
                    localStorage.setItem('weekplanner:showWeeks', String(newVal));
                    if (newVal !== oldVal)
                        _this.$state.reload();
                });
                setTimeout(function () {
                    _this.filterEvents();
                    _this.buildPlanner();
                }, 500);
                this.$scope.$watch('vm.aznForm', function (newVal, oldVal) {
                    if (_this.dragMode !== _this.typeAzn || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.checkPlausibilityAzn();
                }, true);
                this.$scope.$watch('vm.isAznFormValid', function (newVal, oldVal) {
                    if (_this.dragMode !== _this.typeFlsDocumentation || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.checkPlausibilityAzn();
                });
                this.$scope.$watch('vm.flsForm', function (newVal, oldVal) {
                    if (_this.dragMode !== _this.typeFlsDocumentation || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.checkPlausibilityFls();
                }, true);
                this.$scope.$watch('vm.isFlsFormValid', function (newVal, oldVal) {
                    if (_this.dragMode !== _this.typeFlsDocumentation || JSON.stringify(newVal) === JSON.stringify(oldVal))
                        return;
                    _this.checkPlausibilityFls();
                });
                this.$scope.$watch('vm.dragMode', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    if (newVal === _this.typeAzn)
                        _this.checkPlausibilityAzn();
                    else if (newVal === _this.typeFlsDocumentation)
                        _this.checkPlausibilityFls();
                });
            };
            FlsWeekplannerListController.prototype.setNewButton = function () {
                var _this = this;
                if (this.dragMode === this.typeFlsDocumentation) {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = _this.permissions.fls.new ? 'unset' : 'hidden'; });
                }
                else if (this.dragMode === this.typeAzn) {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = _this.permissions.azn.new ? 'unset' : 'hidden'; });
                }
                else {
                    document.getElementsByName('newModalButton').forEach(function (x) { return x.style.visibility = 'hidden'; });
                }
            };
            FlsWeekplannerListController.prototype.getCases = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var request;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                request = JSON.stringify({
                                    carerFilter: this.caseFilterObject.carerTypeFilterId,
                                    carerId: this.selectedPerson,
                                    onlyCurrent: this.caseFilterObject.onlyCurrentCases,
                                    showUnplannableCases: this.showUnplannableCases
                                });
                                if (this.lastCaseRequest === request || !this.caseFilterObject.carerTypeFilterId || this.caseFilterObject.carerTypeFilterId === QMC.Common.Constants.GUID_EMPTY)
                                    return [2 /*return*/];
                                this.lastCaseRequest = request;
                                this.caseLoading = true;
                                this.cases = [];
                                this.casesMap = [];
                                return [4 /*yield*/, this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: JSON.stringify(this.caseFilterObject) }] })];
                            case 1:
                                _a.sent();
                                this.fachleistungsService.getCasesList(this.caseFilterObject.carerTypeFilterId, this.caseFilterObject.onlyCurrentCases, this.selectedPerson, this.showUnplannableCases).then(function (data) {
                                    if (!_this.getFutureCases) {
                                        data = data.filter(function (item) { return moment(item.dateFrom).toDate() <= moment().endOf('day').toDate(); });
                                    }
                                    if (!_this.getPastCases) {
                                        data = data.filter(function (item) { return !item.dateTo || moment(item.dateTo).toDate() >= moment().startOf('day').toDate(); });
                                    }
                                    _this.casesMap = _this.cases.map(function (x) { return _this.$qui.createCaseDisplayObject(x); });
                                    data.forEach(function (x) { return x.displayTitle = _this.$qui.createCaseDisplayObject(x).text; });
                                    _this.cases = data;
                                    setTimeout(function () {
                                        _this.$qui.anonAvatar();
                                        _this.$qui.scopeApply(_this.$scope);
                                    }, 500);
                                    _this.caseLoading = false;
                                    _this.events();
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            };
            FlsWeekplannerListController.prototype.getWv = function () {
                var _this = this;
                this.fachleistungsService.getFlsCaseWv().then(function (data) {
                    _this.flsCaseWv = data;
                    // Set carer type filter from local storage, or if not present, from the first wv item
                    if (!_this.flsCaseWv.carerTypeWv.some(function (x) { return x.objectId === _this.caseFilterObject.carerTypeFilterId; }))
                        _this.caseFilterObject.carerTypeFilterId = _this.flsCaseWv.carerTypeWv[0].id;
                    _this.getCases();
                });
            };
            FlsWeekplannerListController.prototype.getEvents = function (view) {
                var _this = this;
                if (this.dontGetDates) {
                    this.dontGetDates = false;
                    return;
                }
                if (view) {
                    localStorage.setItem('calendarView', view.name);
                }
                if (this.firstLoad && this.$stateParams.startDay) {
                    this.firstLoad = false;
                    $('#weekplannerCalendar').fullCalendar('gotoDate', this.$stateParams.startDay);
                }
                this.$state.go('.', {
                    startDay: this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start).toISOString(),
                    view: $('#weekplannerCalendar').fullCalendar('getView').name
                });
                // calendar is not yet updated, that would mess up everything thats going to follow => bail out
                if (this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start).toISOString() !== moment(this.$state.params.startDay).toISOString()) {
                    setTimeout(function () { _this.getEvents(view); }, 50);
                    return;
                }
                var localEvents = [];
                this.eventList = [];
                this.setViewDates();
                $('#weekplannerCalendar').fullCalendar('removeEvents');
                $("#filterCheck").attr("disabled", "true");
                $(".squaredThree label").css("opacity", "0.4").css("cursor", "not-allowed");
                this.copyCandidates = [];
                this.deleteItems = [];
                this.calendarLoading = true;
                this.getWeekPlanning().then(function (weekData) {
                    _this.addToEventlist(weekData, localEvents);
                    _this.getAppointmentList().then(function (appointmentData) {
                        _this.addToEventlist(appointmentData, localEvents);
                        _this.getArbeitszeitnachweis().then(function (arbeitszeitnachweisData) {
                            _this.addToEventlist(arbeitszeitnachweisData, localEvents);
                            _this.terminService.getHolidaysSpecific($('#weekplannerCalendar').fullCalendar('getDate').year(), _this.showPublicHoliday, _this.showVacation).then(function (holidays) {
                                _this.addToEventlist(_this.createHolidayCalendarEntry(holidays), localEvents);
                                _this.eventList = localEvents;
                                _this.renderCalendar();
                                _this.calendarLoading = false;
                                var calView = $('#weekplannerCalendar').fullCalendar('getView');
                                var start = calView.intervalStart.startOf('day');
                                var end = calView.intervalEnd.subtract(1, 'days').endOf('day');
                                if (!_this.showWeekends)
                                    end = end.subtract(2, 'days');
                                var allDay = false;
                                for (var _i = 0, _a = _this.eventList; _i < _a.length; _i++) {
                                    var event_1 = _a[_i];
                                    if (event_1.allDay && (start.toString().slice(0, 24) === event_1.start.toString().slice(0, 24) || moment(event_1.start).isBetween(start, end) || (moment(start).isSameOrBefore(event_1.end) && moment(event_1.start).isSameOrBefore(end)))) {
                                        allDay = true;
                                        break;
                                    }
                                }
                                _this.dontGetDates = true;
                                $('#weekplannerCalendar').fullCalendar('option', 'allDaySlot', allDay);
                            });
                        });
                    });
                });
            };
            FlsWeekplannerListController.prototype.createHolidayCalendarEntry = function (holidays) {
                for (var _i = 0, holidays_3 = holidays; _i < holidays_3.length; _i++) {
                    var holiday = holidays_3[_i];
                    holiday.allDay = true;
                    holiday.title = holiday.caption;
                    holiday.editable = false;
                    holiday.color = "#DBDBDB";
                    holiday.start = moment(holiday.dateFrom);
                    holiday.end = moment(holiday.dateTo);
                }
                return holidays;
            };
            FlsWeekplannerListController.prototype.getAppointmentList = function () {
                var _this = this;
                var appointmentTypes = [];
                appointmentTypes.push(401000);
                if (this.showHoliday) {
                    appointmentTypes.push(411003); //holidays
                    appointmentTypes.push(411004); //sick days
                }
                // send appointment without userId, those always getting for current.
                return this.terminService.getAppointmentList(this.selectedPerson, this.viewDateFrom, this.viewDateTo, appointmentTypes).then(function (data) {
                    var dataArray = [];
                    var setColor = true;
                    for (var _i = 0, data_5 = data; _i < data_5.length; _i++) {
                        var element = data_5[_i];
                        var tempEvent = _this.ui.createCalendarEvent(element);
                        tempEvent.editable = false;
                        if (setColor) {
                            setColor = false;
                            $("#appointmentColor").css("color", tempEvent.color);
                        }
                        dataArray.push(tempEvent);
                    }
                    return dataArray;
                });
            };
            FlsWeekplannerListController.prototype.openNewForm = function () {
                var _a;
                if (this.formFirstInit) {
                    this.formFirstInit = false;
                    return;
                }
                ;
                this.aznForm = {
                    dateFrom: moment().startOf('hour').toDate(),
                    dateTo: moment().startOf('hour').add(this.eventLength, 'm').toDate(),
                    typeId: QMC.Common.Constants.GUID_EMPTY,
                    referencePersonId: ((_a = this.possibleCarer) === null || _a === void 0 ? void 0 : _a.some(function (x) { return x.objectId === $("#session").data().personId; })) ? $("#session").data().personId : QMC.Common.Constants.GUID_EMPTY
                };
                this.setFlsForm(undefined, undefined, this.selectedPerson);
                this.formState = 'new';
                $('#weekplanner-entry').modal('show');
            };
            FlsWeekplannerListController.prototype.postForm = function () {
                switch (this.dragMode) {
                    case this.typeAzn:
                        this.saveNewAznPlanning();
                        break;
                    case this.typeFlsDocumentation:
                        this.saveNewFlsPlanning();
                        break;
                    default:
                        console.warn("create not supported for dragMode " + this.dragMode);
                }
            };
            FlsWeekplannerListController.prototype.putForm = function () {
                switch (this.dragMode) {
                    case this.typeAzn:
                        this.updateAznPlanning();
                        break;
                    case this.typeFlsDocumentation:
                        this.updateFlsPlanning();
                        break;
                    default:
                        console.warn("update not supported for dragMode " + this.dragMode);
                }
            };
            FlsWeekplannerListController.prototype.deleteForm = function () {
                switch (this.dragMode) {
                    case this.typeAzn:
                        this.deleteAznPlanning();
                        break;
                    case this.typeFlsDocumentation:
                        this.deleteFlsPlanning();
                        break;
                    default:
                        console.warn("delete not supported for dragMode " + this.dragMode);
                }
            };
            FlsWeekplannerListController.prototype.createDocumentation = function (mode) {
                if (mode === this.typeFlsDocumentation) {
                    var cacheObject = {
                        dateFrom: this.flsForm.dateFrom,
                        timeFrom: this.flsForm.dateFrom,
                        dateTo: this.flsForm.dateTo,
                        timeTo: this.flsForm.dateTo,
                        flsCaseId: this.flsForm.flsCaseId,
                        description: this.flsForm.description,
                        activity: this.flsForm.activityTypeId,
                        careType: this.flsForm.careTypeId,
                        contactType: this.flsForm.contactTypeId,
                        miscontact: this.flsForm.miscontactId,
                        carerId: this.flsForm.carerId
                    };
                    localStorage.setItem('flsObject', JSON.stringify(cacheObject));
                    this.$state.go('documentationnew', { plannedDocumentationId: this.flsForm.objectId, flsCaseIds: this.flsForm.flsCaseId }, { reload: true });
                }
                else if (mode === this.typeAzn) {
                    this.goToAznDetail(this.aznForm.objectId);
                }
            };
            /******************* FLS *******************/
            FlsWeekplannerListController.prototype.toggleShowCurrentOnly = function () {
                this.getCases();
                this.getAllCases();
            };
            FlsWeekplannerListController.prototype.saveUnplannableSetting = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.userService.setUserSettings({ settings: [{ key: 'WEEKPLANNER.SHOWUNPLANNABLECASES', value: String(this.showUnplannableCases) }] })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            FlsWeekplannerListController.prototype.checkPlausibilityFls = function (afterValidationAction, form) {
                var _this = this;
                this.$timeout(function () {
                    var _a;
                    form = form !== null && form !== void 0 ? form : _this.flsForm;
                    if (!form)
                        return;
                    _this.validation = {
                        errors: [],
                        warnings: [],
                        type: _this.typeFlsDocumentation
                    };
                    if (!_this.isFlsFormValid) {
                        _this.validation.errors.push(_this.lng.translate(20002061, 'Es wurden nicht alle Pflichtfelder ausgefüllt.'));
                    }
                    if (!_this.flsForm.miscontactId || _this.flsForm.miscontactId === QMC.Common.Constants.GUID_EMPTY) {
                        _this.validation.errors.push(_this.lng.translate(20016243, "Die Fehlkontaktart muss ausgewählt werden"));
                    }
                    if ((_a = _this.validation.errors) === null || _a === void 0 ? void 0 : _a.length) {
                        if (afterValidationAction)
                            afterValidationAction();
                        _this.validationLoading = false;
                        return;
                    }
                    // get current case
                    var currentCase = _this.allCases.filter(function (x) { return form.flsCaseId === x.objectId; })[0];
                    if (!currentCase) {
                        _this.validation.errors = [_this.lng.translate(20000328, 'Die Validierung konnte nicht durchgeführt werden!')];
                        if (afterValidationAction)
                            afterValidationAction();
                        _this.validationLoading = false;
                        return;
                    }
                    _this.validationLoading = true;
                    var validationObject = {
                        dateFrom: form.dateFrom,
                        dateTo: !form.dateTo ? moment(form.dateFrom).add(_this.eventLength, 'minutes').toDate() : form.dateTo,
                        hasManualDuration: false,
                        documentationId: !form.objectId ? QMC.Common.Constants.GUID_EMPTY : form.documentationId,
                        references: [{ caseId: currentCase.objectId, referenceId: currentCase.clientObjectId, accountabilityId: currentCase.defaultAccountableRuleId }],
                        carer: [{
                                activityTypeId: form.activityTypeId,
                                contactTypeId: form.contactTypeId,
                                careTypeId: form.careTypeId,
                                miscontactId: form.miscontactId,
                                carerId: form.carerId
                            }],
                        manualDuration: 0,
                        requestId: _this.$qui.generateGuid(),
                        ignoreConfigRoundInterval: false
                    };
                    var requestId = '_' + Math.random().toString(36).substring(2, 10);
                    _this.lastFlsValidationRequestId = requestId;
                    _this.fachleistungsService.checkForWarningsAndErrors([validationObject], true).then(function (data) {
                        if (_this.lastFlsValidationRequestId !== requestId)
                            return;
                        data.forEach(function (result) {
                            for (var key in result.validation) {
                                _this.validation.errors = result.validation[key].errors;
                                _this.validation.warnings = result.validation[key].warnings;
                            }
                        });
                        if (afterValidationAction)
                            afterValidationAction();
                        _this.validationLoading = false;
                        _this.$qui.scopeApply(_this.$scope);
                    })
                        .catch(function (e) {
                        _this.validation.errors = [_this.lng.translate(20000328, 'Die Validierung konnte nicht durchgeführt werden!')];
                        _this.handleSaveActionError(e);
                        _this.validationLoading = false;
                    });
                });
            };
            FlsWeekplannerListController.prototype.saveNewFlsPlanning = function () {
                var _this = this;
                this.calendarLoading = true;
                $("#weekplanner-entry").modal("hide");
                this.fachleistungsService.postWeekPlanningPlannedDoc([this.flsForm]).then(function () {
                    _this.$qui.notify(_this.$qui.successNote);
                    _this.resetCalendar();
                    _this.calendarLoading = false;
                }).catch(function (e) { return _this.handleSaveActionError(e); });
            };
            FlsWeekplannerListController.prototype.updateFlsPlanning = function (form) {
                var _this = this;
                form = form !== null && form !== void 0 ? form : this.flsForm;
                this.calendarLoading = true;
                $('#weekplanner-entry').modal('hide');
                this.fachleistungsService.putWeekPlanningPlannedDoc(form.documentationId, form).then(function () {
                    _this.$qui.notify(_this.$qui.successNote);
                    _this.resetCalendar();
                    _this.calendarLoading = false;
                }).catch(function (e) { return _this.handleSaveActionError(e); });
            };
            FlsWeekplannerListController.prototype.changeFlsEvent = function (id, dateFrom, dateTo, revertFunc) {
                var _this = this;
                var _a, _b;
                this.dragMode = 'none';
                var origPlanning = this.flsWeekPlanning.filter(function (x) { return x.objectId === id; })[0];
                if (!(origPlanning === null || origPlanning === void 0 ? void 0 : origPlanning.flsCaseId))
                    return;
                var currentCase = this.cases.filter(function (x) { return origPlanning.flsCaseId === x.objectId; })[0];
                if (!currentCase) {
                    this.$qui.notify({
                        message: this.lng.translate(20002066, "Der gewählte Fall steht nicht mehr zur Verfügung, die Planung kann nicht editiert oder dokumentiert werden!"),
                        title: this.lng.translate(20002015, "Fehler"),
                        icon: "qm-icon-delete",
                        status: "warning",
                        timer: 6000
                    });
                    revertFunc();
                    return;
                }
                ;
                this.calendarLoading = true;
                var form = __assign(__assign({}, origPlanning), { documentationId: id, serviceTypeId: currentCase.serviceTypeId, dateFrom: dateFrom, dateTo: dateTo, description: (_a = origPlanning.description) !== null && _a !== void 0 ? _a : '', flsCaseId: (_b = origPlanning.flsCaseId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.GUID_EMPTY });
                this.setFlsForm(form);
                this.checkPlausibilityFls(function () {
                    if (!_this.validation.errors.length && !_this.validation.warnings.length) {
                        _this.updateFlsPlanning(form);
                    }
                    else {
                        _this.formState = 'edit';
                        _this.dragMode = _this.typeFlsDocumentation;
                        $('#weekplanner-entry').modal('show');
                        revertFunc();
                        _this.calendarLoading = false;
                    }
                    _this.dragMode = _this.typeFlsDocumentation;
                }, form);
            };
            FlsWeekplannerListController.prototype.getWeekPlanning = function () {
                var _this = this;
                return this.fachleistungsService.getWeekPlanningList(this.selectedPerson, this.viewDateFrom, this.viewDateTo).then(function (data) {
                    _this.addFlsToCopyCandidates(data);
                    _this.addFlsToDeleteItems(data);
                    _this.flsWeekPlanning = data;
                    var dataArray = [];
                    for (var _i = 0, data_6 = data; _i < data_6.length; _i++) {
                        var element = data_6[_i];
                        var color = _this.colorFlsDocumentation;
                        var isDraggable = false;
                        if (element.isPlannedDocumentation) {
                            color = _this.colorPlannedFlsDocumentation;
                            isDraggable = _this.permissions.fls.modify;
                        }
                        dataArray.push({
                            id: element.objectId,
                            title: element.reportTitle,
                            objectId: element.flsCaseId,
                            start: _this.$qui.createDateFromString(element.dateFrom),
                            end: _this.$qui.createDateFromString(element.dateTo),
                            color: color,
                            editable: isDraggable,
                            type: _this.typeFlsDocumentation,
                            description: element.description
                        });
                    }
                    _this.buildPlanner();
                    _this.renderCalendar();
                    return dataArray;
                });
            };
            FlsWeekplannerListController.prototype.deleteFlsPlanning = function () {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    $('#weekplanner-entry').modal('hide');
                    if (data)
                        _this.fachleistungsService.deleteWeekPlanningPlannedDoc(_this.flsForm.objectId).then(function () {
                            _this.$qui.notify(_this.$qui.deleteNote);
                            _this.resetCalendar();
                        });
                });
            };
            FlsWeekplannerListController.prototype.addFlsToDeleteItems = function (items) {
                var _this = this;
                if (this.cases.length < 1) {
                    setTimeout(function () {
                        _this.addFlsToDeleteItems(items);
                    }, 1000);
                }
                for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
                    var item = items_3[_i];
                    var currentCase = void 0;
                    for (var _a = 0, _b = this.cases; _a < _b.length; _a++) {
                        var cuCase = _b[_a];
                        if (cuCase.objectId == item.flsCaseId)
                            currentCase = cuCase;
                    }
                    if (!currentCase || !item.isPlannedDocumentation)
                        continue;
                    this.deleteItems.push({
                        dateFrom: this.$qui.createDateFromString(item.dateFrom),
                        dateTo: this.$qui.createDateFromString(item.dateTo),
                        id: item.id,
                        isChecked: false,
                        objectId: item.objectId,
                        title: item.reportTitle,
                        type: 230000,
                        flsCase: currentCase,
                        aznImputeId: undefined,
                        aznTypeId: undefined
                    });
                }
            };
            FlsWeekplannerListController.prototype.addFlsToCopyCandidates = function (items) {
                var _this = this;
                if (this.cases.length < 1) {
                    setTimeout(function () {
                        _this.addFlsToCopyCandidates(items);
                    }, 1000);
                }
                var _loop_8 = function (item) {
                    if (this_5.copyCandidates.some(function (x) { return x.objectId === item.objectId; }))
                        return "continue"; //If the candidate already exists, skip it.
                    this_5.copyCandidates.push({
                        dateFrom: this_5.$qui.createDateFromString(item.dateFrom),
                        dateTo: this_5.$qui.createDateFromString(item.dateTo),
                        id: item.id,
                        isChecked: false,
                        objectId: item.objectId,
                        title: item.reportTitle,
                        type: 230000,
                        flsCase: null,
                        flsCaseId: item.flsCaseId,
                        aznImputeId: undefined,
                        aznTypeId: undefined,
                        activityForm: {
                            activityTypeId: item.activityTypeId,
                            careTypeId: item.careTypeId,
                            contactTypeId: item.contactTypeId,
                            miscontactId: item.miscontactId
                        }
                    });
                };
                var this_5 = this;
                for (var _i = 0, items_4 = items; _i < items_4.length; _i++) {
                    var item = items_4[_i];
                    _loop_8(item);
                }
            };
            /******************* AZN *******************/
            FlsWeekplannerListController.prototype.checkPlausibilityAzn = function (afterValidationAction) {
                var _this = this;
                this.$timeout(function () {
                    var _a;
                    if (!_this.aznForm)
                        return;
                    _this.aznForm.referencePersonId = (_a = _this.aznForm.referencePersonId) !== null && _a !== void 0 ? _a : _this.selectedPerson;
                    _this.validation = {
                        errors: [],
                        warnings: [],
                        type: _this.typeAzn
                    };
                    if (!_this.isAznFormValid) {
                        _this.validation.errors.push(_this.lng.translate(20002061, 'Es wurden nicht alle Pflichtfelder ausgefüllt.'));
                        if (afterValidationAction)
                            afterValidationAction();
                        _this.validationLoading = false;
                        return;
                    }
                    if (moment(_this.aznForm.dateTo).isBefore(_this.aznForm.dateFrom)) {
                        _this.validation.errors = [_this.lng.translate(20002004, 'Das Startdatum ist größer als das Enddatum')];
                        return;
                    }
                    _this.validationLoading = true;
                    _this.aznService.checkForWarningsAndErrors({
                        idObjectAznw: _this.aznForm.objectId,
                        dateFrom: moment(_this.aznForm.dateFrom).format(),
                        dateTo: moment(_this.aznForm.dateTo).format(),
                        performingPersonObjIdList: [_this.aznForm.referencePersonId],
                        isPlanned: true,
                        activityId: QMC.Common.Constants.GUID_EMPTY,
                        imputeWvId: QMC.Common.Constants.GUID_EMPTY,
                        instituteId: QMC.Common.Constants.GUID_EMPTY
                    })
                        .then(function (data) {
                        _this.validation.errors = data.errors;
                        _this.validation.warnings = data.warnings;
                        if (afterValidationAction)
                            afterValidationAction();
                        _this.$qui.scopeApply(_this.$scope);
                    })
                        .catch(function (e) {
                        _this.validation.errors = [_this.lng.translate(20000328, 'Die Validierung konnte nicht durchgeführt werden!')];
                    })
                        .finally(function () { return _this.validationLoading = false; });
                });
            };
            FlsWeekplannerListController.prototype.saveNewAznPlanning = function () {
                var _this = this;
                this.calendarLoading = true;
                $("#weekplanner-entry").modal("hide");
                this.aznService.postAznWeekPlanning(this.aznForm).then(function (e) {
                    _this.$qui.notify(_this.$qui.successNote);
                    _this.resetCalendar();
                    _this.calendarLoading = false;
                }).catch(function (e) { return _this.handleSaveActionError(e); });
            };
            FlsWeekplannerListController.prototype.updateAznPlanning = function () {
                var _this = this;
                this.calendarLoading = true;
                $('#weekplanner-entry').modal('hide');
                this.aznService.putAznWeekPlanning(this.aznForm.objectId, this.aznForm).then(function (e) {
                    _this.$qui.notify(_this.$qui.successNote);
                    _this.resetCalendar();
                    _this.calendarLoading = false;
                }).catch(function (e) { return _this.handleSaveActionError(e); });
            };
            FlsWeekplannerListController.prototype.changeAznEvent = function (id, dateFrom, dateTo, revertFunc) {
                var _this = this;
                var azn = this.aznList.filter(function (x) { return x.objectId === id; })[0];
                if (!azn)
                    return;
                this.calendarLoading = true;
                azn.dateFrom = dateFrom;
                azn.dateTo = dateTo;
                this.aznForm = azn;
                this.checkPlausibilityAzn(function () {
                    if (!_this.validation.errors.length && !_this.validation.warnings.length) {
                        _this.updateAznPlanning();
                    }
                    else {
                        _this.formState = 'edit';
                        _this.dragMode = _this.typeAzn;
                        $('#weekplanner-entry').modal('show');
                        revertFunc();
                        _this.calendarLoading = false;
                    }
                });
                this.$qui.scopeApply(this.$scope);
            };
            FlsWeekplannerListController.prototype.openAznPlanning = function (data) {
                this.aznForm = {
                    dateFrom: data.start.toDate(),
                    dateTo: data.end.toDate(),
                    typeId: data.typeId,
                    objectId: data.id,
                    referencePersonId: this.selectedPerson
                };
                this.dragMode = this.typeAzn;
                $('#weekplanner-entry').modal('show');
                this.formState = 'edit';
                this.$qui.scopeApply(this.$scope);
            };
            FlsWeekplannerListController.prototype.deleteAznPlanning = function () {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    $('#weekplanner-entry').modal('hide');
                    if (data)
                        _this.aznService.deleteAznWeekPlanning(_this.aznForm.objectId).then(function () {
                            _this.$qui.notify(_this.$qui.deleteNote);
                            _this.resetCalendar();
                        });
                });
            };
            FlsWeekplannerListController.prototype.getArbeitszeitnachweis = function () {
                var _this = this;
                return this.aznService.getAznWeekPlanning(this.viewDateFrom, this.viewDateTo, true, true, this.selectedPerson).then(function (data) {
                    _this.addAznToCopyCandidates(data);
                    _this.addAznToDeleteItems(data);
                    var dataArray = [];
                    _this.aznList = data;
                    for (var _i = 0, data_7 = data; _i < data_7.length; _i++) {
                        var azn = data_7[_i];
                        dataArray.push({
                            id: azn.objectId,
                            title: azn.type,
                            objectId: azn.objectId,
                            start: _this.$qui.createDateFromString(azn.dateFrom),
                            end: _this.$qui.createDateFromString(azn.dateTo),
                            color: azn.isPlanned ? _this.colorPlannedAzn : _this.colorAzn,
                            editable: azn.isPlanned && azn.permissions.modify,
                            deletable: azn.isPlanned && azn.permissions.delete,
                            type: _this.typeAzn,
                            isPlanned: azn.isPlanned,
                            typeId: azn.typeId
                        });
                    }
                    return dataArray;
                });
            };
            FlsWeekplannerListController.prototype.addAznToCopyCandidates = function (items) {
                for (var _i = 0, items_5 = items; _i < items_5.length; _i++) {
                    var item = items_5[_i];
                    this.copyCandidates.push({
                        dateFrom: new Date(item.dateFrom),
                        dateTo: new Date(item.dateTo),
                        id: item.id,
                        isChecked: false,
                        objectId: item.objectId,
                        title: item.type,
                        type: 425000,
                        flsCase: undefined,
                        aznTypeId: item.typeId,
                        aznImputeId: item.imputeId,
                        flsCaseId: undefined,
                        activityForm: {
                        //Currently empty since planning activity is not supported for AZN at time of writing
                        }
                    });
                }
            };
            FlsWeekplannerListController.prototype.addAznToDeleteItems = function (items) {
                for (var _i = 0, items_6 = items; _i < items_6.length; _i++) {
                    var item = items_6[_i];
                    if (!item.isPlanned)
                        continue;
                    this.deleteItems.push({
                        dateFrom: new Date(item.dateFrom),
                        dateTo: new Date(item.dateTo),
                        id: item.id,
                        isChecked: false,
                        objectId: item.objectId,
                        title: item.type,
                        type: 425000,
                        flsCase: undefined,
                        aznTypeId: item.typeId,
                        aznImputeId: item.imputeId
                    });
                }
            };
            FlsWeekplannerListController.prototype.getAznWv = function () {
                var _this = this;
                this.wvLoading = true;
                this.aznService.getArbeitzeitnachweisWv(undefined).then(function (data) {
                    _this.aznTypesMap = _this.$qui.select(data.types, { value: 'objectId', text: 'name' });
                    _this.aznCurrentPage = 0;
                    _this.aznNumberOfPages = Math.ceil(_this.aznTypesMap.length / _this.aznPageSize);
                });
            };
            FlsWeekplannerListController.prototype.goToAznDetail = function (id) {
                localStorage.setItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE, JSON.stringify({
                    state: this.$state.$current.name,
                    params: {
                        startDay: this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start),
                        view: $('#weekplannerCalendar').fullCalendar('getView').name
                    }
                }));
                this.$state.go('azndetail', { id: id }, { reload: true });
            };
            FlsWeekplannerListController.prototype.toggleDragMode = function () {
                if (this.dragMode == this.typeFlsDocumentation) {
                    this.dragMode = this.typeAzn;
                    this.validation.type = this.typeAzn;
                    this.setNewButton();
                }
                else if (this.dragMode == this.typeAzn) {
                    this.dragMode = this.typeFlsDocumentation;
                    this.validation.type = this.typeFlsDocumentation;
                    this.setNewButton();
                }
            };
            FlsWeekplannerListController.prototype.handleSaveActionError = function (e) {
                this.saveErrors = [];
                // first try to gather all error msgs in one handy array
                if (typeof e === 'string')
                    this.saveErrors.push(e);
                if (typeof e === 'object') {
                    if (e.fieldErrors)
                        this.saveErrors = this.saveErrors.concat(e.fieldErrors);
                    if (e.FieldErrors)
                        this.saveErrors = this.saveErrors.concat(e.FieldErrors);
                    if (e.fieldError)
                        this.saveErrors.push(e.fieldError);
                    if (e.FieldError)
                        this.saveErrors.push(e.FieldError);
                    if (e.globalErrors)
                        this.saveErrors = this.saveErrors.concat(e.globalErrors);
                    if (e.GlobalErrors)
                        this.saveErrors = this.saveErrors.concat(e.GlobalErrors);
                    if (e.globalError)
                        this.saveErrors.push(e.globalError);
                    if (e.GlobalError)
                        this.saveErrors.push(e.GlobalError);
                }
                if (Array.isArray(e)) {
                    this.saveErrors = this.saveErrors.concat(e);
                }
                $('#saveErrorModal').modal('show');
            };
            FlsWeekplannerListController.prototype.leaveState = function () {
                var _this = this;
                if ($('.modal-backdrop') !== null)
                    $('.modal-backdrop').remove();
                this.$timeout(function () {
                    _this.$state.reload();
                });
            };
            FlsWeekplannerListController.prototype.afterErrorAction = function () {
                $('#saveErrorModal').modal('hide');
                // saving completed, clear cache
                this.$state.reload();
            };
            FlsWeekplannerListController.prototype.isDraggable = function (id) {
                return this.cases.some(function (x) { return x.objectId === id; });
            };
            FlsWeekplannerListController.prototype.filterEvents = function () {
                setTimeout(function () {
                    $('.fc-event.dummy').each(function (i) {
                        $(this).data('event', {
                            title: $.trim($(this).text()),
                            id: $(this).data('id'),
                            flsCaseId: $(this).data('case'),
                            clientId: $(this).data('client'),
                            serviceTypeId: $(this).data('service'),
                            type: $(this).data('type'),
                            stick: true
                        });
                        $(this).draggable({
                            zIndex: 999,
                            revert: true,
                            revertDuration: 0
                        });
                    });
                }, 150);
            };
            FlsWeekplannerListController.prototype.addDropEvent = function (obj, revertFunc) {
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                this.calendarLoading = true;
                                obj.carerId = this.selectedPerson;
                                if (!(obj.type === this.typeFlsDocumentation && this.permissions.fls.new)) return [3 /*break*/, 2];
                                _a = this;
                                return [4 /*yield*/, this.setFlsForm(obj, obj.flsCaseId)];
                            case 1:
                                _a.flsForm = _b.sent();
                                this.$timeout(function () {
                                    _this.checkPlausibilityFls(function () {
                                        if (!_this.validation.errors.length && !_this.validation.warnings.length)
                                            _this.saveNewFlsPlanning();
                                        else {
                                            _this.dragMode = _this.typeFlsDocumentation;
                                            $('#weekplanner-entry').modal('show');
                                            _this.calendarLoading = false;
                                            revertFunc();
                                        }
                                    });
                                });
                                return [3 /*break*/, 3];
                            case 2:
                                if (obj.type === this.typeAzn && this.permissions.azn.new) {
                                    this.aznForm = {
                                        dateFrom: obj.dateFrom,
                                        dateTo: moment(obj.dateFrom).add(this.eventLength, 'minutes').toDate(),
                                        typeId: obj.id,
                                        referencePersonId: obj.carerId
                                    };
                                    this.checkPlausibilityAzn(function () {
                                        if (!_this.validation.errors.length && !_this.validation.warnings.length)
                                            _this.saveNewAznPlanning();
                                        else {
                                            _this.dragMode = _this.typeAzn;
                                            $('#weekplanner-entry').modal('show');
                                            _this.calendarLoading = false;
                                            revertFunc();
                                        }
                                    });
                                }
                                else {
                                    $('#noPermissionDialog').modal('show');
                                    this.calendarLoading = false;
                                }
                                _b.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            };
            FlsWeekplannerListController.prototype.resetCalendar = function () {
                $(".modal-backdrop").remove();
                this.getEvents(null);
            };
            FlsWeekplannerListController.prototype.addToEventlist = function (arr, targetList) {
                if (targetList === void 0) { targetList = this.eventList; }
                for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                    var event_2 = arr_1[_i];
                    targetList.push(event_2);
                }
            };
            FlsWeekplannerListController.prototype.renderCalendar = function () {
                $("#filterCheck").removeAttr("disabled");
                $(".squaredThree label").css("opacity", "1").css("cursor", "pointer");
                ;
                $('#weekplannerCalendar').fullCalendar('removeEvents');
                $('#weekplannerCalendar').fullCalendar('addEventSource', this.eventList);
            };
            FlsWeekplannerListController.prototype.setViewDates = function () {
                var dateFrom = $('#weekplannerCalendar').fullCalendar('getView').start;
                var dateTo = $('#weekplannerCalendar').fullCalendar('getView').end;
                if (typeof dateFrom !== "object")
                    dateFrom = new Date();
                if (typeof dateTo !== "object")
                    dateTo = new Date();
                this.viewDateFrom = moment(dateFrom).startOf('week').format();
                this.viewDateTo = moment(dateTo).endOf('week').add(1, 'day').format();
            };
            FlsWeekplannerListController.prototype.deviceDefault = function () {
                if (this.$stateParams.view && this.$stateParams.view.length > 0)
                    return this.$stateParams.view;
                if (localStorage.getItem('calendarView') != null && localStorage.getItem('calendarView') != 'month') {
                    return localStorage.getItem('calendarView');
                }
                if (QMC.Common.Constants.IS_MOBILE)
                    return 'agendaDay';
                else
                    return 'agendaWeek';
            };
            FlsWeekplannerListController.prototype.getHeight = function () {
                if ($('body').hasClass('mobile'))
                    return 350;
                return null;
            };
            FlsWeekplannerListController.prototype.buildPlanner = function () {
                var _this = this;
                var vm = this;
                var allDayText = this.lng.translate(20018016, "Ganztägig");
                $('#weekplannerCalendar').fullCalendar({
                    schedulerLicenseKey: QMC.Common.Constants.FULL_CALENDAR_PREMIUM_LICENSE,
                    defaultTimedEventDuration: '00:30:00',
                    contentHeight: $(window).height() * 0.6,
                    defaultView: this.deviceDefault(),
                    timezone: 'local',
                    allDaySlot: false,
                    allDayText: allDayText,
                    slotLabelFormat: 'H:mm',
                    slotDuration: this.$qui.timeStringFromHours(this.slotDuration),
                    events: this.eventList,
                    firstDay: 1,
                    weekends: this.showWeekends,
                    monthNames: this.lng.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(','),
                    monthNamesShort: this.lng.translate(20018520, 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez').split(','),
                    dayNames: this.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(','),
                    dayNamesShort: this.lng.translate(20018522, 'So.,Mo.,Di.,Mi.,Do.,Fr.,Sa.').split(','),
                    weekNumbers: true,
                    weekNumberCalculation: function (date) { return moment(date).isoWeek(); },
                    views: {
                        month: {
                            titleFormat: 'MMMM yyyy',
                        },
                        week: {
                            titleFormat: 'dddd, D MMM YYYY',
                        },
                        day: {
                            titleFormat: 'dddd D.MM'
                        }
                    },
                    columnFormat: 'ddd D.M',
                    header: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'agendaWeek, agendaDay'
                    },
                    timeFormat: 'H:mm',
                    buttonText: {
                        today: this.lng.translate(20000126, 'Heute'),
                        month: this.lng.translate(20000115, 'Monat'),
                        week: this.lng.translate(20000114, 'Woche'),
                        day: this.lng.translate(20000041, 'Tag')
                    },
                    viewRender: function (view) {
                        _this.getEvents(view);
                        _this.filterEvents();
                    },
                    editable: this.permissions.fls.new,
                    droppable: true,
                    eventResize: function (event, delta, revertFunc) {
                        if (event.type == _this.typeFlsDocumentation) {
                            _this.changeFlsEvent(event.id, moment(event.start).toDate(), moment(event.end).toDate(), revertFunc);
                        }
                        else if (event.type == _this.typeAzn) {
                            _this.changeAznEvent(event.id, moment(event.start).toDate(), moment(event.end).toDate(), revertFunc);
                        }
                    },
                    eventRender: function (event, element) {
                        $(element).find(".fc-title").prepend(event.iconCode);
                    },
                    eventDrop: function (event, delta, revertFunc) {
                        if (event.type == _this.typeFlsDocumentation && _this.permissions.fls.new) {
                            _this.changeFlsEvent(event.id, moment(event.start).toDate(), moment(event.end || event.start).toDate(), revertFunc);
                        }
                        else if (event.type == _this.typeAzn && _this.permissions.azn.new) {
                            _this.changeAznEvent(event.id, moment(event.start).toDate(), moment(event.end || event.start).toDate(), revertFunc);
                        }
                        else {
                            $('#noPermissionDialog').modal('show');
                        }
                    },
                    eventReceive: function (data) {
                        var _a;
                        vm.formState = 'new';
                        var dropForm = {
                            dateFrom: moment(data.start).toDate(),
                            dateTo: moment(data.start).add(vm.eventLength, 'minutes').toDate(),
                            flsCaseId: data.flsCaseId,
                            serviceTypeId: data.serviceTypeId,
                            clientObjectId: data.clientId,
                            description: '',
                            type: (_a = data.type) !== null && _a !== void 0 ? _a : vm.getTypeFailSafe(data.id),
                            id: data.id
                        };
                        // eventReceive does not come with its own revertFunc, so we create oute own (delete events from calender where ids match)
                        vm.addDropEvent(dropForm, function () {
                            $('#weekplannerCalendar').fullCalendar('removeEvents', function (event) { return event.id === data.id; });
                        });
                    },
                    eventClick: function (e) {
                        sessionStorage.setItem('weekplanner:lastSelectedPerson', _this.selectedPerson);
                        if (e.type === _this.typeFlsDocumentation) {
                            localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                                state: 'weekplanner',
                                params: {
                                    startDay: _this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start),
                                    view: $('#weekplannerCalendar').fullCalendar('getView').name
                                }
                            }));
                            if (e.color === _this.colorFlsDocumentation) {
                                _this.$state.go('documentationdetail', { "id": e.id });
                            }
                            else if (e.color === _this.colorPlannedFlsDocumentation) {
                                var fls_1 = _this.flsWeekPlanning.filter(function (x) { return e.id === x.objectId; })[0];
                                if (!(fls_1 === null || fls_1 === void 0 ? void 0 : fls_1.isPlannedDocumentation))
                                    return;
                                var currentCase = _this.allCases.filter(function (x) { return fls_1.flsCaseId === x.objectId; })[0];
                                if (!currentCase) {
                                    _this.$qui.notify({
                                        message: _this.lng.translate(20002066, "Der gewählte Fall steht nicht mehr zur Verfügung, die Planung kann nicht editiert oder dokumentiert werden!"),
                                        title: _this.lng.translate(20002067, "Editieren nicht möglich"),
                                        icon: "qm-icon-information",
                                        status: "info",
                                        timer: 8000
                                    });
                                    return;
                                }
                                _this.formState = 'edit';
                                _this.dragMode = _this.typeFlsDocumentation;
                                _this.setFlsForm({
                                    id: fls_1.id,
                                    objectId: fls_1.objectId,
                                    clientObjectId: fls_1.clientObjectId,
                                    dateFrom: moment(fls_1.dateFrom).toDate(),
                                    dateTo: moment(fls_1.dateTo).toDate(),
                                    description: fls_1.description,
                                    flsCaseId: fls_1.flsCaseId,
                                    serviceTypeId: currentCase.serviceTypeId,
                                    carerId: fls_1.carerId,
                                    documentationId: fls_1.objectId,
                                    activityTypeId: fls_1.activityTypeId,
                                    careTypeId: fls_1.careTypeId,
                                    contactTypeId: fls_1.contactTypeId,
                                    miscontactId: fls_1.miscontactId
                                });
                                $('#weekplanner-entry').modal('show');
                                _this.$qui.scopeApply(_this.$scope);
                            }
                        }
                        else if (e.type === _this.typeAzn) {
                            if (!e.isPlanned) {
                                localStorage.setItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE, JSON.stringify({
                                    state: _this.$state.$current.name,
                                    params: {
                                        startDay: _this.$qui.createDateFromString($('#weekplannerCalendar').fullCalendar('getView').start),
                                        view: $('#weekplannerCalendar').fullCalendar('getView').name
                                    }
                                }));
                                _this.$state.go('azndetail', { "id": e.id });
                            }
                            else {
                                _this.openAznPlanning(e);
                            }
                        }
                        else if (e.isTypeAppointment) {
                            if (e.end == undefined)
                                e.end = e.start;
                            location.hash = "#/appointment/appointment/" +
                                (e.isRecurring ? e.mid : e.id) + "/" +
                                e.isRecurring + "/" + e.participantObjectId + "/" +
                                e.dateFrom + "/" +
                                ((e.start !== undefined) ? moment(e.start._d).toISOString() : 0) + "/" +
                                ((e.end !== undefined) ? moment(e.end._d).toISOString() : ((e.start !== undefined) ? moment(e.start._d).toISOString() : 0)) + "/" +
                                e.isRecurring + ("/" + e.permFlag);
                        }
                    },
                    dayClick: function () {
                        console.log('NOT IMPLEMENTED NOW');
                    }
                });
                this.filterEvents();
            };
            FlsWeekplannerListController.prototype.getTypeFailSafe = function (id) {
                if (this.cases.some(function (x) { return x.objectId === id; }))
                    return this.typeFlsDocumentation;
                if (this.aznTypesMap.some(function (x) { return x.value === id; }))
                    return this.typeAzn;
            };
            FlsWeekplannerListController = __decorate([
                QMC.Controller('QMC.Fachleistung', 'FlsWeekplannerListController'),
                QMC.Inject('$location', 'FachleistungService', '$qui', 'TerminService', 'ArbeitszeitnachweisService', '$scope', '$state', '$timeout', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$stateParams')
            ], FlsWeekplannerListController);
            return FlsWeekplannerListController;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var QmWeekPlannerCopyDirective = /** @class */ (function () {
            function QmWeekPlannerCopyDirective($qui, $state, lng, permissionService, flsService, aznService) {
                var _this = this;
                this.$qui = $qui;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.flsService = flsService;
                this.aznService = aznService;
                this.restrict = 'E';
                this.templateUrl = './fls/WeekplannerCopyDirective';
                this.replace = true;
                this.scope = {
                    qmCalendarName: '@',
                    qmData: '=',
                    qmCarerId: '=' // = is a two way databinding
                };
                this.link = function (scope) {
                    //init
                    scope.cases = [];
                    _this.flsService.getCasesList(null, true).then(function (cases) {
                        scope.cases = cases;
                    });
                    if (!scope.qmCalendarName || scope.qmCalendarName == '')
                        scope.qmCalendarName = 'calendar';
                    scope.lng = _this.lng;
                    scope.flsService = _this.flsService;
                    scope.aznService = _this.aznService;
                    scope.$qui = _this.$qui;
                    scope.copySettings = {
                        copyMode: 'target',
                        futureWeekSelect: 0,
                        start: null,
                        end: null,
                        candidates: [],
                        plannings: [],
                        errors: [],
                        state: 'select',
                        selectAllCandidates: false,
                        selectAllPlannings: false,
                        isValidationFinished: false
                    };
                    scope.dayNames = scope.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(',');
                    scope.$watch('qmData', function (newVal, oldVal) {
                        if (newVal == oldVal)
                            return;
                        scope.createCandidates();
                    }, true);
                    scope.$watch('copySettings.isValidationFinished', function (newVal, oldVal) {
                        if (newVal === oldVal)
                            return;
                        if (newVal) {
                            scope.anythingOrAllSelected(scope.copySettings.plannings, true);
                            scope.copySettings.isValidationFinished = false;
                        }
                    }, true);
                    scope.createCandidates = function () {
                        var _a;
                        if (!scope.cases || scope.cases.length === 0)
                            setTimeout(function () { scope.createCandidates(); }, 500);
                        var start = _this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                        var end = _this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').end);
                        scope.copySettings.candidates = [];
                        var _loop_9 = function (candidate) {
                            if (candidate.dateFrom >= start && candidate.dateTo <= end) {
                                candidate.flsCase = (_a = scope.cases.filter(function (x) { return x.objectId === candidate.flsCaseId; })[0]) !== null && _a !== void 0 ? _a : null;
                                if ((candidate.flsCase || candidate.type !== 230000) && !scope.copySettings.candidates.some(function (x) { return JSON.stringify(x) === JSON.stringify(candidate); }))
                                    scope.copySettings.candidates.push(candidate);
                            }
                        };
                        for (var _i = 0, _b = scope.qmData; _i < _b.length; _i++) {
                            var candidate = _b[_i];
                            _loop_9(candidate);
                        }
                        scope.copySettings.candidates = scope.copySettings.candidates.sort(function (a, b) { return a.dateFrom > b.dateFrom ? 1 : a.dateFrom < b.dateFrom ? -1 : 0; });
                    };
                    scope.openCopyDialog = function () {
                        scope.loading = true;
                        $('#weekplanner-copy-modal').modal('show');
                        scope.copySettings.copyMode = 'target';
                        scope.copySettings.futureWeekSelect = 0;
                        scope.copySettings.plannings = [];
                        scope.copySettings.errors = [];
                        scope.copySettings.state = 'select';
                        //create target Week DropDown Values
                        var start = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                        scope.futureWeeks = [];
                        for (var i = 0; i < 53; i++) {
                            var temp = this.$qui.createDateFromString(start.toISOString());
                            temp = this.$qui.createDateFromString(temp.setDate(temp.getDate() + i * 7));
                            var weeks = weeksBetween(temp, new Date());
                            if (!(weeksBetween(temp, new Date()) > 1) || temp > new Date() || (temp < new Date() && weeks == 1))
                                if (i === 0)
                                    scope.futureWeeks.push({ value: i, text: i + 1 + " " + this.lng.translate(20000114, "Woche") });
                                else
                                    scope.futureWeeks.push({ value: i, text: i + 1 + " " + this.lng.translate(20000118, "Wochen") });
                        }
                        if (moment(start).week() < moment(new Date()).week()) {
                            var firstInArray = scope.futureWeeks[0];
                            scope.futureWeeks.unshift({ value: firstInArray.value - 1, text: this.lng.translate(20016187, "aktuelle Woche") });
                        }
                        scope.copySettings.futureWeekSelect = scope.futureWeeks[0].value;
                        scope.calculateCopyWeek();
                        // reset checkboxes
                        for (var _i = 0, _a = scope.copySettings.candidates; _i < _a.length; _i++) {
                            var candidate = _a[_i];
                            candidate.isChecked = false;
                        }
                        $("#wpcm-toggleAllPlCb").prop("checked", false);
                        $("#wpcm-toggleAllCandCb").prop("checked", false);
                        scope.loading = false;
                    };
                    /////////////////// TimeFrame Helper Functions ///////////////////
                    scope.calculateCopyWeek = function () {
                        if (scope.copySettings.copyMode === 'target') {
                            var start = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                            var temp = getNextWeek(start, 1);
                            scope.copySettings.start = this.$qui.createDateFromString(temp.setDate(temp.getDate() + (scope.copySettings.futureWeekSelect) * 7));
                            temp = this.$qui.createDateFromString(scope.copySettings.start.toDateString());
                            scope.copySettings.end = this.$qui.createDateFromString(temp.setDate(temp.getDate() + 6));
                        }
                        else if (scope.copySettings.copyMode === 'timeFrame') {
                            scope.copySettings.start = getNextWeek(new Date(), 1);
                            var temp = this.$qui.createDateFromString(scope.copySettings.start.getTime());
                            scope.copySettings.end = moment(this.$qui.createDateFromString(temp.setDate(temp.getDate() + 6))).add(scope.copySettings.futureWeekSelect, 'weeks').toDate();
                        }
                    };
                    var getNextWeek = function (date, dayOfWeek) {
                        var dayOffset = dayOfWeek > date.getDay()
                            ? dayOfWeek - date.getDay()
                            : dayOfWeek - date.getDay() + 7;
                        date.setDate(date.getDate() + dayOffset);
                        return date;
                    };
                    var weeksBetween = function (date1, date2) {
                        var date1ms = date1.getTime();
                        var date2ms = date2.getTime();
                        var diff = Math.abs(date2ms - date1ms);
                        // round back to weeks
                        return Math.ceil(diff / (1000 * 60 * 60 * 24 * 7));
                    };
                    /////////////////// Gui Helper Functions ///////////////////
                    scope.toggleAll = function (selectAllCandidates) {
                        var _this = this;
                        if (selectAllCandidates === void 0) { selectAllCandidates = true; }
                        var value = selectAllCandidates ? scope.copySettings.selectAllCandidates : scope.copySettings.selectAllPlannings;
                        for (var _i = 0, _a = selectAllCandidates ? scope.copySettings.candidates : scope.copySettings.plannings; _i < _a.length; _i++) {
                            var selection = _a[_i];
                            selection.isChecked = selectAllCandidates || !value ? value : selection.validation.warnings.length + selection.validation.errors.length === 0;
                        }
                        setTimeout(function () {
                            _this.$qui.scopeApply(_this.$scope);
                        }, 5);
                    };
                    scope.getDayName = function (date) {
                        var dayNumber = (this.$qui.createDateFromString(date)).getDay();
                        if (dayNumber < 0)
                            return scope.dayNames[0];
                        if (dayNumber > 6)
                            return scope.dayNames[6];
                        return scope.dayNames[dayNumber];
                    };
                    scope.anythingOrAllSelected = function (arr, selectAll) {
                        if (selectAll === void 0) { selectAll = false; }
                        var result = false;
                        if (!selectAll) {
                            var itemFound = arr.find(function (item) { return item.isChecked === true; });
                            result = itemFound != null ? true : false;
                        }
                        else {
                            result = arr.every(function (item) { return item.isChecked === true; });
                        }
                        if (selectAll) {
                            if (arr === scope.copySettings.plannings) {
                                scope.copySettings.selectAllPlannings = result;
                                $("#wpcm-toggleAllPlCb").prop("checked", scope.copySettings.selectAllPlannings);
                            }
                            else {
                                scope.copySettings.selectAllCandidates = result;
                                $("#wpcm-toggleAllCandCb").prop("checked", scope.copySettings.selectAllCandidates);
                            }
                        }
                        return result;
                    };
                    scope.getValidationButtonState = function (validation) {
                        if (validation == (null || undefined)) {
                            validation = {
                                errors: [this.lng.translate(20016182, "Noch keine Validierung durchgeführt")],
                                warnings: []
                            };
                        }
                        ;
                        if (validation.errors.length == 0 && validation.warnings.length == 0)
                            return 0;
                        if (validation.errors.length == 0)
                            return 1;
                        return 2;
                    };
                    scope.showValidation = function (item) {
                        scope.currentItem = item;
                        $('#weekplanner-copy-validation-modal').modal('show');
                    };
                    // Workaround part2 since normal modal messes up the dom for whatever reason.
                    scope.hideValidation = function () {
                        $('#weekplanner-copy-validation-modal').modal('hide');
                    };
                    scope.isSaveDisabled = function () {
                        for (var _i = 0, _a = scope.copySettings.plannings; _i < _a.length; _i++) {
                            var planning = _a[_i];
                            if (planning.isChecked && !planning.isValidating)
                                return false;
                        }
                        return true;
                    };
                    scope.toggleMode = function () {
                        scope.copySettings.futureWeekSelect = scope.futureWeeks[0].value;
                        setTimeout(function () {
                            scope.calculateCopyWeek();
                        }, 250);
                    };
                    /////////////////// Planning creation ///////////////////
                    scope.createPlannings = function () {
                        var _a, _b, _c, _d, _e, _f;
                        scope.loading = true;
                        scope.copySettings.errors = [];
                        scope.copySettings.plannings = [];
                        var validationObjects = [];
                        //Create plannings
                        for (var _i = 0, _g = scope.copySettings.candidates; _i < _g.length; _i++) {
                            var candidate = _g[_i];
                            if (!candidate.isChecked)
                                continue;
                            if (candidate.type === 230000) {
                                var currentCase = candidate.flsCase;
                                if (currentCase == (null || undefined)) {
                                    scope.copySettings.errors.push(this.lng.translate(20016181, "Für den folgenden Fall kann keine Planung angelegt werden") + ': ' + candidate.reportTitle
                                        + ', ' + moment(candidate.dateFrom).format('DD.MM.YYYY HH:mm') + ' - ' + moment(candidate.dateTo).format('DD.MM.YYYY HH:mm'));
                                    continue;
                                }
                                if (scope.copySettings.copyMode == 'target') {
                                    var planning = createWeekPlanningObjectFls(currentCase, candidate, scope.copySettings.futureWeekSelect);
                                    planning.isValidating = true;
                                    validationObjects.push({
                                        dateFrom: planning.dateFrom,
                                        dateTo: planning.dateTo === undefined ? moment(planning.dateFrom).add(1, 'hours').toDate() : planning.dateTo,
                                        hasManualDuration: false,
                                        documentationId: planning.documentationId,
                                        references: [{ caseId: currentCase.objectId, referenceId: currentCase.clientObjectId, accountabilityId: currentCase.defaultAccountableRuleId }],
                                        carer: [{
                                                carerId: (_a = scope.qmCarerId) !== null && _a !== void 0 ? _a : $("#session").data().personId,
                                                activityTypeId: (_b = planning.activityTypeId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                                                contactTypeId: planning.contactTypeId,
                                                careTypeId: planning.careTypeId,
                                                miscontactId: (_c = planning.miscontactId) !== null && _c !== void 0 ? _c : QMC.Common.Constants.FLS_NO_MISCONTACT
                                            }],
                                        manualDuration: 0,
                                        ignoreConfigRoundInterval: false,
                                        requestId: planning.documentationId
                                    });
                                    scope.copySettings.plannings.push(planning);
                                }
                                else if (scope.copySettings.copyMode === 'timeFrame') {
                                    for (var j = 0; j <= scope.copySettings.futureWeekSelect; j++) {
                                        var planning = createWeekPlanningObjectFls(currentCase, candidate, j);
                                        planning.isValidating = true;
                                        validationObjects.push({
                                            dateFrom: planning.dateFrom,
                                            dateTo: planning.dateTo === undefined ? moment(planning.dateFrom).add(1, 'hours').toDate() : planning.dateTo,
                                            hasManualDuration: false,
                                            documentationId: planning.documentationId,
                                            references: [{ caseId: currentCase.objectId, referenceId: currentCase.clientObjectId, accountabilityId: currentCase.defaultAccountableRuleId }],
                                            carer: [{
                                                    carerId: (_d = scope.qmCarerId) !== null && _d !== void 0 ? _d : $("#session").data().personId,
                                                    activityTypeId: (_e = planning.activityTypeId) !== null && _e !== void 0 ? _e : QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                                                    contactTypeId: planning.contactTypeId,
                                                    careTypeId: planning.careTypeId,
                                                    miscontactId: (_f = planning.miscontactId) !== null && _f !== void 0 ? _f : QMC.Common.Constants.FLS_NO_MISCONTACT
                                                }],
                                            manualDuration: 0,
                                            ignoreConfigRoundInterval: false,
                                            requestId: planning.documentationId
                                        });
                                        scope.copySettings.plannings.push(planning);
                                    }
                                }
                            }
                            if (candidate.type === 425000) {
                                if (scope.copySettings.copyMode == 'target') {
                                    var planning = createWeekPlanningObjectAzn(candidate, scope.copySettings.futureWeekSelect);
                                    validatePlanningAzn(planning);
                                    scope.copySettings.plannings.push(planning);
                                }
                                else if (scope.copySettings.copyMode == 'timeFrame') {
                                    for (var j = 0; j <= scope.copySettings.futureWeekSelect; j++) {
                                        var planning = createWeekPlanningObjectAzn(candidate, j);
                                        validatePlanningAzn(planning);
                                        scope.copySettings.plannings.push(planning);
                                    }
                                }
                            }
                        }
                        if (validationObjects.length > 0) {
                            validatePlanningFls(validationObjects);
                        }
                        scope.copySettings.plannings = scope.copySettings.plannings.sort(function (a, b) { return a.dateFrom > b.dateFrom ? 1 : a.dateFrom < b.dateFrom ? -1 : 0; });
                        scope.loading = false;
                    };
                    var validatePlanningFls = function (validationObjects) {
                        scope.flsService.checkForWarningsAndErrors(validationObjects, true).then(function (data) {
                            data.forEach(function (result) {
                                var _a;
                                var planning = scope.copySettings.plannings.filter(function (x) { return x.documentationId === result.requestId; })[0];
                                if (!planning)
                                    return;
                                planning.validation = result.validation[(_a = scope.qmCarerId) !== null && _a !== void 0 ? _a : $("#session").data().personId];
                                planning.isValidating = false;
                                if (planning.validation.errors.length == 0 && planning.validation.warnings.length == 0)
                                    planning.isChecked = true;
                                else
                                    planning.isChecked = false;
                            });
                            scope.copySettings.isValidationFinished = true;
                        });
                    };
                    var validatePlanningAzn = function (planning) {
                        planning.isValidating = true;
                        scope.aznService.checkForWarningsAndErrors({
                            idObjectAznw: QMC.Common.Constants.GUID_EMPTY,
                            dateFrom: planning.dateFrom,
                            dateTo: planning.dateTo,
                            performingPersonObjIdList: [planning.carerId],
                            activityId: planning.activityTypeId,
                            imputeWvId: QMC.Common.Constants.GUID_EMPTY,
                            instituteId: QMC.Common.Constants.GUID_EMPTY,
                            isPlanned: true
                        }).then(function (data) {
                            planning.validation = data;
                            planning.isValidating = false;
                            if (data.errors.length == 0 && data.warnings.length == 0)
                                planning.isChecked = true;
                            else
                                planning.isChecked = false;
                        });
                    };
                    var createWeekPlanningObjectFls = function (currentCase, item, modifier) {
                        var weekModifier = (7 * (modifier + 1));
                        var tempStart = new Date(item.dateFrom.getTime());
                        var tempEnd = new Date(item.dateTo.getTime());
                        var newEntry = __assign(__assign({}, item), { dateFrom: new Date(tempStart.setDate(tempStart.getDate() + weekModifier)), dateTo: new Date(tempEnd.setDate(tempEnd.getDate() + weekModifier)), flsCaseId: currentCase.objectId, serviceTypeId: currentCase.serviceTypeId, clientObjectId: currentCase.clientObjectId, title: item.title, isValidating: false, isChecked: false, validation: null, type: item.type, documentationId: scope.copySettings.copyMode === 'timeFrame' ? scope.$qui.generateGuid() : item.id, description: "" });
                        return newEntry;
                    };
                    var createWeekPlanningObjectAzn = function (item, modifier) {
                        var weekModifier = (7 * (modifier + 1));
                        var tempStart = new Date(item.dateFrom.getTime());
                        var tempEnd = new Date(item.dateTo.getTime());
                        var newEntry = {
                            dateFrom: new Date(tempStart.setDate(tempStart.getDate() + weekModifier)),
                            dateTo: new Date(tempEnd.setDate(tempEnd.getDate() + weekModifier)),
                            clientObjectId: $('#session').data().personId,
                            flsCaseId: item.aznImputeId,
                            serviceTypeId: item.aznTypeId,
                            title: item.title,
                            isValidating: false,
                            isChecked: false,
                            validation: null,
                            type: item.type,
                            documentationId: QMC.Common.Constants.GUID_EMPTY,
                            description: ""
                        };
                        return newEntry;
                    };
                    scope.postPlannings = function () {
                        var _a;
                        scope.loading = true;
                        var toCreateFls = [];
                        var toCreateAzn = [];
                        for (var _i = 0, _b = scope.copySettings.plannings; _i < _b.length; _i++) {
                            var planning = _b[_i];
                            if (planning.isChecked && planning.type === 230000) {
                                toCreateFls.push({
                                    id: null,
                                    objectId: null,
                                    carerId: (_a = scope.qmCarerId) !== null && _a !== void 0 ? _a : $("#session").data().personId,
                                    clientObjectId: planning.clientObjectId,
                                    dateFrom: planning.dateFrom,
                                    dateTo: planning.dateTo,
                                    flsCaseId: planning.flsCaseId,
                                    serviceTypeId: planning.serviceTypeId,
                                    description: null,
                                    documentationId: null,
                                    activityTypeId: planning.activityForm.activityTypeId,
                                    contactTypeId: planning.activityForm.contactTypeId,
                                    careTypeId: planning.activityForm.careTypeId,
                                    miscontactId: !planning.activityForm || planning.activityForm.miscontactId === QMC.Common.Constants.GUID_EMPTY
                                        ? QMC.Common.Constants.FLS_NO_MISCONTACT
                                        : planning.activityForm.miscontactId
                                });
                            }
                            if (planning.isChecked && planning.type === 425000) {
                                toCreateAzn.push({
                                    dateFrom: planning.dateFrom,
                                    dateTo: planning.dateTo,
                                    referencePersonId: planning.clientObjectId,
                                    typeId: planning.serviceTypeId,
                                    imputeId: planning.flsCaseId // ... azn purposes
                                });
                            }
                        }
                        scope.savingFls = false;
                        if (toCreateFls.length > 0) {
                            scope.savingFls = true;
                            this.flsService.postWeekPlanningPlannedDoc(toCreateFls).then(function (data) {
                                scope.savingFls = false;
                                finishSaving();
                            });
                        }
                        scope.savingAzn = false;
                        if (toCreateAzn.length > 0) {
                            scope.savingAzn = true;
                            this.aznService.postAznWeekPlanning(toCreateAzn).then(function (data) {
                                scope.savingAzn = false;
                                finishSaving();
                            });
                        }
                    };
                    var finishSaving = function () {
                        if (scope.savingAzn || scope.savingFls)
                            return;
                        scope.loading = false;
                        $('#weekplanner-copy-modal').modal('hide');
                        scope.$qui.notify(scope.$qui.successNote);
                    };
                };
            }
            QmWeekPlannerCopyDirective = __decorate([
                QMC.Directive('QMC.Fachleistung', 'qmWeekplannerCopy', ['$qui', '$state', 'QmcLanguageService', 'QmcPermissionService', 'FachleistungService', 'ArbeitszeitnachweisService'])
            ], QmWeekPlannerCopyDirective);
            return QmWeekPlannerCopyDirective;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var QmWeekPlannerDeleteDirective = /** @class */ (function () {
            function QmWeekPlannerDeleteDirective($qui, $state, lng, permissionService, flsService, aznService) {
                var _this = this;
                this.$qui = $qui;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.flsService = flsService;
                this.aznService = aznService;
                this.restrict = 'E';
                this.templateUrl = './fls/WeekplannerDeleteDirective';
                this.replace = true;
                this.scope = {
                    qmCalendarName: '@',
                    qmData: '=',
                    qmCases: '='
                };
                this.link = function (scope) {
                    //init
                    if (!scope.qmCalendarName || scope.qmCalendarName == '')
                        scope.qmCalendarName = 'calendar';
                    scope.lng = _this.lng;
                    scope.flsService = _this.flsService;
                    scope.aznService = _this.aznService;
                    scope.$qui = _this.$qui;
                    scope.$state = _this.$state;
                    scope.promptOptions = {
                        title: "Wochenplannung Löschen",
                        yesNo: true,
                        icon: "qm-icon-history2",
                        text: 'Wollen Sie den Einträge wirklich löschen?',
                    };
                    scope.canDeleteAzn = _this.deleteAzn;
                    scope.canDeleteFls = _this.delete;
                    scope.deleteSettings = {
                        start: null,
                        end: null,
                        plannedItems: [],
                        plannedItemsToDelete: [],
                        errors: [],
                        state: 'select',
                        selectAll: false
                    };
                    scope.$watch('qmData', function (newVal, oldVal) {
                        if (newVal == oldVal)
                            return;
                        var start = _this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                        var end = _this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').end);
                        scope.deleteSettings.plannedItems = [];
                        for (var _i = 0, _a = scope.qmData; _i < _a.length; _i++) {
                            var plannedItem = _a[_i];
                            if (plannedItem.dateFrom >= start && plannedItem.dateTo <= end) {
                                scope.deleteSettings.plannedItems.push(plannedItem);
                            }
                        }
                        scope.deleteSettings.plannedItems = scope.deleteSettings.plannedItems.sort(function (a, b) { return a.dateFrom > b.dateFrom ? 1 : a.dateFrom < b.dateFrom ? -1 : 0; });
                    }, true);
                    scope.openDeleteDialog = function () {
                        scope.loading = true;
                        $('#weekplanner-delete-modal').modal('show');
                        scope.deleteSettings.errors = [];
                        scope.deleteSettings.state = 'select';
                        scope.deleteSettings.selectAll = false;
                        //create target Week DropDown Values
                        var start = this.$qui.createDateFromString($('#' + scope.qmCalendarName).fullCalendar('getView').start);
                        // reset checkboxes
                        for (var _i = 0, _a = scope.deleteSettings.plannedItems; _i < _a.length; _i++) {
                            var plannedItem = _a[_i];
                            plannedItem.isChecked = false;
                        }
                        $("#wpcm-toggleDeleteAllCb").prop("checked", false);
                        scope.loading = false;
                    };
                    /////////////////// Planning items to be deleted creation ///////////////////
                    scope.createPlanningItemsToBeDeleted = function () {
                        scope.loading = true;
                        scope.deleteSettings.errors = [];
                        scope.deleteSettings.plannedItemsToDelete = [];
                        //Create the items to be deleted with validation
                        for (var _i = 0, _a = scope.deleteSettings.plannedItems; _i < _a.length; _i++) {
                            var plannedItem = _a[_i];
                            if (!plannedItem.isChecked)
                                continue;
                            var planningItemToDelete = createWeekPlanningDeleteObjectFls(plannedItem);
                            planningItemToDelete.isChecked = true;
                            scope.deleteSettings.plannedItemsToDelete.push(planningItemToDelete);
                        }
                        scope.deleteSettings.plannedItemsToDelete = scope.deleteSettings.plannedItemsToDelete.sort(function (a, b) { return a.dateFrom > b.dateFrom ? 1 : a.dateFrom < b.dateFrom ? -1 : 0; });
                        scope.deleteSettings.state = 'delete';
                        scope.loading = false;
                    };
                    var createWeekPlanningDeleteObjectFls = function (item) {
                        var newEntry = {
                            id: item.id,
                            objectId: item.objectId,
                            dateTo: item.dateTo,
                            dateFrom: item.dateFrom,
                            isChecked: item.isChecked,
                            type: item.type,
                            flsCase: item.flsCase,
                            title: item.title,
                            aznImputeId: item.aznImputeId,
                            aznTypeId: item.aznTypeId
                        };
                        return newEntry;
                    };
                    /////////////////// Planning items to be deleted creation ///////////////////
                    scope.deletePlannings = function () {
                        scope.loading = true;
                        //QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                        $('#weekplanner-delete-modal').modal('hide');
                        var _loop_10 = function (plannedItemToDelete) {
                            if (plannedItemToDelete.type == 230000) {
                                scope.flsService.deleteWeekPlanningPlannedDoc(plannedItemToDelete.objectId).then(function () {
                                    $('#weekplannerCalendar').fullCalendar('removeEvents', plannedItemToDelete.objectId);
                                    scope.RemoveItemsFromDeleteList(plannedItemToDelete);
                                });
                            }
                            if (plannedItemToDelete.type == 425000) {
                                this_6.aznService.deleteAznWeekPlanning(plannedItemToDelete.id).then(function () {
                                    $('#weekplannerCalendar').fullCalendar('removeEvents', plannedItemToDelete.objectId);
                                    scope.RemoveItemsFromDeleteList(plannedItemToDelete);
                                });
                            }
                        };
                        var this_6 = this;
                        //if (data) {
                        for (var _i = 0, _a = scope.deleteSettings.plannedItemsToDelete; _i < _a.length; _i++) {
                            var plannedItemToDelete = _a[_i];
                            _loop_10(plannedItemToDelete);
                        }
                        this.$qui.notify(this.$qui.deleteNotes);
                        setTimeout(function () { scope.$state.go('weekplanner', {}, { reload: true }); }, 500);
                        //}
                        //else {
                        //  $('#weekplanner-delete-modal').modal('hide');
                        //}
                        //});
                        scope.loading = false;
                    };
                    scope.RemoveItemsFromDeleteList = function (deletedItem) {
                        for (var i = 0; i < scope.deleteSettings.plannedItemsToDelete.length; i++) {
                            if (scope.deleteSettings.plannedItemsToDelete[i].objectId === deletedItem.objectId) {
                                scope.deleteSettings.plannedItemsToDelete.splice(i, 1);
                            }
                        }
                    };
                    scope.toggleAllDelete = function (value) {
                        var _this = this;
                        if (value == null || value == undefined)
                            value = scope.deleteSettings.selectAll;
                        for (var _i = 0, _a = scope.deleteSettings.plannedItems; _i < _a.length; _i++) {
                            var plannedItem = _a[_i];
                            plannedItem.isChecked = value;
                        }
                        setTimeout(function () {
                            _this.$qui.scopeApply(_this.$scope);
                        }, 5);
                    };
                    scope.anythingSelected = function (arr) {
                        for (var _i = 0, arr_2 = arr; _i < arr_2.length; _i++) {
                            var element = arr_2[_i];
                            if (element.isChecked)
                                return true;
                        }
                        return false;
                    };
                    scope.isDeleteDisabled = function () {
                        for (var _i = 0, _a = scope.deleteSettings.plannedItemsToDelete; _i < _a.length; _i++) {
                            var plannedItemToDelete = _a[_i];
                            if (plannedItemToDelete.isChecked)
                                return false;
                        }
                        return true;
                    };
                };
                //ObjectType: FlsZeitplanungSoll
                permissionService.getPermissionsByObjectType(230007).then(function (data) {
                    _this.delete = data[0].delete && data[0].moduleAccess;
                    _this.new = data[0].new && data[0].moduleAccess;
                    _this.modify = data[0].modify && data[0].moduleAccess;
                });
                permissionService.getPermissionsByObjectType(411010).then(function (data) {
                    _this.deleteAzn = data[0].delete && data[0].moduleAccess;
                    _this.newAzn = data[0].new && data[0].moduleAccess;
                    _this.modifyAzn = data[0].modify && data[0].moduleAccess;
                });
            }
            QmWeekPlannerDeleteDirective = __decorate([
                QMC.Directive('QMC.Fachleistung', 'qmWeekplannerDelete', ['$qui', '$state', 'QmcLanguageService', 'QmcPermissionService', 'FachleistungService', 'ArbeitszeitnachweisService'])
            ], QmWeekPlannerDeleteDirective);
            return QmWeekPlannerDeleteDirective;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var WeekplannerAznFormDirective = /** @class */ (function () {
            function WeekplannerAznFormDirective(scope, userService) {
                var _this = this;
                this.scope = scope;
                this.id = '_' + Math.random().toString(36).substring(2, 10);
                this.carerMap = [];
                this.types = [];
                this.loading = { wv: false };
                this.watchers = [];
                this.$postLink = function () {
                    _this.events();
                };
                this.$onDestroy = function () {
                    _this.watchers.forEach(function (watcher) { return watcher(); });
                };
                userService.getUserSettings(['AZN.SHOWDATETO']).then(function (data) {
                    _this.showDateTo = data[0].value.toLowerCase() === 'true';
                });
            }
            WeekplannerAznFormDirective.prototype.events = function () {
                var _this = this;
                this.watchers.push(this.scope.$watch('vm.carer', function () {
                    var _a, _b;
                    _this.carerMap = (_b = (_a = _this.carer) === null || _a === void 0 ? void 0 : _a.map(function (x) { return ({ text: x.displayTitle, value: x.objectId }); })) !== null && _b !== void 0 ? _b : [];
                }, true));
                this.watchers.push(this.scope.$watch('vm.form', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    //reset the form
                    _this.id.$setPristine();
                    _this.id.$setUntouched();
                }));
            };
            WeekplannerAznFormDirective.prototype.isGuidEmpty = function (guid) {
                return !guid || guid === QMC.Common.Constants.GUID_EMPTY;
            };
            return WeekplannerAznFormDirective;
        }());
        angular.module('QMC.Fachleistung').component('qmWeekplannerAznForm', {
            templateUrl: './fls/WeekplannerAznForm',
            controller: ['$scope', 'UserService', WeekplannerAznFormDirective],
            controllerAs: 'vm',
            bindings: {
                carer: '=',
                types: '=',
                form: '=?',
                isValid: '=?'
            }
        });
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var WeekplannerFlsFormDirective = /** @class */ (function () {
            function WeekplannerFlsFormDirective(scope, $qui, flsService, userService) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.flsService = flsService;
                this.id = '_' + Math.random().toString(36).substring(2, 10);
                this.cases = {};
                this.casesMap = [];
                this.carerMap = [];
                this.loading = { wv: false };
                this.watchers = [];
                this.defaultActivities = {
                    activity: QMC.Common.Constants.DEFAULT_ACTIVITY_ID,
                    careType: QMC.Common.Constants.GUID_EMPTY,
                    contactType: QMC.Common.Constants.GUID_EMPTY
                };
                // settings
                this.defaultEventLength = 60;
                this.getFutureCases = true;
                this.getPastCases = true;
                this.$postLink = function () {
                    _this.events();
                    _this.setForm = function (form, caseId, carerId) { return __awaiter(_this, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    this.watchers.forEach(function (watcher) { return watcher(); });
                                    this.form = form !== null && form !== void 0 ? form : {
                                        id: undefined,
                                        objectId: undefined,
                                        clientObjectId: QMC.Common.Constants.GUID_EMPTY,
                                        dateFrom: moment().startOf('hour').toDate(),
                                        dateTo: moment().startOf('hour').add(this.defaultEventLength, 'm').toDate(),
                                        description: '',
                                        documentationId: QMC.Common.Constants.GUID_EMPTY,
                                        flsCaseId: QMC.Common.Constants.GUID_EMPTY,
                                        serviceTypeId: QMC.Common.Constants.GUID_EMPTY,
                                        carerId: ((_a = this.carer) === null || _a === void 0 ? void 0 : _a.some(function (x) { return x.objectId === $("#session").data().personId; })) ? $("#session").data().personId : QMC.Common.Constants.GUID_EMPTY
                                    };
                                    this.isMiscontactEnabled = !this.isGuidEmpty(form === null || form === void 0 ? void 0 : form.miscontactId) && (form === null || form === void 0 ? void 0 : form.miscontactId) !== QMC.Common.Constants.FLS_NO_MISCONTACT;
                                    this.internalMiscontactId = (_b = form === null || form === void 0 ? void 0 : form.miscontactId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.FLS_NO_MISCONTACT;
                                    this.form.flsCaseId = caseId !== null && caseId !== void 0 ? caseId : this.form.flsCaseId;
                                    this.form.carerId = carerId !== null && carerId !== void 0 ? carerId : this.form.carerId;
                                    if (!this.internalMiscontactId || this.internalMiscontactId === QMC.Common.Constants.GUID_EMPTY)
                                        this.internalMiscontactId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                                    return [4 /*yield*/, this.getWv()];
                                case 1:
                                    _c.sent();
                                    this.events();
                                    return [2 /*return*/, Promise.resolve(this.form)];
                            }
                        });
                    }); };
                };
                this.$onDestroy = function () {
                    _this.watchers.forEach(function (watcher) { return watcher(); });
                };
                this.setCasesMap = function () {
                    var _a, _b;
                    if (!((_a = _this.form) === null || _a === void 0 ? void 0 : _a.carerId))
                        return;
                    if (_this.cases[_this.form.carerId] === 'loading') {
                        setTimeout(_this.setCasesMap, 250);
                        return;
                    }
                    var cases = (_b = _this.cases[_this.form.carerId]) !== null && _b !== void 0 ? _b : [];
                    if (cases === 'loading')
                        cases = [];
                    if (!_this.getFutureCases) {
                        cases = cases.filter(function (item) { return moment(item.dateFrom).toDate() <= new Date(); });
                    }
                    if (!_this.getPastCases) {
                        cases = cases.filter(function (item) { return !item.dateTo || moment(item.dateTo).endOf("day").toDate() >= new Date(); });
                    }
                    // if cases are fitlered by current, ensure that current selected case is always present (editing)
                    _this.casesMap = cases.filter(function (x) { var _a; return !_this.onlyCurrent || x.isCurrent || ((_a = _this.form) === null || _a === void 0 ? void 0 : _a.flsCaseId) === x.objectId; }).map(function (x) { return (__assign(__assign({}, _this.$qui.createCaseDisplayObject(x)), { warn: !x.isCurrent })); });
                };
                this.getCases = function () {
                    var _a;
                    if (!((_a = _this.form) === null || _a === void 0 ? void 0 : _a.carerId) || _this.form.carerId === QMC.Common.Constants.GUID_EMPTY)
                        return;
                    _this.cases[_this.form.carerId] = 'loading';
                    _this.flsService.getCasesList(QMC.Common.Constants.GUID_EMPTY, false, _this.form.carerId).then(function (data) {
                        _this.cases[_this.form.carerId] = data;
                    }).catch(function () { return _this.cases[_this.form.carerId] = []; }).finally(function () { _this.setCaseDependetForm(); _this.setCasesMap(); });
                };
                this.setCaseDependetForm = function () {
                    var _a, _b;
                    if (_this.form && _this.cases[_this.form.carerId]) {
                        if (_this.cases[_this.form.carerId] === 'loading') {
                            setTimeout(_this.setCaseDependetForm, 250);
                            return;
                        }
                        var currentCase = _this.cases[_this.form.carerId].filter(function (x) { return _this.form.flsCaseId === x.objectId; })[0];
                        _this.form.clientObjectId = (_a = currentCase === null || currentCase === void 0 ? void 0 : currentCase.clientObjectId) !== null && _a !== void 0 ? _a : QMC.Common.Constants.GUID_EMPTY;
                        _this.form.serviceTypeId = (_b = currentCase === null || currentCase === void 0 ? void 0 : currentCase.serviceTypeId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.GUID_EMPTY;
                    }
                };
                this.flsService.getUserConfig().then(function (data) {
                    _this.defaultActivities.activity = data.defaultActivityType;
                    _this.defaultActivities.careType = data.defaultCareType;
                    _this.defaultActivities.contactType = data.defaultContactType;
                });
                userService.getUserSettings(['FLS.WEEKPLANNER.DEFAULTEVENTLENGTH', 'FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES', 'FLS.WEEKPLANNER_INCLUDE_PAST_CASES', 'FLS.SHOWDATETO']).then(function (data) {
                    _this.defaultEventLength = data[0].value && data[0].value.length > 0 ? parseInt(data[0].value) : _this.defaultEventLength;
                    _this.getFutureCases = data[1].value === "" ? _this.getFutureCases : data[1].value.toLowerCase() === "true";
                    _this.getPastCases = data[2].value === "" ? _this.getPastCases : data[2].value.toLowerCase() === "true";
                    _this.showDateTo = data[3].value.toLowerCase() === 'true';
                    _this.getWv();
                });
            }
            WeekplannerFlsFormDirective.prototype.events = function () {
                var _this = this;
                this.watchers.push(this.scope.$watch('vm.onlyCurrent', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.setCasesMap();
                }));
                this.watchers.push(this.scope.$watch('vm.carer', function () {
                    var _a, _b;
                    _this.carerMap = (_b = (_a = _this.carer) === null || _a === void 0 ? void 0 : _a.map(function (x) { return ({ text: x.displayTitle, value: x.objectId }); })) !== null && _b !== void 0 ? _b : [];
                }, true));
                this.watchers.push(this.scope.$watch('vm.form.dateFrom', function (newVal, oldVal) {
                    if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
                        _this.getWv();
                }));
                this.watchers.push(this.scope.$watch('vm.form.flsCaseId', function (newVal, oldVal) {
                    if (newVal !== oldVal)
                        _this.getWv();
                    _this.setCaseDependetForm();
                }));
                this.watchers.push(this.scope.$watch('vm.form.carerId', function (newVal, oldVal) {
                    if (newVal !== oldVal)
                        _this.getWv();
                    _this.getCases();
                }));
                this.watchers.push(this.scope.$watch('vm.form', function (newVal, oldVal) {
                    _this.setCasesMap();
                    if (newVal === oldVal)
                        return;
                    //reset the form
                    _this.id.$setPristine();
                    _this.id.$setUntouched();
                }));
                this.watchers.push(this.scope.$watch('vm.internalMiscontactId', function () {
                    if (!_this.form)
                        return;
                    if (_this.isMiscontactEnabled)
                        if (_this.internalMiscontactId === QMC.Common.Constants.FLS_NO_MISCONTACT)
                            _this.form.miscontactId = QMC.Common.Constants.GUID_EMPTY;
                        else
                            _this.form.miscontactId = _this.internalMiscontactId;
                    else {
                        _this.form.miscontactId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                    }
                }));
                this.watchers.push(this.scope.$watch('vm.isMiscontactEnabled', function () {
                    if (!_this.form)
                        return;
                    if (!_this.isMiscontactEnabled) {
                        _this.internalMiscontactId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                        _this.form.miscontactId = QMC.Common.Constants.FLS_NO_MISCONTACT;
                    }
                    else if (_this.internalMiscontactId === QMC.Common.Constants.FLS_NO_MISCONTACT) {
                        _this.form.miscontactId = QMC.Common.Constants.GUID_EMPTY;
                    }
                }));
            };
            WeekplannerFlsFormDirective.prototype.shouldDisableActivity = function () {
                var _a, _b;
                return this.isGuidEmpty((_a = this.form) === null || _a === void 0 ? void 0 : _a.carerId) || this.isGuidEmpty((_b = this.form) === null || _b === void 0 ? void 0 : _b.flsCaseId) || this.loading.wv;
            };
            WeekplannerFlsFormDirective.prototype.isGuidEmpty = function (guid) {
                return !guid || guid === QMC.Common.Constants.GUID_EMPTY;
            };
            WeekplannerFlsFormDirective.prototype.getWv = function () {
                var _this = this;
                return new Promise(function (resolve) {
                    if (_this.shouldDisableActivity()) {
                        resolve();
                        return;
                    }
                    _this.loading.wv = true;
                    _this.flsService.getFlsDocumentationWvModel([_this.form.flsCaseId], _this.form.documentationId, [_this.form.carerId], _this.form.dateFrom)
                        .then(function (data) {
                        _this.wvMaps = {
                            activity: data[0].documentationCarerWvModel.activityWv.map(function (x) { return ({ text: x.name, value: x.objectId }); }),
                            careType: data[0].documentationCarerWvModel.careTypeWv.map(function (x) { return ({ text: x.name, value: x.objectId }); }),
                            contactType: data[0].documentationCarerWvModel.contactTypeWv.map(function (x) { return ({ text: x.name, value: x.objectId }); }),
                            miscontact: data[0].documentationCarerWvModel.miscontactWv.map(function (x) { return ({ text: x.name, value: x.objectId }); })
                        };
                    })
                        .catch(function () { return _this.wvMaps = { activity: [], careType: [], contactType: [], miscontact: [] }; })
                        .finally(function () {
                        _this.loading.wv = false;
                        _this.applyDefaultWv();
                        _this.setCaseDependetForm();
                        resolve();
                    });
                });
            };
            WeekplannerFlsFormDirective.prototype.applyDefaultWv = function () {
                var _this = this;
                var _a, _b, _c, _d, _e, _f, _g;
                if (this.isGuidEmpty((_a = this.form) === null || _a === void 0 ? void 0 : _a.objectId)) { // do not automatically alter persisted data
                    if (this.isGuidEmpty(this.form.activityTypeId))
                        this.form.activityTypeId = this.defaultActivities.activity;
                    if (this.isGuidEmpty(this.form.careTypeId))
                        this.form.careTypeId = this.defaultActivities.careType;
                    if (this.isGuidEmpty(this.form.contactTypeId))
                        this.form.contactTypeId = this.defaultActivities.contactType;
                    this.form.activityTypeId = ((_c = (_b = this.wvMaps) === null || _b === void 0 ? void 0 : _b.activity) === null || _c === void 0 ? void 0 : _c.some(function (x) { return x.value === _this.form.activityTypeId; })) ? this.form.activityTypeId : QMC.Common.Constants.DEFAULT_ACTIVITY_ID;
                    this.form.careTypeId = ((_e = (_d = this.wvMaps) === null || _d === void 0 ? void 0 : _d.careType) === null || _e === void 0 ? void 0 : _e.some(function (x) { return x.value === _this.form.careTypeId; })) ? this.form.careTypeId : QMC.Common.Constants.GUID_EMPTY;
                    this.form.contactTypeId = ((_g = (_f = this.wvMaps) === null || _f === void 0 ? void 0 : _f.contactType) === null || _g === void 0 ? void 0 : _g.some(function (x) { return x.value === _this.form.contactTypeId; })) ? this.form.contactTypeId : QMC.Common.Constants.GUID_EMPTY;
                }
                this.$qui.scopeApply(this.scope);
            };
            WeekplannerFlsFormDirective.prototype.areRequiredFieldsOkay = function () {
                var _a, _b;
                var isMiscontactValid = !this.isMiscontactEnabled || !this.isGuidEmpty(this.internalMiscontactId);
                return isMiscontactValid && !this.isGuidEmpty((_a = this.form) === null || _a === void 0 ? void 0 : _a.carerId) && !this.isGuidEmpty((_b = this.form) === null || _b === void 0 ? void 0 : _b.flsCaseId);
            };
            return WeekplannerFlsFormDirective;
        }());
        angular.module('QMC.Fachleistung').component('qmWeekplannerFlsForm', {
            templateUrl: './fls/WeekplannerFlsForm',
            controller: ['$scope', '$qui', 'FachleistungService', 'UserService', WeekplannerFlsFormDirective],
            controllerAs: 'vm',
            bindings: {
                onlyCurrent: '=',
                carer: '=',
                form: '=?',
                isValid: '=?',
                setForm: '=?',
            }
        });
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsSignatureListController = /** @class */ (function () {
            /**
             * QMC.Fachleistung.SignatureController
             * @constructor
             * @param fachleistungsService
             * @param $qui
             * @param $stateParams
             * @param klientService
             * @param $state
             * @param lng
             */
            function FlsSignatureListController($location, $scope, fachleistungsService, $qui, $stateParams, klientService, $state, $timeout, userService, lng, permissionService) {
                var _this = this;
                this.$location = $location;
                this.$scope = $scope;
                this.fachleistungsService = fachleistungsService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.klientService = klientService;
                this.$state = $state;
                this.$timeout = $timeout;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.sliderSizeCacheName = 'SigSliderSizes';
                this.ui = new QMC.Fachleistung.UserInterface();
                this.allowTableExport = false;
                this.filterSearchText = "";
                this.signatureMode = "single";
                this.defaultSigningPerson = QMC.Common.UserSettingConstantsAndDefaults.DEFAULTSIGNINGPERSON;
                this.defaultSigningReason = QMC.Common.UserSettingConstantsAndDefaults.DEFAULTSIGNINGREASON;
                this.defaultSigningReasonText = "";
                this.reasonNotMandatory = false;
                this.allFlsChecked = false;
                this.blockModal = false;
                this.promptOptionsOneMore = {
                    title: "Fachleistungen",
                    yesNo: true,
                    icon: "qm-icon-clock",
                    text: this.lng.translate(20016136, 'Wollen Sie weitere Fachleistungen für den Klienten erfassen?'),
                };
                this.signingPersonClientId = QMC.Common.Constants.SIGNATURE_SIGNING_PERSON_CLIENT;
                this.maxTargetWidth = 600;
                this.maxPossibleWidth = 300;
                this.sigHeight = 150;
                this.sigWidth = 300;
                this.signatureFilterCacheName = "SignatureFilter;";
                this.signatureOnlyCurrentCases = "SignatureOnlyCurrentCases";
                $qui.init($qui.getSectionColor($location.path()), function () {
                    // signatureModal
                    $('#signatureModal').on('hidden.bs.modal', function () {
                        $("#clear-signature").click();
                    });
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.ui.signatureTable.data = [];
                //ObjectType: FlsSignatur
                permissionService.getPermissionsByObjectTypes([230009, 230000]).then(function (data) {
                    _this.delete = data[0].delete && data[0].moduleAccess;
                    _this.new = data[0].new && data[0].moduleAccess;
                    _this.modify = data[0].modify && data[0].moduleAccess;
                    _this.allowTableExport = data[1].print;
                });
                if (document.getElementById("permissions").getAttribute("signature").toLocaleLowerCase() !== "true") {
                    this.forbidden = true;
                    return;
                }
                this.filter = {
                    dateFrom: moment().startOf('month').toDate(),
                    dateTo: moment().endOf('month').toDate(),
                    onlyOwn: false,
                    onlyCurrentCases: false
                };
                //get Filter Cache
                this.filter.onlyOwn = JSON.parse(localStorage.getItem(this.signatureFilterCacheName));
                this.filter.onlyCurrentCases = JSON.parse(localStorage.getItem(this.signatureOnlyCurrentCases));
                this.$qui.getTableAutoload(this.userService).then(function (ltd) {
                    _this.shouldLoadTableData = ltd;
                    _this.userService.getUserSettings(["FLS.SIGNATURE.BLOCK", "FLS.SIGNATURE.HIDEREPORTS", "FLS.SHOWMONTHFILTER", "FLS.MINUTESTOSIGN"]).then(function (data) {
                        _this.blockModal = (data[0].value.toLowerCase() === "true");
                        if (_this.blockModal) {
                            $("#signatureModal").on('shown.bs.modal', function () {
                                $('div.modal-backdrop').css('opacity', 1);
                            });
                        }
                        _this.ui.signatureHideReports = data[1].value.toLowerCase() === "true";
                        _this.ui.showMonthFilter = data[2].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS : data[2].value.toLowerCase() === "true";
                        _this.minutesToSign = data[3].value === "" ? -1 : parseFloat(data[3].value);
                        // when we are in detailmode we need to load the list to allow direct signature
                        if (_this.shouldLoadTableData || _this.$state.current.name === "signaturedetail") {
                            _this.getData();
                        }
                        _this.$qui.scopeApply(_this.$scope);
                    });
                });
                this.userService.getUserSettings(["FLS.SIGNATURE.DEFAULTSIGNINGPERSON", "FLS.SIGNATURE.DEFAULTSIGNINGREASON", "FLS.SIGNATURE.DEFAULTSIGNINGREASONTEXT",
                    "FLS.SIGNATURE.REASONNOTMANDATORY"], false).then(function (data) {
                    if (data[0].value !== "")
                        _this.defaultSigningPerson = data[0].value;
                    if (data[1].value !== "")
                        _this.defaultSigningReason = data[1].value;
                    _this.defaultSigningReasonText = data[2].value;
                    _this.reasonNotMandatory = data[3].value.toLowerCase() === 'true';
                });
                this.cards = false;
                if (QMC.Common.Constants.IS_MOBILE)
                    this.cards = true;
                this.$scope.$watch('vm.user', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    if (_this.user === _this.signingPersonClientId) {
                        _this.reasonWv = QMC.Common.Constants.GUID_EMPTY;
                        _this.notice = '';
                        return;
                    }
                    if (_this.user === _this.defaultSigningPerson) {
                        _this.reasonWv = _this.defaultSigningReason;
                    }
                });
                this.$scope.$watch('vm.reasonWv', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    if (_this.reasonWv === _this.defaultSigningReason && _this.user !== _this.signingPersonClientId) {
                        _this.notice = _this.defaultSigningReasonText;
                    }
                });
                this.$scope.$watch('vm.selectedMultiSignClient', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    _this.allFlsChecked = false;
                    _this.item = null;
                });
                this.$scope.$watch('vm.sigWidth', function (newValue, oldValue) {
                    if (newValue !== oldValue && newValue === 300 && (oldValue === _this.maxTargetWidth || oldValue === _this.maxPossibleWidth))
                        _this.setSigWidth(_this.getSigSliderCacheWidth());
                });
                this.$scope.$watch('vm.allFlsChecked', function () {
                    if (!_this.multiSignableList || !_this.multiSignableList[_this.selectedMultiSignClient])
                        return;
                    for (var _i = 0, _a = _this.multiSignableList[_this.selectedMultiSignClient]; _i < _a.length; _i++) {
                        var element = _a[_i];
                        element.isChecked = _this.allFlsChecked;
                    }
                    _this.isSomethingChecked(_this.multiSignableList);
                });
                this.sigResizeWatcher();
            }
            FlsSignatureListController.prototype.sigResizeWatcher = function () {
                var _this = this;
                if (this.maxPossibleWidth !== $('#sig-pad').parent().width())
                    this.setSigWidth(this.getSigSliderCacheWidth());
                if (this.$location.path().indexOf("signature") > 0)
                    setTimeout(function () { _this.sigResizeWatcher(); }, 1000);
            };
            /////////////// DISPLAY LOGIC ///////////////
            FlsSignatureListController.prototype.setSigSliderSizeCache = function () {
                if (this.maxPossibleWidth <= 0 || this.sigWidth === this.maxTargetWidth || this.sigWidth === 300)
                    return;
                var cache = JSON.parse(localStorage.getItem(this.sliderSizeCacheName));
                if (!cache)
                    cache = [];
                for (var _i = 0, cache_1 = cache; _i < cache_1.length; _i++) {
                    var element = cache_1[_i];
                    if (element.possibleWidth === this.maxPossibleWidth) {
                        element.width = this.sigWidth;
                        localStorage.setItem(this.sliderSizeCacheName, JSON.stringify(cache));
                        return;
                    }
                }
                cache.push({
                    possibleWidth: this.maxPossibleWidth,
                    width: this.sigWidth,
                });
                localStorage.setItem(this.sliderSizeCacheName, JSON.stringify(cache));
            };
            FlsSignatureListController.prototype.getSigSliderCacheWidth = function () {
                var cache = JSON.parse(localStorage.getItem(this.sliderSizeCacheName));
                if (!cache)
                    cache = [];
                for (var _i = 0, cache_2 = cache; _i < cache_2.length; _i++) {
                    var element = cache_2[_i];
                    if (element.possibleWidth === this.maxPossibleWidth) {
                        return element.width;
                    }
                }
                return this.maxTargetWidth;
            };
            FlsSignatureListController.prototype.setSigWidth = function (target) {
                this.maxPossibleWidth = $('#sig-pad').parent().width();
                this.sigWidth = this.maxPossibleWidth;
                if (this.maxTargetWidth < this.maxPossibleWidth) {
                    if (target)
                        this.sigWidth = target;
                    else
                        this.sigWidth = this.maxTargetWidth;
                }
                this.setSigHeight();
            };
            FlsSignatureListController.prototype.setSigHeight = function () {
                this.sigHeight = this.sigWidth / 2;
                this.$qui.scopeApply(this.$scope);
                this.setSigSliderSizeCache();
            };
            FlsSignatureListController.prototype.events = function () {
                var _this = this;
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    _this.getUnsignedList();
                });
            };
            FlsSignatureListController.prototype.toggleShowOnlyOwnCreated = function () {
                localStorage.setItem(this.signatureFilterCacheName, this.filter.onlyOwn);
                this.$qui.scopeApply(this.$scope);
            };
            FlsSignatureListController.prototype.toggleShowOnlyCurrentCases = function () {
                localStorage.setItem(this.signatureOnlyCurrentCases, this.filter.onlyCurrentCases);
                this.$qui.scopeApply(this.$scope);
            };
            FlsSignatureListController.prototype.getData = function () {
                this.getUnsignedList();
                this.getWv();
                this.events();
            };
            /**
             * selectItem
             * @description Set the current item.
             * @param item The item selected by the view
             */
            FlsSignatureListController.prototype.selectItem = function (item) {
                this.user = this.defaultSigningPerson;
                this.reasonWv = this.defaultSigningReason;
                this.notice = this.defaultSigningReasonText;
                this.signatureMode = "single";
                this.allowedToSign = this.checkIfAllowedToSign(item);
                this.item = item;
                if (this.blockModal)
                    $("#signatureModal").modal({ backdrop: 'static', keyboard: false });
                else
                    $("#signatureModal").modal('show');
            };
            /**
             * Checks if enough time has past from the end of a fls to sign it
             * @param item
             */
            FlsSignatureListController.prototype.checkIfAllowedToSign = function (item) {
                if (item) {
                    var endDate = this.$qui.createDateFromString(item.dateToFls);
                    return this.minutesToSign >= 0 ? moment(Date.now()).add(this.minutesToSign, 'm').toDate() > endDate : true;
                }
                if (this.multiSignableList != null) {
                    //no item specified we iterrate through all selected fls'
                    this.allowedToSign = true;
                    for (var _i = 0, _a = this.multiSignableList[this.selectedMultiSignClient]; _i < _a.length; _i++) {
                        var item_1 = _a[_i];
                        var endDate = this.$qui.createDateFromString(item_1.dateToFls);
                        this.allowedToSign = this.allowedToSign && this.minutesToSign >= 0 ? moment(Date.now()).add(this.minutesToSign, 'm').toDate() > endDate : true;
                    }
                }
                return this.allowedToSign;
            };
            /**
             * setPutObject
             * @description Set the putItem with all needed properties
             */
            FlsSignatureListController.prototype.createForm = function () {
                var _a, _b, _c, _d;
                this.form = {
                    flsDocumentationIds: [(_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.flsDocumentationId) !== null && _b !== void 0 ? _b : QMC.Common.Constants.GUID_EMPTY],
                    clientId: (_d = (_c = this.item) === null || _c === void 0 ? void 0 : _c.referenceObjectId) !== null && _d !== void 0 ? _d : QMC.Common.Constants.GUID_EMPTY,
                    signingPersonWvId: this.user,
                    reasonWvId: this.reasonWv,
                    reason: this.notice,
                    signatureBase64String: this.getSignature()
                };
                // if signing person is client, dont save reasonWv or Text DAA-426
                if (this.form.signingPersonWvId === this.signingPersonClientId) {
                    this.form.reasonWvId = QMC.Common.Constants.GUID_EMPTY;
                    this.form.reason = '';
                }
                if (this.signatureMode === "multi") {
                    this.form.flsDocumentationIds = [];
                    for (var _i = 0, _e = this.multiSignableList[this.selectedMultiSignClient]; _i < _e.length; _i++) {
                        var docu = _e[_i];
                        if (docu.isChecked)
                            if (!this.checkIdInFlsDocumentationIds(docu.flsDocumentationId)) {
                                //just a measure against the "Element mit dem gleichen Schlüssel" error
                                this.form.flsDocumentationIds.push(docu.flsDocumentationId);
                            }
                    }
                    this.form.clientId = this.selectedMultiSignClient;
                    this.form.clientFullName = this.getClientName(this.selectedMultiSignClient);
                }
            };
            FlsSignatureListController.prototype.getClientName = function (id) {
                var client = this.ui.signatureTable.data.find(function (x) { return x.clientObjectId === id; });
                return client ? this.$qui.createPersonDisplay(client.clientName, client.clientFirstName) : '';
            };
            FlsSignatureListController.prototype.checkIdInFlsDocumentationIds = function (flsDocumentationId) {
                for (var _i = 0, _a = this.form.flsDocumentationIds; _i < _a.length; _i++) {
                    var docu = _a[_i];
                    if (docu === flsDocumentationId) {
                        return true;
                    }
                }
                return false;
            };
            FlsSignatureListController.prototype.openMultipleSignature = function () {
                var _this = this;
                this.loading = true;
                $('#loading-modal').modal('show');
                this.user = this.defaultSigningPerson;
                this.reasonWv = this.defaultSigningReason;
                this.notice = this.defaultSigningReasonText;
                this.allFlsChecked = false;
                this.selectedMultiSignClient = null;
                this.signatureMode = "multi";
                this.item = {};
                this.multiSignableList = {};
                this.multiSignableClients = [];
                var tmpClients = [];
                this.ui.signatureTable.data.filter(function (docu) { return docu.isMultiSignable && _this.checkIfAllowedToSign(docu); }).forEach(function (docu) {
                    if (_this.multiSignableList[docu.clientObjectId] === (null || undefined))
                        _this.multiSignableList[docu.clientObjectId] = [];
                    docu.isChecked = false;
                    _this.multiSignableList[docu.clientObjectId].push(docu);
                });
                for (var client in this.multiSignableList) {
                    if (this.multiSignableList.hasOwnProperty(client)) {
                        tmpClients.push({ id: client, name: this.multiSignableList[client][0].clientDisplayTitle, value: client, text: this.multiSignableList[client][0].clientDisplayTitle });
                    }
                }
                tmpClients.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                this.loading = false;
                $('#loading-modal').modal('hide');
                if (this.blockModal)
                    $("#signatureModal").modal({ backdrop: 'static', keyboard: false });
                else
                    $("#signatureModal").modal('show');
                setTimeout(function () {
                    _this.multiSignableClients = tmpClients;
                });
            };
            FlsSignatureListController.prototype.isSomethingChecked = function (list) {
                if (list === (null || undefined))
                    return false;
                for (var _i = 0, list_3 = list; _i < list_3.length; _i++) {
                    var element = list_3[_i];
                    if (element.isChecked) {
                        return true;
                    }
                }
                return false;
            };
            FlsSignatureListController.prototype.showReportText = function (docu) {
                docu.isActive = !docu.isActive;
                if (docu.isActive)
                    this.item = docu;
                else
                    this.item = {};
                for (var _i = 0, _a = this.multiSignableList[this.selectedMultiSignClient]; _i < _a.length; _i++) {
                    var client = _a[_i];
                    if (client.objectId !== docu.objectId)
                        client.isActive = false;
                }
            };
            FlsSignatureListController.prototype.closeSignatureModal = function (close, reload) {
                var _this = this;
                if (reload === void 0) { reload = true; }
                this.$state.params.id = "";
                if (close)
                    this.promptOptions = {
                        title: "Signierung",
                        icon: "qm-icon-clipboard_check_edit",
                        text: this.lng.translate(20016166, 'Wollen Sie die Signierung wirklich abbrechen?'),
                    };
                else
                    this.promptOptions = {
                        title: "Signierung",
                        icon: "qm-icon-clipboard_check_edit",
                        text: this.lng.translate(20000232, 'Sie werden zur Listenansicht weitergeleitet.'),
                        yesNo: 'okay'
                    };
                // use timeout to reload to make sure that modal backdrop has gone
                if (this.blockModal) {
                    QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                        if (data) {
                            $("#signatureModal").modal("hide");
                            if (reload)
                                setTimeout(function () {
                                    _this.getUnsignedList();
                                }, 250);
                            _this.showOneMore();
                        }
                    }, '#signPrompt');
                }
                else {
                    $("#signatureModal").modal("hide");
                    if (reload)
                        setTimeout(function () {
                            _this.getUnsignedList();
                            _this.showOneMore();
                        }, 250);
                }
                this.allFlsChecked = false;
            };
            FlsSignatureListController.prototype.showOneMore = function () {
                var _this = this;
                if (this.flsCase && this.flsCase.length > 0 && this.flsCase !== QMC.Common.Constants.GUID_EMPTY) {
                    QMC.Common.Utilities.confirm(this.promptOptionsOneMore, function (data) {
                        if (data) {
                            if (_this.flsCase)
                                _this.$state.go("documentationnew", { flsCaseIds: [_this.flsCase] });
                            setTimeout(function () {
                                $('#prompt').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                            }, 300);
                        }
                    }, '#oneMorePrompt');
                }
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * signatureItem
             * @description Send the signature by fls Id to API
             */
            FlsSignatureListController.prototype.saveSignature = function () {
                var _this = this;
                this.createForm();
                this.closeSignatureModal(false, false);
                this.loading = true;
                this.allFlsChecked = false;
                $('#loading-modal').modal('show');
                this.fachleistungsService.postSignature(this.form).then(function () {
                    _this.$qui.notify({
                        message: _this.lng.translate(20016206, 'Signatur(en) erfolgreich gespeichert.'),
                        title: _this.lng.translate(20016008, 'Signatur'),
                        icon: 'qm-icon-ballpen',
                        status: 'default',
                        timer: 3000,
                        delay: 1000
                    });
                }).finally(function () {
                    _this.$state.params.id = "";
                    _this.getUnsignedList();
                });
            };
            /**
             * getUnsignedList
             * @description Get all list of all unsigned fls documentations from API
             */
            FlsSignatureListController.prototype.getUnsignedList = function () {
                var _this = this;
                this.loading = true;
                this.$qui.functionWaiter("ui.createTable", this);
                this.$qui.scopeApply(this.$scope);
                /* Remove Listener */
                this.fachleistungsService.getUnsignedFlsDocumentationList(-1, 0, this.filter.dateFrom, this.filter.dateTo, this.filter.onlyOwn, '', this.filter.onlyCurrentCases).then(function (data) {
                    _this.unsigned = data;
                    data.items.forEach(function (x) {
                        x.clientDisplayTitle = _this.$qui.createPersonDisplay(x.clientName, x.clientFirstName, x.clientShortCaption, x.clientPersonNr);
                        x.authorDisplayTitle = _this.$qui.createPersonDisplay(x.authorName, x.authorFirstName, x.authorShortCaption, x.authorPersonNr);
                    });
                    _this.ui.signatureTable.data = data.items;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    if (_this.$state.current.name === "signaturedetail") {
                        _this.$timeout(function () {
                            for (var _i = 0, _a = _this.unsigned.items; _i < _a.length; _i++) {
                                var item = _a[_i];
                                if (item.objectId === _this.$state.params.id) {
                                    _this.selectItem(item);
                                    break;
                                }
                            }
                        });
                    }
                    // Do this to know which case was selected when a docu is directly signed
                    var docuId = _this.$stateParams.id;
                    _this.$stateParams.id = '';
                    for (var _i = 0, _a = _this.unsigned.items; _i < _a.length; _i++) {
                        var docu = _a[_i];
                        if (docu.objectId === docuId)
                            _this.flsCase = docu.flsCaseId;
                    }
                    _this.loading = false;
                    $('#loading-modal').modal('hide');
                    _this.$qui.scopeApply(_this.$scope);
                }).catch(function () {
                    _this.ui.signatureTable.data = [];
                });
            };
            /**
             * getWv
             * @description Get the WV list from API
             */
            FlsSignatureListController.prototype.getWv = function () {
                var _this = this;
                this.wvLoad = true;
                this.fachleistungsService.getSignatureWv().then(function (data) {
                    _this.wvLoad = false;
                    _this.wv = data;
                    _this.signingPersons = _this.getSigningPersons();
                    _this.reasonsWvList = _this.getReasons();
                });
            };
            FlsSignatureListController.prototype.getSigningPersons = function () {
                return this.wv.signingPersons.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
            };
            FlsSignatureListController.prototype.getReasons = function () {
                return this.wv.reasons.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
            };
            FlsSignatureListController = __decorate([
                QMC.Controller('QMC.Fachleistung', 'FlsSignatureListController'),
                QMC.Inject('$location', '$scope', 'FachleistungService', '$qui', '$stateParams', 'KlientService', '$state', '$timeout', 'UserService', 'QmcLanguageService', 'QmcPermissionService')
            ], FlsSignatureListController);
            return FlsSignatureListController;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var FlsSummaryController = /** @class */ (function () {
            function FlsSummaryController($location, flsService, userService, $qui, $stateParams, $scope, $state, $sce, permissionService, $timeout, lng, clientService) {
                var _this = this;
                this.$location = $location;
                this.flsService = flsService;
                this.userService = userService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.$sce = $sce;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.lng = lng;
                this.clientService = clientService;
                this.allowExport = false;
                this.referencesMap = [];
                this.maps = {
                    wvlivingAreaList: [],
                    wvmarkingsList: [],
                };
                this.filteredTextBlocks = [];
                this.filterText = "";
                this.caseFilter = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.orderAscending = true;
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.showTime = false;
                // pagination
                this.page = 0;
                this.pageSize = 30;
                this.filterCacheName = 'flsSummaryFilterCache';
                this.groupTags = {
                    client: this.lng.translate(21002000, 'Klient'),
                    personslist: this.lng.translate(20000237, 'Personenliste'),
                    case: this.lng.translate(20016028, 'Fall')
                };
                var previousState = JSON.parse(localStorage.getItem('previousState'));
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                if (document.getElementById("permissions").getAttribute("fachleistung").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module fachleistung");
                    this.forbidden = true;
                    return;
                }
                $qui.cachePrivateContentPermission(permissionService);
                permissionService.getPermissionsByObjectTypes([230000]).then(function (data) {
                    _this.allowExport = data[0].print;
                });
                this.loading = false;
                if (localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_ORDER_ASCENDING) !== null) {
                    this.orderAscending = localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_ORDER_ASCENDING) === "true";
                }
                var filterCache = localStorage.getItem(this.filterCacheName);
                if (filterCache && filterCache.length > 0) {
                    var cache = JSON.parse(filterCache);
                    this.dateFrom = this.$qui.createDateFromString(cache.dateFrom);
                    this.dateTo = this.$qui.createDateFromString(cache.dateTo);
                }
                else {
                    this.dateFrom = moment().startOf('month').toDate();
                    this.dateTo = moment().endOf('month').toDate();
                }
                if (previousState && previousState.controller === 'FlsDocumentationController' && localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH) !== null) {
                    this.lastSearch = JSON.parse(localStorage.getItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH));
                    if (this.lastSearch) {
                        this.dateFrom = this.$qui.createDateFromString(this.lastSearch.dateFrom);
                        this.dateTo = this.$qui.createDateFromString(this.lastSearch.dateTo);
                        this.filterText = this.lastSearch.searchString;
                        localStorage.removeItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH);
                    }
                }
                // datefilter validation and failsafe to defaults:
                if (!(this.dateFrom instanceof Date) || isNaN(this.dateFrom))
                    this.dateFrom = moment().startOf('month').toDate();
                if (!(this.dateTo instanceof Date) || isNaN(this.dateTo))
                    this.dateTo = moment().endOf('month').toDate();
                this.userService.getUserSettings(["SHOWTIMEINSTEADOFDECIMAL", "FLS.SUMMARY.PAGESIZE", QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY]).then(function (data) {
                    _this.showTime = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : data[0].value.toLowerCase() === "true";
                    _this.pageSize = data[1].value === "" ? _this.pageSize : parseInt(data[1].value);
                    _this.caseFilter = data[2].value === '' ? _this.caseFilter : JSON.parse(data[2].value);
                    _this.getCases();
                });
                this.getClients();
            }
            /////////////// DISPLAY LOGIC ///////////////
            FlsSummaryController.prototype.formatTimeString = function (durationInHours) {
                if (this.showTime) {
                    var conv = this.$qui.convertDec(durationInHours);
                    var minutes = conv[1].toString();
                    if (conv[1] < 10)
                        minutes = "0" + minutes;
                    return conv[0] + ":" + minutes;
                }
                else {
                    return durationInHours.toFixed(2).toString().replace('.', ',');
                }
            };
            /**
             * initForm
             * @description Init the form with default values
             */
            FlsSummaryController.prototype.init = function () {
                var _this = this;
                this.$scope.$watch('vm.page', function (newValue, oldValue) {
                    if (newValue === oldValue || _this.dontTriggerPageChange)
                        return;
                    _this.getData(false);
                });
                this.$qui.getTableAutoload(this.userService).then(function (ltd) {
                    _this.shouldLoadTableData = ltd;
                    if (_this.shouldLoadTableData) {
                        _this.$scope.$watch('vm.selectedReferenceId', function (newValue, oldValue) {
                            if (newValue === oldValue)
                                return;
                            _this.geLivingAreaWvList();
                            _this.getData();
                        });
                        _this.$scope.$watch('vm.livingAreaIds', function (newValue, oldValue) {
                            if (newValue === oldValue)
                                return;
                            _this.getData();
                        });
                        _this.$scope.$watch('vm.markingIds', function (newValue, oldValue) {
                            if (newValue === oldValue)
                                return;
                            _this.getData();
                        });
                        _this.$scope.$watch('vm.dateFrom', function (newValue, oldValue) {
                            if (newValue === oldValue)
                                return;
                            if (_this.dateFrom > _this.dateTo)
                                _this.dateTo = _this.dateFrom;
                            _this.getData();
                        });
                        _this.$scope.$watch('vm.dateTo', function (newValue, oldValue) {
                            if (newValue === oldValue)
                                return;
                            if (_this.dateTo < _this.dateFrom)
                                _this.dateFrom = _this.dateTo;
                            _this.getData();
                        });
                        _this.$scope.$watch('vm.filterText', function (newValue, oldValue) {
                            if (newValue === oldValue)
                                return;
                            var lastValue = _this.filterText;
                            setTimeout(function () {
                                if (_this.filterText === lastValue) {
                                    _this.getData();
                                }
                            }, 500);
                        });
                        _this.getData();
                    }
                });
            };
            /**
             * currentFilter
             * @description Filter the content by entry.
             * @param entry The entry entered in the View
             */
            FlsSummaryController.prototype.currentfilter = function (entry) {
                var filterActive = $('#filterActive').val();
                console.log(entry, filterActive, entry.isCurrent);
                if (filterActive === 'true')
                    return entry.isCurrent;
                else
                    return true;
            };
            FlsSummaryController.prototype.toggleShowCurrentOnly = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.referencesMap = this.createReferencesMap();
                                this.$qui.scopeApply(this.$scope);
                                return [4 /*yield*/, this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: JSON.stringify(this.caseFilter) }] })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            FlsSummaryController.prototype.toggleOrderAscending = function () {
                localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_ORDER_ASCENDING, this.orderAscending.toString());
                if (!this.shouldLoadTableData)
                    return;
                console.log('####: order changed', this.orderAscending);
                this.getData();
            };
            FlsSummaryController.prototype.stripHtml = function (str) {
                var temp = document.createElement('DIV');
                temp.innerHTML = str;
                return temp.textContent.trim() || temp.innerText.trim();
            };
            FlsSummaryController.prototype.openDocu = function (id) {
                this.loading = true;
                localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_SUMMARY_LAST_SEARCH, JSON.stringify({
                    caseId: this.selectedReferenceId,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    searchString: this.filterText,
                    scrollPos: id
                }));
                this.$qui.scopeApply(this.$scope);
                localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                    state: this.$state.$current.name,
                    params: {}
                }));
                this.$state.go("documentationdetail", { id: id });
            };
            FlsSummaryController.prototype.changePage = function (newPage) {
                this.page = newPage;
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * getCases
             * @description Get the aviable fls cases from API
             */
            FlsSummaryController.prototype.getCases = function () {
                var _this = this;
                this.loading = true;
                this.flsService.getCasesListByViewPermission(false).then(function (data) {
                    _this.allCases = data;
                    _this.referencesMap = _this.createReferencesMap();
                    _this.loading = false;
                    if (_this.lastSearch) {
                        _this.selectedReferenceId = _this.lastSearch.caseId;
                    }
                    var filterCache = localStorage.getItem(_this.filterCacheName);
                    if (filterCache && filterCache.length > 0) {
                        var cache_3 = JSON.parse(filterCache);
                        if (_this.referencesMap.some(function (x) { return x.value === cache_3.caseId; }))
                            _this.selectedReferenceId = cache_3.caseId;
                    }
                    _this.geLivingAreaWvList();
                    _this.$qui.scopeApply(_this.$scope);
                    _this.init();
                });
            };
            FlsSummaryController.prototype.getClients = function () {
                var _this = this;
                Promise.all([this.clientService.getMinimalClientList(), this.clientService.getAllPersonLists()]).then(function (_a) {
                    var data = _a[0], datapl = _a[1];
                    _this.clients = data;
                    _this.personlists = datapl;
                    _this.referencesMap = _this.createReferencesMap();
                    _this.$qui.scopeApply(_this.$scope);
                });
            };
            FlsSummaryController.prototype.createReferencesMap = function () {
                var _this = this;
                var _a, _b, _c, _d;
                var cases = ((_b = (_a = this.allCases) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x.isCurrent || !_this.caseFilter.onlyCurrentCases; })) !== null && _b !== void 0 ? _b : []).map(function (x) { return (__assign(__assign({}, _this.$qui.createCaseDisplayObject(x)), { group: _this.groupTags.case })); });
                var clients = ((_c = this.clients) !== null && _c !== void 0 ? _c : []).map(function (x) { return ({ text: _this.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.personNumber), value: x.id, group: _this.groupTags.client }); });
                var lists = ((_d = this.personlists) !== null && _d !== void 0 ? _d : []).map(function (x) { return ({ text: x.name, value: x.objectId, group: _this.groupTags.personslist }); });
                return __spreadArrays(cases, clients, lists);
            };
            FlsSummaryController.prototype.geLivingAreaWvList = function () {
                var _this = this;
                this.maps.wvlivingAreaList = [];
                this.maps.wvmarkingsList = [];
                this.flsService.getFlsDocumentationWvModel([this.selectedReferenceId], null, [$('#session').data().personId]).then(function (data) {
                    if (data.length > 0) {
                        _this.maps.wvlivingAreaList = data[0].documentationCarerWvModel.livingAreaWvList.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                        _this.maps.wvlivingAreaList.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: _this.lng.translate(20000212, '- Alle -'), isFix: true });
                        _this.maps.wvmarkingsList = data[0].documentationCarerWvModel.markingsWvList.map(function (x) { return ({ value: x.objectId, text: x.name, isFix: x.isFix }); });
                        _this.maps.wvmarkingsList.unshift({ value: QMC.Common.Constants.GUID_EMPTY, text: _this.lng.translate(20000212, '- Alle -'), isFix: true });
                    }
                });
            };
            /**
             * getSummary
             * @description Get the fls summary by activeCaseId and a dateRange from API
             */
            FlsSummaryController.prototype.getData = function (resetPage) {
                var _this = this;
                if (resetPage === void 0) { resetPage = true; }
                if (!this.selectedReferenceId || this.selectedReferenceId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                // cache current filter
                localStorage.setItem(this.filterCacheName, JSON.stringify({
                    caseId: this.selectedReferenceId,
                    dateFrom: this.dateFrom,
                    dateto: this.dateTo
                }));
                this.loading = true;
                this.$qui.scopeApply(this.$scope);
                if (resetPage) {
                    this.dontTriggerPageChange = true;
                    this.page = 0;
                    this.dontTriggerPageChange = false;
                }
                var paginationInfo = {
                    page: this.page,
                    pageSize: this.pageSize
                };
                var filter = null;
                filter = {
                    id: this.selectedReferenceId,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    orderAscending: this.orderAscending,
                    pagination: paginationInfo,
                    listSearch: this.filterText,
                    livingAreaIds: this.livingAreaIds,
                    markingIds: this.markingIds,
                    exclude: undefined,
                    referenceType: this.getTypeForId(this.selectedReferenceId)
                };
                this.flsService.getFlsDocumentationSummary(filter).then(function (data) {
                    _this.summaryItems = data.items;
                    _this.paginationInfo = data.paginationInfo;
                    _this.loading = false;
                    _this.$qui.scopeApply(_this.$scope);
                    _this.$timeout(function () {
                        if (_this.lastSearch) {
                            //document.getElementById('box-' + this.lastSearch.scrollPos).scrollIntoView(true);
                            var element = document.getElementById('box-' + _this.lastSearch.scrollPos);
                            var elementRect = element.getBoundingClientRect();
                            var absoluteElementTop = elementRect.top + window.pageYOffset;
                            var middle = absoluteElementTop - (window.innerHeight / 2);
                            window.scrollTo(0, middle);
                        }
                    });
                });
            };
            FlsSummaryController.prototype.getTypeForId = function (id) {
                var _a;
                var group = (_a = this.referencesMap.find(function (x) { return x.value === id; })) === null || _a === void 0 ? void 0 : _a.group;
                switch (group) {
                    case this.groupTags.personslist:
                        return 190000;
                    case this.groupTags.client:
                        return 140000;
                    case this.groupTags.case:
                    default:
                        return 0;
                }
            };
            FlsSummaryController.prototype.print = function () {
                var areas = document.getElementsByName('printableAreas');
                var winPrint = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
                for (var i = 0; i < areas.length; i++) {
                    winPrint.document.write(areas[i].innerHTML);
                    if (i % 2 == 1)
                        winPrint.document.write("<br /><br />");
                }
                winPrint.document.close();
                winPrint.focus();
                winPrint.print();
                winPrint.close();
            };
            FlsSummaryController = __decorate([
                QMC.Controller('QMC.Fachleistung', 'FlsSummaryController'),
                QMC.Inject('$location', 'FachleistungService', 'UserService', '$qui', '$stateParams', '$scope', '$state', '$sce', 'QmcPermissionService', '$timeout', 'QmcLanguageService', 'KlientService')
            ], FlsSummaryController);
            return FlsSummaryController;
        }());
        Fachleistung.FlsSummaryController = FlsSummaryController;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        var SummaryDirective = /** @class */ (function () {
            function SummaryDirective($location, $qui, $state, $sce, lng, permissionService, flsService) {
                var _this = this;
                this.$location = $location;
                this.$qui = $qui;
                this.$state = $state;
                this.$sce = $sce;
                this.lng = lng;
                this.permissionService = permissionService;
                this.flsService = flsService;
                this.restrict = 'E';
                this.templateUrl = './fls/SummaryDirective/';
                this.scope = {
                    'qmCaseId': '@',
                    'qmOrderAscending': '@',
                    'qmDateFrom': '@',
                    'qmDateTo': '@',
                    'qmPage': '@',
                    'qmPageSize': '@',
                    'qmShowTime': '@',
                    'qmExclude': '@'
                };
                this.showError = false;
                this.link = function (scope) {
                    scope.$sce = _this.$sce;
                    var lastRequest = { case: null, qmDateFrom: null, qmDateTo: null, order: null, page: 0, pageSize: 0 };
                    if (scope.qmPage == (null || undefined))
                        scope.qmPage = 0;
                    if (scope.qmPageSize == (null || undefined))
                        scope.qmPageSize = -1;
                    scope.getSummary = function () {
                        var request = { case: scope.qmCaseId, qmDateFrom: scope.qmDateFrom, qmDateTo: scope.qmDateTo, order: scope.qmOrderAscending, page: scope.qmPage, pageSize: scope.qmPageSize };
                        if (!request.case ||
                            (lastRequest.case == request.case && lastRequest.qmDateFrom == request.qmDateFrom && lastRequest.qmDateTo == request.qmDateTo && request.order == lastRequest.order
                                && lastRequest.page == request.page && lastRequest.pageSize == request.pageSize))
                            return;
                        lastRequest = request;
                        scope.loading = true;
                        _this.flsService.getFlsDocumentationSummary({ id: request.case, dateFrom: request.qmDateFrom, dateTo: request.qmDateTo, orderAscending: !scope.qmOrderAscending, pagination: { page: scope.qmPage, pageSize: scope.qmPageSize }, listSearch: '', livingAreaIds: [], markingIds: [], exclude: scope.qmExclude }).then(function (data) {
                            scope.summaryItems = data.items;
                            scope.qmPaginationInfo = data.paginationInfo;
                            scope.loading = false;
                        });
                    };
                    scope.formatTimeString = function (durationInHours) {
                        if (scope.qmShowTime) {
                            var conv = _this.$qui.convertDec(durationInHours);
                            var minutes = conv[1].toString();
                            if (conv[1] < 10)
                                minutes = "0" + minutes;
                            return conv[0] + ":" + minutes;
                        }
                        else {
                            return durationInHours.toFixed(2).toString().replace('.', ',');
                        }
                    };
                    scope.openDocu = function (id) {
                        localStorage.setItem(QMC.Common.LocalStorageConstants.FLS_PREVIOUS_STATE, JSON.stringify({
                            state: _this.$state.$current.name,
                            params: {}
                        }));
                        _this.$state.go("documentationdetail", { id: id });
                    };
                    scope.stripHtml = function (html) {
                        var temp = document.createElement('DIV');
                        temp.innerHTML = html;
                        return temp.textContent.trim() || temp.innerText.trim();
                    };
                    scope.changePage = function (newPage) {
                        scope.qmPage = newPage;
                    };
                    scope.$watch('qmDateFrom', function () {
                        if (scope.qmDateFrom > scope.qmDateTo)
                            scope.qmDateTo = scope.qmDateFrom;
                        scope.getSummary();
                    });
                    scope.$watch('qmDateTo', function () {
                        if (scope.qmDateTo < scope.qmDateFrom)
                            scope.qmDateFrom = scope.qmDateTo;
                        scope.getSummary();
                    });
                    scope.$watch('qmOrderAscending', function () {
                        scope.getSummary();
                    });
                    scope.$watch('qmPage', function () {
                        scope.getSummary();
                    });
                    scope.$watch('qmPageSize', function () {
                        scope.getSummary();
                    });
                    scope.$watch('qmCaseId', function () {
                        scope.getSummary();
                    });
                    setTimeout(function () {
                        scope.getSummary();
                    }, 500);
                };
            }
            SummaryDirective = __decorate([
                QMC.Directive('QMC.Fachleistung', 'qmFlsSummary', ['$location', '$qui', '$state', '$sce', 'QmcLanguageService', 'QmcPermissionService', 'FachleistungService'])
            ], SummaryDirective);
            return SummaryDirective;
        }());
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Fachleistung;
    (function (Fachleistung) {
        /**
         * Fachleistung UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        var UserInterface = /** @class */ (function (_super) {
            __extends(UserInterface, _super);
            function UserInterface() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.showMonthFilter = true;
                /**
                 * Fachleistung case table
                 * @memberOf UserInterface
                 */
                _this.caseTable = {
                    "filter": {
                        "model": null
                    },
                    "table": {
                        //"Checkbox": {
                        //    "id": "objectId",
                        //    "selected": "isChecked",
                        //    "dType": "Checkbox",
                        //    "events": {
                        //        "onChange": "toggleChecked"
                        //    }
                        //},
                        "Bild": {
                            "label": "clientObjectId",
                            "dType": "Avatar",
                            "name": "name",
                            "forename": "forename",
                            "selectable": "true",
                            "selectableExclude": "isGroup",
                            "events": {
                                "onChange": "toggleChecked"
                            },
                            "selected": "isChecked"
                        },
                        "Name": {
                            "label": "fullName",
                            "dType": "string",
                            "lngTag": "20000072"
                        },
                        "Leistung": {
                            "label": "internalName",
                            "dType": "string",
                            "lngTag": "20000089"
                        },
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "style": "highlightDate",
                            "lngTag": "20000045"
                        },
                        "Aktueller Fall": {
                            "label": "isCurrent",
                            "dType": "Bool",
                            "invisible": "true",
                        },
                        "Id": {
                            "label": "objectId",
                            "dType": "string",
                            "invisible": "true",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-add blue",
                                "href": "#/fls/documentation/new/{{objectId}}",
                                "label": "objectId",
                                "tooltip": "FLS eintragen",
                                "lngTag": "20016064",
                                "dType": "Button",
                            }, {
                                "icon": "qm-icon-clock orange",
                                "click": "toggleContingentModal",
                                "label": "objectId",
                                "dType": "Button",
                                "tooltip": "Kontingent anzeigen",
                                "lngTag": "20016029",
                            }, {
                                "icon": "qm-icon-dude4 green",
                                "href": "#/stammdaten/detail/{{clientObjectId}}/cover/{{clientObjectId}}",
                                "label": "clientObjectId",
                                "dType": "Button",
                                "events": {
                                    "hide": "isGroup",
                                },
                                "tooltip": "Klient Stammdaten",
                                "lngTag": "21002052",
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!comment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }],
                    }, "card": {
                        "idProperty": "objectId",
                        "avatar": {
                            "label": "clientObjectId",
                            "dType": "Avatar",
                            "name": "name",
                            "forename": "forename",
                            "selectable": "true",
                            "selectableExclude": "isGroup",
                            "events": {
                                "onChange": "toggleChecked"
                            },
                            "selected": "isChecked"
                        },
                        "text": {
                            "label": ["fullName"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "internalName",
                                "dType": "string",
                                "style": "highlightDate"
                            },
                            {
                                "label": "date",
                                "dType": "string",
                                "style": "highlightDate"
                            }
                        ],
                        "toggle": {
                            "label": "isCurrent"
                        },
                        "buttons": [{
                                "icon": "qm-icon-add blue",
                                "href": "#/fls/documentation/new/{{objectId}}",
                                "label": "objectId",
                                "tooltip": "FLS eintragen",
                                "lngTag": "20016064",
                                "dType": "Button",
                            }, {
                                "icon": "qm-icon-clock orange",
                                "click": "toggleContingentModal",
                                "label": "objectId",
                                "dType": "Button",
                                "tooltip": "Kontingent anzeigen",
                                "lngTag": "20016029",
                            }, {
                                "icon": "qm-icon-dude4 green",
                                "href": "#/stammdaten/detail/{{clientObjectId}}/cover/{{clientObjectId}}",
                                "label": "clientObjectId",
                                "dType": "Button",
                                "hide": "isGroup",
                                "events": {
                                    "hide": "isGroup",
                                },
                                "tooltip": "Klient Stammdaten",
                                "lngTag": "21002052",
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!comment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }],
                    },
                    "data": null,
                };
                /**
                 * Fachleistung documentation list table
                 * @memberOf UserInterface
                 */
                _this.documentationTable = {
                    "config": {
                        "defaultSort": "dateFrom",
                        "sortReverse": "true",
                        "tableRowLink": "#/fls/documentation/{{objectId}}",
                    },
                    "filter": {
                        "model": null,
                    },
                    "table": {
                        "Klient": {
                            "label": "personReference",
                            "dType": "string",
                            "lngTag": "21002000",
                            "style": "style"
                        },
                        "Leistung": {
                            "label": "serviceName",
                            "dType": "string",
                            "lngTag": "20000089",
                            "style": "style"
                        },
                        "Zeitraum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000060",
                            "style": "style"
                        },
                        "Zeitraum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000061",
                            "style": "style"
                        },
                        "Dauer": {
                            "label": "duration",
                            "dType": "Time",
                            "calculate": "true",
                            "lngTag": "20000075",
                            "style": "style"
                        },
                        "Autor": {
                            "label": "authorPerson",
                            "dType": "string",
                            "lngTag": "20000062",
                            "style": "style"
                        },
                        "Erbringer": {
                            "label": "performer",
                            "dType": "string",
                            "lngTag": "20000272",
                            "style": "style"
                        },
                        "Erstellt am": {
                            "label": "createdDate",
                            "dType": "Date",
                            "lngTag": "20000063",
                            "style": "style"
                        },
                        "Signiert": {
                            "label": "isSigned",
                            "dType": "Bool",
                            "invisible": false,
                            "lngTag": "20016105",
                            "style": "style"
                        },
                        "Fahrtdauer": {
                            "label": "drivingDuration",
                            "dType": "Time",
                            "lngTag": "20016153",
                            "calculate": "true",
                            "style": "style"
                        },
                        "Fahrtstrecke": {
                            "label": "drivingDistance",
                            "dType": "Number",
                            "lngTag": "20016154",
                            "calculate": "true",
                            "style": "style"
                        }
                    },
                    "card": {
                        "avatar": {
                            "label": "referenceObjectId",
                            "dType": "Avatar",
                            "name": "personReference",
                            "forename": "personReference",
                            "href": "#/fls/documentation/{{objectId}}",
                        },
                        "text": {
                            "label": "personReference",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "serviceName",
                                "dType": "string",
                            }, {
                                "label": "dateFrom",
                                "dType": "Date",
                                "withTime": "true",
                            }, {
                                "label": "dateTo",
                                "dType": "Date",
                                "withTime": "true",
                            }
                        ],
                        "buttons": [{
                                "icon": "qm-icon-eye blue",
                                "href": "#/fls/documentation/{{objectId}}",
                                "label": "objectId",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000065",
                                "permission": "modify",
                            }]
                    },
                    "data": null,
                    "totalSums": {
                        data: null,
                        columns: {
                            "duration": "totalDuration",
                            "drivingDuration": "totalDrivingDuration",
                            "drivingDistance": "totalDrivingDistance"
                        }
                    }
                };
                _this.documentationParticipantsForm = {
                    form: [
                        {
                            label: "Anzahl der Teilnehmer",
                            type: "Number",
                            model: "participantCount",
                            lngTag: 20016086,
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                hideExpression: "!(qmScopeCallback().group.onlyNumberOfParticipants)"
                            }
                        },
                        {
                            type: "Select2",
                            model: "participants",
                            multiple: true,
                            label: "Teilnehmer",
                            lngTag: 20016084,
                            dataSource: "getParticipantsList",
                            style: {
                                class: "col-xs-12"
                            },
                            events: {
                                hideExpression: "qmScopeCallback().group.onlyNumberOfParticipants"
                            }
                        },
                        {
                            type: "Select2",
                            model: "participantEmployees",
                            multiple: true,
                            label: "Mitarbeiter",
                            lngTag: 20000235,
                            dataSource: "getParticipantEmployeesList",
                            style: {
                                class: "col-xs-12"
                            }
                        }
                    ]
                };
                _this.documentationActivityForm = {
                    form: [
                        {
                            label: "...als",
                            placeholder: "Tätigkeit wählen...",
                            lngTag: 20016047,
                            type: "Select",
                            model: "activityWvId",
                            dataSource: "getActivityList",
                            disabled: true,
                            style: {
                                class: "col-xs-12"
                            },
                            events: {
                                hideExpression: "!(qmForm.isActivityFix)"
                            }
                        },
                        {
                            label: "...als",
                            placeholder: "Tätigkeit wählen...",
                            lngTag: 20016047,
                            type: "Select",
                            model: "activityWvId",
                            dataSource: "getActivityList",
                            style: {
                                class: "col-xs-12"
                            },
                            events: {
                                hideExpression: "(qmForm.isActivityFix)"
                            }
                        },
                        {
                            label: "Kontaktart",
                            placeholder: "Kontaktart wählen...",
                            lngTag: 20016049,
                            type: "Select",
                            model: "contactTypeWvId",
                            dataSource: "getContactList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Betreuungsart",
                            placeholder: "Betreuungsart wählen...",
                            lngTag: 20016051,
                            type: "Select",
                            model: "careTypeWvId",
                            dataSource: "getCareTypeList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: "Checkbox",
                            model: "isMiscontactEnabled",
                            style: {
                                class: "col-xs-1"
                            },
                            events: {
                                hideExpression: "(qmForm.isMiscontactRequired)"
                            }
                        },
                        {
                            label: "Fehlkontaktart",
                            lngTag: 20016242,
                            type: "Select",
                            model: "miscontactWvId",
                            dataSource: "getMiscontactList",
                            style: {
                                class: "col-xs-11"
                            },
                            events: {
                                hideExpression: "(!qmForm.isMiscontactEnabled)"
                            }
                        },
                        {
                            label: "Fehlkontaktart",
                            lngTag: 20016242,
                            type: "Select",
                            model: "miscontactWvId",
                            disabled: true,
                            dataSource: "getMiscontactList",
                            style: {
                                class: "col-xs-11"
                            },
                            events: {
                                hideExpression: "(qmForm.isMiscontactEnabled)"
                            }
                        }
                    ]
                };
                _this.documentationDrivingCostsForm = {
                    form: [
                        {
                            label: "Stunden",
                            type: "Number",
                            lngTag: 20000219,
                            maxLength: 4,
                            model: "hours",
                            style: {
                                class: "col-md-3 col-xs-6"
                            }
                        },
                        {
                            label: "Minuten",
                            type: "Number",
                            lngTag: 20000247,
                            model: "minutes",
                            style: {
                                class: "col-md-3 col-xs-6"
                            }
                        },
                        {
                            label: "Gefahrene Strecke (in km)",
                            lngTag: 20016056,
                            type: "Number",
                            model: "drivingDistance",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Fahrtkostenart",
                            placeholder: "Fahrtkostenart auswählen",
                            lngTag: 20016087,
                            type: "Select",
                            model: "drivingCostCategoryId",
                            dataSource: "getDrivingCostCategoryList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Abrechnungsart",
                            placeholder: "Abrechnungsart auswählen",
                            lngTag: 20016089,
                            type: "Select",
                            model: "chargingMethodId",
                            dataSource: "getDrivingCostCharingList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Abfahrtsort",
                            placeholder: "Anfahrtsort eingeben..",
                            lngTag: 20016113,
                            type: "Autocomplete",
                            id: "departure",
                            model: "departure",
                            style: {
                                class: "col-xs-12",
                            }
                        },
                        {
                            label: "Anfahrtsort",
                            lngTag: 20016114,
                            placeholder: "Abfahrtsort eingeben..",
                            type: "Autocomplete",
                            model: "destination",
                            id: "destination",
                            style: {
                                class: "col-xs-12"
                            }
                        }
                    ]
                };
                _this.documentationTimeForm = {
                    form: [
                        {
                            placeholder: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis",
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            startDate: null,
                            endDate: null,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo",
                                durationInHours: "durationInHours"
                            },
                            style: {
                                class: "col-xs-12 col-md-12"
                            },
                            required: true,
                            config: {
                                displayDateTo: true,
                                displayTime: true,
                                dateFromNotRequired: false,
                                dateToRequired: true,
                                roundInterval: 0,
                                startRoundType: null,
                                endRoundType: null,
                                disableTime: "disableTime",
                            }
                        },
                        {
                            label: "Dauer",
                            model: "timeString",
                            lngTag: 20000075,
                            type: "String",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-clock-o"
                            },
                            events: {
                                hide: "isManualDuration"
                            }
                        },
                        {
                            label: "Stunden",
                            model: "hours",
                            type: "Number",
                            style: {
                                class: "col-xs-6 col-md-3"
                            },
                            events: {
                                hideExpression: "!(qmForm.isManualDuration)"
                            }
                        },
                        {
                            label: "Minuten",
                            type: "Number",
                            model: "minutes",
                            style: {
                                class: "col-xs-6 col-md-3"
                            },
                            events: {
                                hideExpression: "!(qmForm.isManualDuration)"
                            }
                        },
                        {
                            label: "Manuelle Dauer",
                            type: "Checkbox",
                            lngTag: 20000213,
                            model: "isManualDuration",
                            id: "isManualDuration",
                            style: {
                                class: "col-lg-2 col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "(!qmForm.isManualTimeAllowed || !qmForm.isManuelTimeVisible)"
                            }
                        },
                        {
                            label: "Stunden auf ausgewählte Fälle verteilen",
                            lngTag: 20016151,
                            model: "distributeHours",
                            id: "distributeHours",
                            type: "Checkbox",
                            style: {
                                class: "col-lg-4 col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "(qmScopeCallback().flsCaseIds.length < 2 || qmForm.distributeHoursFix)"
                            }
                        },
                        {
                            label: "Aufteilung",
                            lngTag: 20016193,
                            model: "splitString",
                            type: "String",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-info"
                            },
                            events: {
                                hideExpression: "!(qmForm.splitString && qmForm.splitString.length > 0)"
                            }
                        },
                    ]
                };
                /**
                 * Facheleistung signature list table
                 * @memberOf UserInterface
                 */
                _this.signatureTable = {
                    "config": {
                        "defaultSort": "dateFromFls",
                        "sortReverse": "true",
                        "events": {
                            "click": "selectItem",
                        }
                    },
                    "filter": {
                        "model": null
                    },
                    "table": {
                        "Klient": {
                            "label": "clientDisplayTitle",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Fall": {
                            "label": "flsCaseName",
                            "dType": "string",
                            "lngTag": "20016028"
                        },
                        "Zeitraum von": {
                            "label": "dateFromFls",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000060"
                        },
                        "Zeitraum bis": {
                            "label": "dateToFls",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000061"
                        },
                        "Autor": {
                            "label": "authorDisplayTitle",
                            "dType": "string",
                            "lngTag": "20000062"
                        },
                        "Erstellt am": {
                            "label": "createdDate",
                            "dType": "Date",
                            "lngTag": "20000063"
                        },
                        "Signierungsart": {
                            "label": "signingType",
                            "dType": "string",
                            "lngTag": "20016062"
                        },
                    },
                    "card": {
                        "avatar": {
                            //"label": "referenceObjectId",
                            //"dType": "Avatar",
                            "icon": "qm-icon-print_layout_single",
                            "name": "clientName",
                            "forename": "clientFirstName"
                        },
                        "text": {
                            "label": ["clientDisplayTitle"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "reportTitle",
                                "dType": "string"
                            },
                        ],
                        "buttons": {
                            "icon": "qm-icon-ballpen blue",
                            "click": "selectItem",
                            "label": "data",
                            "tooltip": "Signieren",
                            "lngTag": "20016063",
                            "dType": "Button",
                            "permission": "new"
                        }
                    },
                    "data": null,
                };
                _this.rawDocuTable = {
                    "config": {
                        "tableRowLink": "#/fls/documentation/{{objectId}}",
                    },
                    "table": {
                        "Klient": {
                            "label": "clientName",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Leistung": {
                            "label": "caseName",
                            "dType": "string",
                            "lngTag": "20000089"
                        },
                        "Zeitraum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000060"
                        },
                        "Zeitraum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000061"
                        },
                        "Autor": {
                            "label": "authorName",
                            "dType": "Date",
                            "lngTag": "20000062"
                        },
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-clipboard"
                        },
                        "text": {
                            "label": ["clientName"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "caseName",
                                "dType": "string"
                            },
                            {
                                "label": "dateFrom",
                                "dType": "Date"
                            },
                            {
                                "label": "dateTo",
                                "dType": "Date"
                            },
                        ],
                        "buttons": {
                            "icon": "qm-icon-ballpen blue",
                            "label": "data",
                            "href": "#/fls/documentation/{{objectId}}",
                            "tooltip": "Dokumentation ansehen",
                            "dType": "Button",
                            "permission": "new"
                        }
                    },
                    "data": null,
                };
                _this.planedDocuTable = {
                    "config": {
                        "events": {
                            "click": "writeFlsObjectToLocalStorage"
                        }
                    },
                    "table": {
                        "Bezeichnung": {
                            "label": "reportTitle",
                            "dType": "string",
                            "lngTag": "20000053"
                        },
                        "Klient": {
                            "label": "referencePerson",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Zeitraum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000060"
                        },
                        "Zeitraum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000061"
                        },
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-clipboard_empty"
                        },
                        "text": {
                            "label": ["reportTitle"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "referencePerson",
                                "dType": "string"
                            },
                            {
                                "label": "dateFrom",
                                "dType": "Date"
                            },
                            {
                                "label": "dateTo",
                                "dType": "Date"
                            },
                        ],
                        "buttons": {
                            "icon": "qm-icon-ballpen blue",
                            "label": "data",
                            "click": "writeFlsObjectToLocalStorage",
                            "href": "#/fls/documentation/new/{{flsCaseId}}?plannedDocumentationId={{objectId}}",
                            "tooltip": "Dokumentation ansehen",
                            "dType": "Button",
                            "permission": "new"
                        }
                    },
                    "data": null,
                };
                return _this;
            }
            /**
             * Create a new Guid
             *
             * @private
             * @returns {Guid}
             *
             * @memberof UserInterface
             */
            UserInterface.prototype.getNewGuid = function () {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            };
            /**
             * Convert a decimal to hours and minutes
             * example 1.5 = 1 hour 30 minutes
             * @param {number} dec
             * @returns {number[]}
             *
             * @memberof UserInterface
             */
            //public convertDec(dec: number): number[] {
            //    if (isNaN(dec)) return [0, 0];
            //    const hours: number = Math.floor(Math.abs(dec));
            //    const minutes: number = Math.floor(Math.abs(dec) * 60 % 60);
            //    return [hours, minutes];
            //}
            UserInterface.prototype.convertHours = function (hours, minutes) {
                if (isNaN(minutes))
                    minutes = parseInt(minutes);
                if (isNaN(hours))
                    hours = parseInt(hours);
                if (isNaN(hours) || isNaN(minutes))
                    return 0;
                return moment.duration(hours + ":" + minutes).asHours();
            };
            /**
             * format the addreses to a readable format
             *
             * @param {Klient.IAddressByTypeListItem[]} data
             * @returns {*}
             *
             * @memberof UserInterface
             */
            UserInterface.prototype.formatAddresses = function (data) {
                var addresses = [];
                for (var i = 0; i < data.length; i++) {
                    var displayName = data[i].name;
                    displayName += data[i].forename.length > 0 ? ", " + data[i].forename + " (" + data[i].street : " (" + data[i].street;
                    displayName += data[i].street.length > 0 ? " " + data[i].houseNumber : data[i].houseNumber;
                    displayName += data[i].street.length > 0 || data[i].houseNumber.length > 0 ? ", " + data[i].postCode : data[i].postCode;
                    displayName += data[i].postCode.length > 0 ? " " + data[i].city : data[i].city;
                    displayName += data[i].postCode.length > 0 || data[i].city.length > 0 ? ", " + data[i].country + ")" : data[i].country + ")";
                    var value = data[i].forename;
                    value += data[i].forename.length > 0 ? " " + data[i].name : data[i].name;
                    value += data[i].street.length > 0 || data[i].houseNumber.length > 0 ? ", " + data[i].street + " " + data[i].houseNumber : "";
                    value += data[i].city.length > 0 || data[i].postCode.length > 0 ? ", " + data[i].postCode + " " + data[i].city : "";
                    value += data[i].country.length > 0 ? ", " + data[i].country : "";
                    addresses.push({
                        displayName: displayName,
                        value: value,
                        objectTypeName: data[i].objectTypeName
                    });
                }
                return addresses;
            };
            return UserInterface;
        }(QMC.Common.UserInterface));
        Fachleistung.UserInterface = UserInterface;
    })(Fachleistung = QMC.Fachleistung || (QMC.Fachleistung = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Fachleistung/qmc.fachleistung.js.map
